// 20240516181607
// https://corsproxy.io/?https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=13.0826802&lng=80.2707184&restaurantId=806891

{
    "statusCode": 0,
    "data": {
      "statusMessage": "done successfully",
      "cards": [
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
              "text": "Pizza Hut",
              "headerStyling": {
                "textColor": "text_Highest_Emphasis",
                "textVariant": "header_H3_Black"
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
              "tabs": [
                {
                  "id": "Order Online",
                  "title": "Order Online"
                }
              ]
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
              "info": {
                "id": "806891",
                "name": "Pizza Hut",
                "city": "Chennai",
                "slugs": {
                  "restaurant": "pizza-hut-anna-salai-royapettah",
                  "city": "chennai"
                },
                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                "cloudinaryImageId": "978358a0d0caba4f4555b8e2147b467d",
                "locality": "Anna Salai",
                "areaName": "Triplicane",
                "costForTwo": "35000",
                "costForTwoMessage": "₹350 for two",
                "cuisines": [
                  "Pizzas"
                ],
                "avgRating": 4.3,
                "feeDetails": {
                  "restaurantId": "806891",
                  "fees": [
                    {
                      "name": "TYPE_DISTANCE",
                      "fee": 4100
                    },
                    {
                      "name": "TYPE_TIME"
                    }
                  ],
                  "totalFee": 4100,
                  "title": "Delivery Charge",
                  "amount": "4100",
                  "icon": "v1648635511/Delivery_fee_new_cjxumu",
                  "message": "<b>3.0 kms</b> | ₹41 Delivery fee will apply"
                },
                "parentId": "721",
                "avgRatingString": "4.3",
                "totalRatingsString": "100+ ratings",
                "sla": {
                  "restaurantId": "806891",
                  "deliveryTime": 36,
                  "minDeliveryTime": 35,
                  "maxDeliveryTime": 40,
                  "lastMileTravel": 3,
                  "serviceability": "SERVICEABLE",
                  "stressFactor": 1,
                  "rainMode": "RAIN_MODE_NONE",
                  "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                  "zoneId": 183,
                  "slaString": "35-40 MINS",
                  "lastMileTravelString": "3.0 km",
                  "iconType": "ICON_TYPE_EMPTY"
                },
                "availability": {
                  "nextCloseTime": "2024-05-17 01:00:00",
                  "visibility": true,
                  "opened": true,
                  "restaurantClosedMeta": {
                    
                  }
                },
                "aggregatedDiscountInfo": {
                  "header": "50% off",
                  "shortDescriptionList": [
                    {
                      "meta": "50% off | Use SWIGGY50",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "30% off | Use TRYNEW",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "50% off up to ₹100 | Use code SWIGGY50",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "30% off up to ₹75 | Use code TRYNEW",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "visible": true
                },
                "badges": {
                  
                },
                "slugString": "pizza-hut-anna-salai-royapettah",
                "multiOutlet": true,
                "isOpen": true,
                "labels": [
                  {
                    "title": "Timings",
                    "message": "null"
                  },
                  {
                    "title": "Address",
                    "message": "Old No - 57-62, New No -111, First Floor, Wallajah Road, Anna Salai, Chennai, Tamilnadu - 600002"
                  },
                  {
                    "title": "Cuisines",
                    "message": "Pizzas"
                  }
                ],
                "logo": "rng/md/carousel/production/cztbor82z4wcxssgnaje",
                "totalRatings": 100,
                "aggregatedDiscountInfoV2": {
                  "header": "50% off",
                  "shortDescriptionList": [
                    {
                      "meta": "50% off | Use SWIGGY50",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "30% off | Use TRYNEW",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "50% off up to ₹100 | Use code SWIGGY50",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "30% off up to ₹75 | Use code TRYNEW",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "couponDetailsCta": "View coupon details"
                },
                "type": "F",
                "nudgeBanners": [
                  {
                    "minValue": 125,
                    "maxValue": 179,
                    "priority": 2,
                    "couponCode": "TRYNEW",
                    "discountInfo": {
                      "discountType": "Percentage",
                      "value": 30
                    },
                    "lockedMessage": "Add items worth ₹<amount> to save upto ₹75 | Code TRYNEW",
                    "unlockedMessage": "TRYNEW Coupon Unlocked! Use it to save upto ₹75",
                    "logoCtx": {
                      
                    }
                  }
                ],
                "headerBanner": {
                  "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/806891"
                },
                "expectationNotifiers": [
                  {
                    "text": "<b>3.0 kms</b> | ₹41 Delivery fee will apply",
                    "icon": {
                      "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                    },
                    "popup": {
                      "cta": {
                        
                      }
                    },
                    "type": "DISTANCE_FEE_NON_FOOD_LM",
                    "enrichedText": "<b>3.0 kms</b> | ₹41 Delivery fee will apply",
                    "halfCardPopup": {
                      "halfCardPopupHeader": {
                        
                      }
                    },
                    "trailingIcon": {
                      
                    }
                  }
                ],
                "ratingSlab": "RATING_SLAB_5",
                "orderabilityCommunication": {
                  "title": {
                    
                  },
                  "subTitle": {
                    
                  },
                  "message": {
                    
                  },
                  "customIcon": {
                    
                  }
                },
                "hasBestsellerItems": true,
                "cartOrderabilityNudgeBanner": {
                  "parameters": {
                    
                  },
                  "presentation": {
                    
                  }
                },
                "latLong": "13.0667561,80.2735799",
                "backgroundImageOverlayInfo": {
                  
                }
              },
              "analytics": {
                
              }
            },
            "relevance": {
              "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
              "sectionId": "POP_UP_CROUTON_MENU"
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
              "layout": {
                "rows": 1,
                "columns": 5,
                "horizontalScrollEnabled": true,
                "itemSpacing": 12,
                "lineSpacing": 10,
                "widgetPadding": {
                  
                },
                "containerStyle": {
                  "containerPadding": {
                    "left": 10,
                    "right": 10,
                    "bottom": 16
                  }
                },
                "scrollBar": {
                  
                }
              },
              "id": "offerCollectionWidget_UX4",
              "gridElements": {
                "infoWithStyle": {
                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                  "offers": [
                    {
                      "info": {
                        "header": "50% OFF UPTO ₹100",
                        "offerTagColor": "#E46D47",
                        "offerIds": [
                          "cebd66f5-6aaa-4c7a-80af-0429947646f6"
                        ],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE SWIGGY50",
                        "description": "ABOVE ₹149",
                        "offerType": "offers",
                        "restId": "806891",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "30% OFF UPTO ₹75",
                        "offerTagColor": "#E46D47",
                        "offerIds": [
                          "5187de8e-3b35-47d5-88c1-85bdab73413a"
                        ],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE TRYNEW",
                        "description": "ON SELECT ITEMS",
                        "offerType": "offers",
                        "restId": "806891",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "20% OFF UPTO ₹125",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/4/30/dfb04dfd-509e-4fe2-896f-75e78e398330_Kotak.png",
                        "offerIds": [
                          "686370b9-7afb-435f-a8c9-c6f29cc3ac54"
                        ],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE KOTAK811",
                        "description": "ABOVE ₹499",
                        "offerType": "offers",
                        "restId": "806891",
                        "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/4/30/dfb04dfd-509e-4fe2-896f-75e78e398330_Kotak.png",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "15% OFF UPTO ₹150",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/4/30/b26ac2f6-045e-4633-99a4-74992eedbc68_HSBC.png",
                        "offerIds": [
                          "b5f40c6c-2083-44d1-abd3-e5183f69f018"
                        ],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE HSBCMANIA",
                        "description": "ABOVE ₹499",
                        "offerType": "offers",
                        "restId": "806891",
                        "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/4/30/b26ac2f6-045e-4633-99a4-74992eedbc68_HSBC.png",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹40 OFF",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/5/1/a5e0c2ad-ca03-42e7-b4ce-000d04acc0c5_Simpl.png",
                        "offerIds": [
                          "d5d1fe9e-409a-4691-8866-c37130b7a59a"
                        ],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "NO CODE REQUIRED",
                        "description": "ABOVE ₹499",
                        "offerType": "offers",
                        "restId": "806891",
                        "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/5/1/a5e0c2ad-ca03-42e7-b4ce-000d04acc0c5_Simpl.png",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    }
                  ],
                  "habitMilestoneInfo": {
                    "callout": {
                      
                    }
                  },
                  "loyaltyDiscoverPresentationInfo": {
                    "logoCtx": {
                      
                    }
                  }
                }
              }
            }
          }
        },
        {
          "groupedCard": {
            "cardGroupMap": {
              "REGULAR": {
                "cards": [
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                        "badges": {
                          
                        },
                        "vegOnlyDetails": {
                          "imageId": "AutoVegOnly_qkjowj",
                          "title": "Showing only vegetarian options.",
                          "description": "Tap on the VEG ONLY button to turn off the setting"
                        },
                        "offersFilter": {
                          "attributes": {
                            "displayText": "30% OFF"
                          }
                        },
                        "topRatedFilter": {
                          "attributes": {
                            "displayText": "Ratings 4.0+"
                          }
                        },
                        "kidsCategoryFilter": {
                          "attributes": {
                            "displayText": "Kids Favourites",
                            "tooltip": {
                              "enabled": true,
                              "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                            }
                          }
                        },
                        "vegFilter": {
                          "attributes": {
                            "displayText": "VEG"
                          }
                        },
                        "nonvegFilter": {
                          "attributes": {
                            "displayText": "NONVEG"
                          }
                        }
                      },
                      "relevance": {
                        "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                        "sectionId": "MENU_FILTER_TOGGLE"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                        "title": "Top Picks",
                        "carousel": [
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "1968789",
                            "creativeId": "TopPicks/MeMealFries",
                            "title": "Melts Meal for 1 with Fries - Veg",
                            "description": " ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "135326956",
                                "name": "Melts Meal for 1 with Fries - Veg",
                                "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                "description": "Serves 1 | Choose your favourite Melts & Fries. Customize your satisfaction. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).",
                                "imageId": "77b13d58799f70f670be31e6fe53374e",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344688",
                                      "name": "Choose your Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Veggie BBQ",
                                          "price": 199,
                                          "default": 1,
                                          "id": "135515512",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344690",
                                            "variationId": "135515519"
                                          }
                                        },
                                        {
                                          "name": "Cheezy Cheese Veg",
                                          "price": 219,
                                          "id": "135515514",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344690",
                                            "variationId": "135515519"
                                          }
                                        },
                                        {
                                          "name": "Magical Makhni Paneer",
                                          "price": 299,
                                          "id": "135515517",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344690",
                                            "variationId": "135515519"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344690",
                                      "name": "Side",
                                      "variations": [
                                        {
                                          "name": "Sprinkled Fries",
                                          "price": 60,
                                          "default": 1,
                                          "id": "135515519",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344688",
                                          "variationId": "135515512"
                                        },
                                        {
                                          "groupId": "42344690",
                                          "variationId": "135515519"
                                        }
                                      ],
                                      "price": 25900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344688",
                                          "variationId": "135515514"
                                        },
                                        {
                                          "groupId": "42344690",
                                          "variationId": "135515519"
                                        }
                                      ],
                                      "price": 27900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344688",
                                          "variationId": "135515517"
                                        },
                                        {
                                          "groupId": "42344690",
                                          "variationId": "135515519"
                                        }
                                      ],
                                      "price": 35900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {
                                  
                                },
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "1963858",
                            "creativeId": "TopPicks/CreMeBVeg",
                            "title": "Create your Melts Box of 2 - Veg",
                            "description": " ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "135326957",
                                "name": "Create your Melts Box of 2 - Veg",
                                "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                "description": "Serves 2 | Choose any 2 Melts. Double the flavour, double the satisfaction. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).",
                                "imageId": "e6072e97754de0c6c6030103e0fb50d3",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344700",
                                      "name": "Choose your 1st Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Veggie BBQ",
                                          "price": 189.5,
                                          "default": 1,
                                          "id": "135515557",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344701",
                                            "variationId": "135515565"
                                          }
                                        },
                                        {
                                          "name": "Cheezy Cheese Veg",
                                          "price": 219,
                                          "id": "135515559",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344701",
                                            "variationId": "135515565"
                                          }
                                        },
                                        {
                                          "name": "Magical Makhni Paneer",
                                          "price": 299,
                                          "id": "135515561",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344701",
                                            "variationId": "135515565"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344701",
                                      "name": "Choose your 2nd Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Veggie BBQ",
                                          "price": 189.5,
                                          "default": 1,
                                          "id": "135515565",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Cheezy Cheese Veg",
                                          "price": 219,
                                          "id": "135515567",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Magical Makhni Paneer",
                                          "price": 299,
                                          "id": "135515569",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515557"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515565"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515557"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515567"
                                        }
                                      ],
                                      "price": 40850
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515557"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515569"
                                        }
                                      ],
                                      "price": 48850
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515559"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515565"
                                        }
                                      ],
                                      "price": 40850
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515559"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515567"
                                        }
                                      ],
                                      "price": 43800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515559"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515569"
                                        }
                                      ],
                                      "price": 51800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515561"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515565"
                                        }
                                      ],
                                      "price": 48850
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515561"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515567"
                                        }
                                      ],
                                      "price": 51800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515561"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515569"
                                        }
                                      ],
                                      "price": 59800
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 2"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "1964980",
                            "creativeId": "TopPicks/M3CM1Veg",
                            "title": "Melts 3 Course Meal for 1 - Veg",
                            "description": " ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "135326958",
                                "name": "Melts 3 Course Meal for 1 - Veg",
                                "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                "description": "Serves 1 | The perfect \"Me Time\" meal. Choose your favourite Melts & Fries accompanied with 1 Pepsi PET. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/bfee1036-41ea-40c1-addc-4fcbfb9475ee_37545bf3-2f63-458b-a7bc-fbeeaa7c41bc.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344711",
                                      "name": "Choose your Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Veggie BBQ",
                                          "price": 309,
                                          "default": 1,
                                          "id": "135515601",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Cheezy Cheese Veg",
                                          "price": 329,
                                          "id": "135515604",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Magical Makhni Paneer",
                                          "price": 409,
                                          "id": "135515607",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344711",
                                          "variationId": "135515601"
                                        }
                                      ],
                                      "price": 30900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344711",
                                          "variationId": "135515604"
                                        }
                                      ],
                                      "price": 32900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344711",
                                          "variationId": "135515607"
                                        }
                                      ],
                                      "price": 40900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 30900,
                                "ribbon": {
                                  
                                },
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "2217923",
                            "creativeId": "TopPicks/BBBQVCrispy",
                            "title": "Bold BBQ Veggie Thin n Crispy",
                            "description": " ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "136105859",
                                "name": "Bold BBQ Veggie Thin n Crispy",
                                "category": "New Thin n Crispy Pizzas",
                                "description": "Serves 4 | New Thin n Crispy crust with our signature pan sauce, with BBQ sauce drizzle, topped with mushroom, onion, green capsicum, & red paprika (TnC-266 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "e2f207fda70413b191db2683e4d471df",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 74900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 4"
                                },
                                "ribbon": {
                                  
                                },
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "1965559",
                            "creativeId": "TopPicks/ChPanSizzle",
                            "title": "Chilli Paneer Sizzle",
                            "description": " ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "133116149",
                                "name": "Chilli Paneer Sizzle",
                                "category": "Flavour Fun Range.",
                                "description": "Pizza topped with spiced paneer, a spicy schezwan sauce, juicy tomato, crunchy onion & capsicum and cheesy dressing (298 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "fc2d0de600d6649eaea5ca50d84ab5ec",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37483143",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "117298894",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37483144",
                                            "variationId": "117298895"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37483144",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 179,
                                          "default": 1,
                                          "id": "117298895",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37483143",
                                          "variationId": "117298894"
                                        },
                                        {
                                          "groupId": "37483144",
                                          "variationId": "117298895"
                                        }
                                      ],
                                      "price": 17900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "isBestseller": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "2218733",
                            "creativeId": "TopPicks/DDaKCrispy",
                            "title": "Dhabe Da Keema Thin n Crispy",
                            "description": " ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "136105862",
                                "name": "Dhabe Da Keema Thin n Crispy",
                                "category": "New Thin n Crispy Pizzas",
                                "description": "Serves 4 | New Thin n Crispy crust with dhaba style chicken keema masala, green chiili, crunchy onion with flavourful pan sauce, 100 % mozzarella cheese & a generous drizzle of mint mayo (TnC-290 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/7/74ad756e-dc60-4b84-bdc2-2ddf65fda8f7_b340bd7e-a978-47fb-9fc1-d08ed1ad35b1_compressed",
                                "inStock": 1,
                                "price": 74900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 4"
                                },
                                "ribbon": {
                                  
                                },
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "1966419",
                            "creativeId": "TopPicks/ClaOniCaps",
                            "title": "Classic Onion Capsicum",
                            "description": " ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "132859658",
                                "name": "Classic Onion Capsicum",
                                "category": "Flavour Fun Range.",
                                "description": "Serves 1 | Personal pizza topped with our classic pan sauce, crunchy onion & capsicum and cheesy dressing (307 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "ed6a84173f69cdd4f676e94c2332c5e7",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266321",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400794",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266322",
                                            "variationId": "116400795"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266322",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 99,
                                          "default": 1,
                                          "id": "116400795",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266321",
                                          "variationId": "116400794"
                                        },
                                        {
                                          "groupId": "37266322",
                                          "variationId": "116400795"
                                        }
                                      ],
                                      "price": 9900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692619",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692619",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692619",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692619",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692619",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692619",
                                          "addonId": "112193861"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "133692619",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 9900,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "isBestseller": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "1967808",
                            "creativeId": "TopPicks/ClasCorn",
                            "title": "Classic Corn",
                            "description": " ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "132859656",
                                "name": "Classic Corn",
                                "category": "Flavour Fun Range.",
                                "description": "Serves 1 | Personal pizza topped with our classic pan sauce, sweet corn and cheesy dressing. An all-time favorite (319 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "aed52ab0d028996e060b772f11ff31d8",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266317",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400783",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266318",
                                            "variationId": "116400787"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266318",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 109,
                                          "default": 1,
                                          "id": "116400787",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266317",
                                          "variationId": "116400783"
                                        },
                                        {
                                          "groupId": "37266318",
                                          "variationId": "116400787"
                                        }
                                      ],
                                      "price": 10900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692615",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692615",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692615",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692615",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692615",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692615",
                                          "addonId": "112193861"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "133692615",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 10900,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "isBestseller": true
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Recommended",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135326956",
                                "name": "Melts Meal for 1 with Fries - Veg",
                                "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                "description": "Serves 1 | Choose your favourite Melts & Fries. Customize your satisfaction. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).",
                                "imageId": "77b13d58799f70f670be31e6fe53374e",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344688",
                                      "name": "Choose your Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Veggie BBQ",
                                          "price": 199,
                                          "default": 1,
                                          "id": "135515512",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344690",
                                            "variationId": "135515519"
                                          }
                                        },
                                        {
                                          "name": "Cheezy Cheese Veg",
                                          "price": 219,
                                          "id": "135515514",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344690",
                                            "variationId": "135515519"
                                          }
                                        },
                                        {
                                          "name": "Magical Makhni Paneer",
                                          "price": 299,
                                          "id": "135515517",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344690",
                                            "variationId": "135515519"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344690",
                                      "name": "Side",
                                      "variations": [
                                        {
                                          "name": "Sprinkled Fries",
                                          "price": 60,
                                          "default": 1,
                                          "id": "135515519",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344688",
                                          "variationId": "135515512"
                                        },
                                        {
                                          "groupId": "42344690",
                                          "variationId": "135515519"
                                        }
                                      ],
                                      "price": 25900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344688",
                                          "variationId": "135515514"
                                        },
                                        {
                                          "groupId": "42344690",
                                          "variationId": "135515519"
                                        }
                                      ],
                                      "price": 27900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344688",
                                          "variationId": "135515517"
                                        },
                                        {
                                          "groupId": "42344690",
                                          "variationId": "135515519"
                                        }
                                      ],
                                      "price": 35900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135326959",
                                "name": "Melts Meal for 1 with Fries Non-Veg",
                                "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                "description": "Serves 1 | Choose your favourite Melts & Fries combo. Customize your satisfaction.Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts : (330 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g).",
                                "imageId": "da8429720566b8992d5c1c6bfeecdd2c",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344720",
                                      "name": "Choose your Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Chicken BBQ",
                                          "price": 249,
                                          "default": 1,
                                          "id": "135515671",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344722",
                                            "variationId": "135515682"
                                          }
                                        },
                                        {
                                          "name": "Cheezy Cheese Chicken",
                                          "price": 269,
                                          "id": "135515673",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344722",
                                            "variationId": "135515682"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka & Keema",
                                          "price": 309,
                                          "id": "135515676",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344722",
                                            "variationId": "135515682"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344722",
                                      "name": "Side",
                                      "variations": [
                                        {
                                          "name": "Sprinkled Fries",
                                          "price": 60,
                                          "default": 1,
                                          "id": "135515682",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344720",
                                          "variationId": "135515671"
                                        },
                                        {
                                          "groupId": "42344722",
                                          "variationId": "135515682"
                                        }
                                      ],
                                      "price": 30900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344720",
                                          "variationId": "135515673"
                                        },
                                        {
                                          "groupId": "42344722",
                                          "variationId": "135515682"
                                        }
                                      ],
                                      "price": 32900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344720",
                                          "variationId": "135515676"
                                        },
                                        {
                                          "groupId": "42344722",
                                          "variationId": "135515682"
                                        }
                                      ],
                                      "price": 36900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 30900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135326961",
                                "name": "Melts 3 Course Meal for 1 Non-Veg",
                                "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                "description": "Serves 1 | The perfect \"Me Time\" meal. Choose your favourite Melts & Fries accompanied with 1 Pepsi PET. Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts : (330 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g).",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/26d48552-a554-4b30-93d0-7462c255adc2_cc625cc1-b13b-44d4-a394-969d224b4c6c.jpg_compressed",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344733",
                                      "name": "Choose your Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Chicken BBQ",
                                          "price": 359,
                                          "default": 1,
                                          "id": "135515737",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Cheezy Cheese Chicken",
                                          "price": 379,
                                          "id": "135515738",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Tikka & Keema",
                                          "price": 419,
                                          "id": "135515740",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344733",
                                          "variationId": "135515737"
                                        }
                                      ],
                                      "price": 35900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344733",
                                          "variationId": "135515738"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344733",
                                          "variationId": "135515740"
                                        }
                                      ],
                                      "price": 41900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 35900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135326958",
                                "name": "Melts 3 Course Meal for 1 - Veg",
                                "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                "description": "Serves 1 | The perfect \"Me Time\" meal. Choose your favourite Melts & Fries accompanied with 1 Pepsi PET. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/bfee1036-41ea-40c1-addc-4fcbfb9475ee_37545bf3-2f63-458b-a7bc-fbeeaa7c41bc.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344711",
                                      "name": "Choose your Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Veggie BBQ",
                                          "price": 309,
                                          "default": 1,
                                          "id": "135515601",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Cheezy Cheese Veg",
                                          "price": 329,
                                          "id": "135515604",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Magical Makhni Paneer",
                                          "price": 409,
                                          "id": "135515607",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344711",
                                          "variationId": "135515601"
                                        }
                                      ],
                                      "price": 30900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344711",
                                          "variationId": "135515604"
                                        }
                                      ],
                                      "price": 32900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344711",
                                          "variationId": "135515607"
                                        }
                                      ],
                                      "price": 40900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 30900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135326957",
                                "name": "Create your Melts Box of 2 - Veg",
                                "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                "description": "Serves 2 | Choose any 2 Melts. Double the flavour, double the satisfaction. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).",
                                "imageId": "e6072e97754de0c6c6030103e0fb50d3",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344700",
                                      "name": "Choose your 1st Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Veggie BBQ",
                                          "price": 189.5,
                                          "default": 1,
                                          "id": "135515557",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344701",
                                            "variationId": "135515565"
                                          }
                                        },
                                        {
                                          "name": "Cheezy Cheese Veg",
                                          "price": 219,
                                          "id": "135515559",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344701",
                                            "variationId": "135515565"
                                          }
                                        },
                                        {
                                          "name": "Magical Makhni Paneer",
                                          "price": 299,
                                          "id": "135515561",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344701",
                                            "variationId": "135515565"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344701",
                                      "name": "Choose your 2nd Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Veggie BBQ",
                                          "price": 189.5,
                                          "default": 1,
                                          "id": "135515565",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Cheezy Cheese Veg",
                                          "price": 219,
                                          "id": "135515567",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Magical Makhni Paneer",
                                          "price": 299,
                                          "id": "135515569",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515557"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515565"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515557"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515567"
                                        }
                                      ],
                                      "price": 40850
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515557"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515569"
                                        }
                                      ],
                                      "price": 48850
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515559"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515565"
                                        }
                                      ],
                                      "price": 40850
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515559"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515567"
                                        }
                                      ],
                                      "price": 43800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515559"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515569"
                                        }
                                      ],
                                      "price": 51800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515561"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515565"
                                        }
                                      ],
                                      "price": 48850
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515561"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515567"
                                        }
                                      ],
                                      "price": 51800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344700",
                                          "variationId": "135515561"
                                        },
                                        {
                                          "groupId": "42344701",
                                          "variationId": "135515569"
                                        }
                                      ],
                                      "price": 59800
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 2"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.5",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135326960",
                                "name": "Create your Melts Box of 2 Non-Veg",
                                "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                "description": "Serves 2 | Choose any 2 Melts. Double the flavour, double the satisfaction. Cheezy Cheese Chicken : (268 Kcal/100g), Loaded BBQ Non-Veg : (330 Kcal/100g), Chicken Tikka Keema : (283 Kcal/100g).",
                                "imageId": "e7620274ab99ba415f3e00480020cb48",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344725",
                                      "name": "Choose your 1st Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Chicken BBQ",
                                          "price": 249,
                                          "default": 1,
                                          "id": "135515716",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344726",
                                            "variationId": "135515724"
                                          }
                                        },
                                        {
                                          "name": "Cheezy Cheese Chicken",
                                          "price": 269,
                                          "id": "135515719",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344726",
                                            "variationId": "135515724"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka & Keema",
                                          "price": 309,
                                          "id": "135515721",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344726",
                                            "variationId": "135515724"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344726",
                                      "name": "Choose your 2nd Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Chicken BBQ",
                                          "price": 249,
                                          "default": 1,
                                          "id": "135515724",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Cheezy Cheese Chicken",
                                          "price": 269,
                                          "id": "135515725",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Tikka & Keema",
                                          "price": 309,
                                          "id": "135515727",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344725",
                                          "variationId": "135515716"
                                        },
                                        {
                                          "groupId": "42344726",
                                          "variationId": "135515724"
                                        }
                                      ],
                                      "price": 49800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344725",
                                          "variationId": "135515716"
                                        },
                                        {
                                          "groupId": "42344726",
                                          "variationId": "135515725"
                                        }
                                      ],
                                      "price": 51800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344725",
                                          "variationId": "135515716"
                                        },
                                        {
                                          "groupId": "42344726",
                                          "variationId": "135515727"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344725",
                                          "variationId": "135515719"
                                        },
                                        {
                                          "groupId": "42344726",
                                          "variationId": "135515724"
                                        }
                                      ],
                                      "price": 51800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344725",
                                          "variationId": "135515719"
                                        },
                                        {
                                          "groupId": "42344726",
                                          "variationId": "135515725"
                                        }
                                      ],
                                      "price": 53800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344725",
                                          "variationId": "135515719"
                                        },
                                        {
                                          "groupId": "42344726",
                                          "variationId": "135515727"
                                        }
                                      ],
                                      "price": 57800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344725",
                                          "variationId": "135515721"
                                        },
                                        {
                                          "groupId": "42344726",
                                          "variationId": "135515724"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344725",
                                          "variationId": "135515721"
                                        },
                                        {
                                          "groupId": "42344726",
                                          "variationId": "135515725"
                                        }
                                      ],
                                      "price": 57800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344725",
                                          "variationId": "135515721"
                                        },
                                        {
                                          "groupId": "42344726",
                                          "variationId": "135515727"
                                        }
                                      ],
                                      "price": 61800
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 2"
                                },
                                "defaultPrice": 49800,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135337391",
                                "name": "Cheezy Cheese Chicken & Loaded BBQ Non-Veg Combo",
                                "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                "description": "Serves 1 | Satisfy your non veg cravings with Cheezy Cheese Chicken & Loaded Chicken BBQ Melts. Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts: (330 Kcal/100g).",
                                "imageId": "3779ffaf02380c80f951a1ed2b90c997",
                                "inStock": 1,
                                "price": 48900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135703516",
                                "name": "Cheezy Cheese Veg & Loaded BBQ Veg Combo",
                                "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                "description": "Serves 2 | Double the satisfaction with Cheezy Cheese Veg & Loaded BBQ Veg Melts. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g).",
                                "imageId": "0b816322be7e8731246e9492e4b44b84",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 39900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 2"
                                },
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135337392",
                                "name": "Makhni Paneer & Chicken Tikka Keema Combo",
                                "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                "description": "Serves 2 | Satisfy your desi flavour cravings with Makhni Paneer & Chicken Tikka Keema Melts. Makhni Paneer Melts: (265 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g).",
                                "imageId": "a6c351a9a53ae0c5fa2e5e401b8bf27a",
                                "inStock": 1,
                                "price": 54900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 2"
                                },
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859678",
                                "name": "My Box - Non Veg",
                                "category": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                                "description": "Serves 1 | 1 personal non veg pizza, 2 pc garlic bread & 1 Pepsi PET. For Meals, refer to the nutritional data for individual products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/3330ac68-19aa-4598-a9f9-ac1f538ab52c_e1e7be34-7ff1-475b-a69b-4b99de6a2b09.png",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344507",
                                      "name": "Pizza",
                                      "variations": [
                                        {
                                          "name": "Chicken Sausage",
                                          "price": 212,
                                          "default": 1,
                                          "id": "135514405",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344512",
                                            "variationId": "135514436"
                                          }
                                        },
                                        {
                                          "name": "Sausage & Sweet Corn",
                                          "price": 252,
                                          "id": "135514407",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344512",
                                            "variationId": "135514436"
                                          }
                                        },
                                        {
                                          "name": "Dhabe Da Keema",
                                          "price": 252,
                                          "id": "135514408",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344512",
                                            "variationId": "135514436"
                                          }
                                        },
                                        {
                                          "name": "Sizzling Schezwan Chicken",
                                          "price": 252,
                                          "id": "135514411",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344512",
                                            "variationId": "135514436"
                                          }
                                        },
                                        {
                                          "name": "Murg Malai Chicken",
                                          "price": 272,
                                          "id": "135514413",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344512",
                                            "variationId": "135514436"
                                          }
                                        },
                                        {
                                          "name": "Awesome American Cheesy Chicken",
                                          "price": 272,
                                          "id": "135514416",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344512",
                                            "variationId": "135514436"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka",
                                          "price": 272,
                                          "id": "135514418",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344512",
                                            "variationId": "135514436"
                                          }
                                        },
                                        {
                                          "name": "Chicken Pepperoni",
                                          "price": 272,
                                          "id": "135514421",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344512",
                                            "variationId": "135514436"
                                          }
                                        },
                                        {
                                          "name": "Nawabi Murg Makhni",
                                          "price": 292,
                                          "id": "135514424",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344512",
                                            "variationId": "135514436"
                                          }
                                        },
                                        {
                                          "name": "Chicken Supreme",
                                          "price": 292,
                                          "id": "135514427",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344512",
                                            "variationId": "135514436"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka Supreme",
                                          "price": 292,
                                          "id": "135514430",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344512",
                                            "variationId": "135514436"
                                          }
                                        },
                                        {
                                          "name": "Triple Chicken Feast",
                                          "price": 292,
                                          "id": "135514432",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344512",
                                            "variationId": "135514436"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344512",
                                      "name": "Garlic Bread",
                                      "variations": [
                                        {
                                          "name": "2 Pcs Cheese Garlic Bread",
                                          "price": 70,
                                          "id": "135514434",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344514",
                                            "variationId": "135514439"
                                          }
                                        },
                                        {
                                          "name": "2 Pcs Garlic Bread",
                                          "price": 50,
                                          "default": 1,
                                          "id": "135514436",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344514",
                                            "variationId": "135514439"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344514",
                                      "name": "Beverage",
                                      "variations": [
                                        {
                                          "name": "Pepsi Pet Bottle",
                                          "price": 57,
                                          "default": 1,
                                          "id": "135514439",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514405"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514434"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 33900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514405"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514436"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 31900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514407"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514434"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514407"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514436"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 35900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514408"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514434"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514408"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514436"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 35900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514411"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514434"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514411"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514436"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 35900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514413"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514434"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514413"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514436"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514416"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514434"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514416"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514436"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514418"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514434"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514418"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514436"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514421"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514434"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514421"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514436"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514424"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514434"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 41900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514424"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514436"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514427"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514434"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 41900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514427"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514436"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514430"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514434"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 41900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514430"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514436"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514432"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514434"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 41900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344507",
                                          "variationId": "135514432"
                                        },
                                        {
                                          "groupId": "42344512",
                                          "variationId": "135514436"
                                        },
                                        {
                                          "groupId": "42344514",
                                          "variationId": "135514439"
                                        }
                                      ],
                                      "price": 39900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859680",
                                "name": "My Box - Veg",
                                "category": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                                "description": "Serves 1 | 1 personal veg pizza, 2 pc garlic bread & 1 Pepsi PET ! For Meals, refer to the nutritional data for individual products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/a1efbc7d-6165-4b69-8fe8-e88335921678_0c2d69b5-8aef-4ff2-962c-7c9d75bb84ce.png",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344517",
                                      "name": "Pizza",
                                      "variations": [
                                        {
                                          "name": "Margherita",
                                          "price": 142,
                                          "default": 1,
                                          "id": "135514454",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344523",
                                            "variationId": "135514483"
                                          }
                                        },
                                        {
                                          "name": "Schezwan Margherita",
                                          "price": 142,
                                          "id": "135514456",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344523",
                                            "variationId": "135514483"
                                          }
                                        },
                                        {
                                          "name": "Corn & Cheese",
                                          "price": 192,
                                          "id": "135514457",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344523",
                                            "variationId": "135514483"
                                          }
                                        },
                                        {
                                          "name": "Veggie Feast",
                                          "price": 212,
                                          "id": "135514459",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344523",
                                            "variationId": "135514483"
                                          }
                                        },
                                        {
                                          "name": "Spiced Paneer",
                                          "price": 212,
                                          "id": "135514460",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344523",
                                            "variationId": "135514483"
                                          }
                                        },
                                        {
                                          "name": "Mexican Fiesta",
                                          "price": 232,
                                          "id": "135514462",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344523",
                                            "variationId": "135514483"
                                          }
                                        },
                                        {
                                          "name": "Bold BBQ Veggies",
                                          "price": 232,
                                          "id": "135514464",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344523",
                                            "variationId": "135514483"
                                          }
                                        },
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 232,
                                          "id": "135514466",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344523",
                                            "variationId": "135514483"
                                          }
                                        },
                                        {
                                          "name": "Country Feast",
                                          "price": 232,
                                          "id": "135514468",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344523",
                                            "variationId": "135514483"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Tandoori Veggie",
                                          "price": 252,
                                          "id": "135514469",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344523",
                                            "variationId": "135514483"
                                          }
                                        },
                                        {
                                          "name": "Mazedar Makhni Paneer",
                                          "price": 252,
                                          "id": "135514470",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344523",
                                            "variationId": "135514483"
                                          }
                                        },
                                        {
                                          "name": "Awesome American Cheesy",
                                          "price": 252,
                                          "id": "135514473",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344523",
                                            "variationId": "135514483"
                                          }
                                        },
                                        {
                                          "name": "Veggie Supreme",
                                          "price": 252,
                                          "id": "135514476",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344523",
                                            "variationId": "135514483"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344523",
                                      "name": "Garlic Bread",
                                      "variations": [
                                        {
                                          "name": "2 Pcs Cheese Garlic Bread",
                                          "price": 70,
                                          "id": "135514480",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344525",
                                            "variationId": "135514488"
                                          }
                                        },
                                        {
                                          "name": "2 Pcs Garlic Bread",
                                          "price": 50,
                                          "default": 1,
                                          "id": "135514483",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344525",
                                            "variationId": "135514488"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344525",
                                      "name": "Beverage",
                                      "variations": [
                                        {
                                          "name": "Pepsi Pet Bottle",
                                          "price": 57,
                                          "default": 1,
                                          "id": "135514488",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514454"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514480"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 26900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514454"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514483"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 24900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514456"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514480"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 26900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514456"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514483"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 24900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514457"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514480"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 31900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514457"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514483"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 29900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514459"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514480"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 33900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514459"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514483"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 31900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514460"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514480"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 33900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514460"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514483"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 31900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514462"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514480"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 35900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514462"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514483"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 33900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514464"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514480"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 35900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514464"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514483"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 33900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514466"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514480"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 35900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514466"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514483"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 33900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514468"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514480"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 35900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514468"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514483"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 33900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514469"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514480"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514469"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514483"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 35900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514470"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514480"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514470"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514483"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 35900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514473"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514480"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514473"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514483"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 35900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514476"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514480"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344517",
                                          "variationId": "135514476"
                                        },
                                        {
                                          "groupId": "42344523",
                                          "variationId": "135514483"
                                        },
                                        {
                                          "groupId": "42344525",
                                          "variationId": "135514488"
                                        }
                                      ],
                                      "price": 35900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 24900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859672",
                                "name": "Hut Treat Meal for 2 - Non Veg",
                                "category": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                                "description": "Serves 2 | 1 medium non-veg pizza upto signature, 1 classic bread stix, 1 Pepsi PET. For Meals, refer to the nutritional data for individual products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/fc115b57-9536-4c2d-8876-bcedf630ea7b_b7818aa0-4ccb-4cfa-acb5-df7a9cace4e5.png_compressed",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344462",
                                      "name": "Choose Your Pizza",
                                      "variations": [
                                        {
                                          "name": "Chicken Sausage",
                                          "price": 433,
                                          "default": 1,
                                          "id": "135514147",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344464",
                                            "variationId": "135514175"
                                          }
                                        },
                                        {
                                          "name": "Sausage & Sweet Corn",
                                          "price": 433,
                                          "id": "135514151",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344464",
                                            "variationId": "135514175"
                                          }
                                        },
                                        {
                                          "name": "Dhabe Da Keema",
                                          "price": 433,
                                          "id": "135514154",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344464",
                                            "variationId": "135514175"
                                          }
                                        },
                                        {
                                          "name": "Sizzling Schezwan Chicken",
                                          "price": 433,
                                          "id": "135514159",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344464",
                                            "variationId": "135514175"
                                          }
                                        },
                                        {
                                          "name": "Murg Malai Chicken",
                                          "price": 483,
                                          "id": "135514162",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344464",
                                            "variationId": "135514175"
                                          }
                                        },
                                        {
                                          "name": "Awesome American Cheesy Chicken",
                                          "price": 483,
                                          "id": "135514165",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344464",
                                            "variationId": "135514175"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka",
                                          "price": 483,
                                          "id": "135514168",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344464",
                                            "variationId": "135514175"
                                          }
                                        },
                                        {
                                          "name": "Chicken Pepperoni",
                                          "price": 433,
                                          "id": "135514170",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344464",
                                            "variationId": "135514175"
                                          }
                                        },
                                        {
                                          "name": "Nawabi Murg Makhni",
                                          "price": 483,
                                          "id": "135514171",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344464",
                                            "variationId": "135514175"
                                          }
                                        },
                                        {
                                          "name": "Chicken Supreme",
                                          "price": 483,
                                          "id": "135514172",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344464",
                                            "variationId": "135514175"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka Supreme",
                                          "price": 483,
                                          "id": "135514173",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344464",
                                            "variationId": "135514175"
                                          }
                                        },
                                        {
                                          "name": "Triple Chicken Feast",
                                          "price": 483,
                                          "id": "135514174",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344464",
                                            "variationId": "135514175"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344464",
                                      "name": "Side",
                                      "variations": [
                                        {
                                          "name": "Classic BreadStix",
                                          "price": 99,
                                          "default": 1,
                                          "id": "135514175",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344465",
                                            "variationId": "135514176"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344465",
                                      "name": "Beverage",
                                      "variations": [
                                        {
                                          "name": "Pepsi PET Bottle",
                                          "price": 57,
                                          "default": 1,
                                          "id": "135514176",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344462",
                                          "variationId": "135514147"
                                        },
                                        {
                                          "groupId": "42344464",
                                          "variationId": "135514175"
                                        },
                                        {
                                          "groupId": "42344465",
                                          "variationId": "135514176"
                                        }
                                      ],
                                      "price": 58900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344462",
                                          "variationId": "135514151"
                                        },
                                        {
                                          "groupId": "42344464",
                                          "variationId": "135514175"
                                        },
                                        {
                                          "groupId": "42344465",
                                          "variationId": "135514176"
                                        }
                                      ],
                                      "price": 58900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344462",
                                          "variationId": "135514154"
                                        },
                                        {
                                          "groupId": "42344464",
                                          "variationId": "135514175"
                                        },
                                        {
                                          "groupId": "42344465",
                                          "variationId": "135514176"
                                        }
                                      ],
                                      "price": 58900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344462",
                                          "variationId": "135514159"
                                        },
                                        {
                                          "groupId": "42344464",
                                          "variationId": "135514175"
                                        },
                                        {
                                          "groupId": "42344465",
                                          "variationId": "135514176"
                                        }
                                      ],
                                      "price": 58900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344462",
                                          "variationId": "135514162"
                                        },
                                        {
                                          "groupId": "42344464",
                                          "variationId": "135514175"
                                        },
                                        {
                                          "groupId": "42344465",
                                          "variationId": "135514176"
                                        }
                                      ],
                                      "price": 63900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344462",
                                          "variationId": "135514165"
                                        },
                                        {
                                          "groupId": "42344464",
                                          "variationId": "135514175"
                                        },
                                        {
                                          "groupId": "42344465",
                                          "variationId": "135514176"
                                        }
                                      ],
                                      "price": 63900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344462",
                                          "variationId": "135514168"
                                        },
                                        {
                                          "groupId": "42344464",
                                          "variationId": "135514175"
                                        },
                                        {
                                          "groupId": "42344465",
                                          "variationId": "135514176"
                                        }
                                      ],
                                      "price": 63900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344462",
                                          "variationId": "135514170"
                                        },
                                        {
                                          "groupId": "42344464",
                                          "variationId": "135514175"
                                        },
                                        {
                                          "groupId": "42344465",
                                          "variationId": "135514176"
                                        }
                                      ],
                                      "price": 58900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344462",
                                          "variationId": "135514171"
                                        },
                                        {
                                          "groupId": "42344464",
                                          "variationId": "135514175"
                                        },
                                        {
                                          "groupId": "42344465",
                                          "variationId": "135514176"
                                        }
                                      ],
                                      "price": 63900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344462",
                                          "variationId": "135514172"
                                        },
                                        {
                                          "groupId": "42344464",
                                          "variationId": "135514175"
                                        },
                                        {
                                          "groupId": "42344465",
                                          "variationId": "135514176"
                                        }
                                      ],
                                      "price": 63900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344462",
                                          "variationId": "135514173"
                                        },
                                        {
                                          "groupId": "42344464",
                                          "variationId": "135514175"
                                        },
                                        {
                                          "groupId": "42344465",
                                          "variationId": "135514176"
                                        }
                                      ],
                                      "price": 63900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344462",
                                          "variationId": "135514174"
                                        },
                                        {
                                          "groupId": "42344464",
                                          "variationId": "135514175"
                                        },
                                        {
                                          "groupId": "42344465",
                                          "variationId": "135514176"
                                        }
                                      ],
                                      "price": 63900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 2"
                                },
                                "defaultPrice": 58900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859673",
                                "name": "Hut Treat Meal for 2 - Veg",
                                "category": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                                "description": "Serves 2 | 1 medium veg pizza upto signature, 1 classic bread stix, 1 Pepsi PET. For Meals, refer to the nutritional data for individual products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/9004b4ef-3454-40d3-babb-641082675270_4fd584b6-55b0-4a17-b519-d42e6fff8af9.png",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344471",
                                      "name": "Choose Your Pizza",
                                      "variations": [
                                        {
                                          "name": "Margherita",
                                          "price": 373,
                                          "default": 1,
                                          "id": "135514221",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344474",
                                            "variationId": "135514238"
                                          }
                                        },
                                        {
                                          "name": "Schezwan Margherita",
                                          "price": 373,
                                          "id": "135514224",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344474",
                                            "variationId": "135514238"
                                          }
                                        },
                                        {
                                          "name": "Corn & Cheese",
                                          "price": 373,
                                          "id": "135514226",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344474",
                                            "variationId": "135514238"
                                          }
                                        },
                                        {
                                          "name": "Veggie Feast",
                                          "price": 373,
                                          "id": "135514227",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344474",
                                            "variationId": "135514238"
                                          }
                                        },
                                        {
                                          "name": "Spiced Paneer",
                                          "price": 373,
                                          "id": "135514228",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344474",
                                            "variationId": "135514238"
                                          }
                                        },
                                        {
                                          "name": "Mexican Fiesta",
                                          "price": 433,
                                          "id": "135514229",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344474",
                                            "variationId": "135514238"
                                          }
                                        },
                                        {
                                          "name": "Bold BBQ Veggies",
                                          "price": 433,
                                          "id": "135514230",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344474",
                                            "variationId": "135514238"
                                          }
                                        },
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 433,
                                          "id": "135514231",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344474",
                                            "variationId": "135514238"
                                          }
                                        },
                                        {
                                          "name": "Country Feast",
                                          "price": 433,
                                          "id": "135514232",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344474",
                                            "variationId": "135514238"
                                          }
                                        },
                                        {
                                          "name": "Veggie Supreme",
                                          "price": 433,
                                          "id": "135514235",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344474",
                                            "variationId": "135514238"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344474",
                                      "name": "Side",
                                      "variations": [
                                        {
                                          "name": "Classic BreadStix",
                                          "price": 99,
                                          "default": 1,
                                          "id": "135514238",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344475",
                                            "variationId": "135514239"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344475",
                                      "name": "Beverage",
                                      "variations": [
                                        {
                                          "name": "Pepsi PET Bottle",
                                          "price": 57,
                                          "default": 1,
                                          "id": "135514239",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344471",
                                          "variationId": "135514221"
                                        },
                                        {
                                          "groupId": "42344474",
                                          "variationId": "135514238"
                                        },
                                        {
                                          "groupId": "42344475",
                                          "variationId": "135514239"
                                        }
                                      ],
                                      "price": 52900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344471",
                                          "variationId": "135514224"
                                        },
                                        {
                                          "groupId": "42344474",
                                          "variationId": "135514238"
                                        },
                                        {
                                          "groupId": "42344475",
                                          "variationId": "135514239"
                                        }
                                      ],
                                      "price": 52900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344471",
                                          "variationId": "135514226"
                                        },
                                        {
                                          "groupId": "42344474",
                                          "variationId": "135514238"
                                        },
                                        {
                                          "groupId": "42344475",
                                          "variationId": "135514239"
                                        }
                                      ],
                                      "price": 52900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344471",
                                          "variationId": "135514227"
                                        },
                                        {
                                          "groupId": "42344474",
                                          "variationId": "135514238"
                                        },
                                        {
                                          "groupId": "42344475",
                                          "variationId": "135514239"
                                        }
                                      ],
                                      "price": 52900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344471",
                                          "variationId": "135514228"
                                        },
                                        {
                                          "groupId": "42344474",
                                          "variationId": "135514238"
                                        },
                                        {
                                          "groupId": "42344475",
                                          "variationId": "135514239"
                                        }
                                      ],
                                      "price": 52900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344471",
                                          "variationId": "135514229"
                                        },
                                        {
                                          "groupId": "42344474",
                                          "variationId": "135514238"
                                        },
                                        {
                                          "groupId": "42344475",
                                          "variationId": "135514239"
                                        }
                                      ],
                                      "price": 58900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344471",
                                          "variationId": "135514230"
                                        },
                                        {
                                          "groupId": "42344474",
                                          "variationId": "135514238"
                                        },
                                        {
                                          "groupId": "42344475",
                                          "variationId": "135514239"
                                        }
                                      ],
                                      "price": 58900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344471",
                                          "variationId": "135514231"
                                        },
                                        {
                                          "groupId": "42344474",
                                          "variationId": "135514238"
                                        },
                                        {
                                          "groupId": "42344475",
                                          "variationId": "135514239"
                                        }
                                      ],
                                      "price": 58900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344471",
                                          "variationId": "135514232"
                                        },
                                        {
                                          "groupId": "42344474",
                                          "variationId": "135514238"
                                        },
                                        {
                                          "groupId": "42344475",
                                          "variationId": "135514239"
                                        }
                                      ],
                                      "price": 58900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344471",
                                          "variationId": "135514235"
                                        },
                                        {
                                          "groupId": "42344474",
                                          "variationId": "135514238"
                                        },
                                        {
                                          "groupId": "42344475",
                                          "variationId": "135514239"
                                        }
                                      ],
                                      "price": 58900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 2"
                                },
                                "defaultPrice": 52900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859675",
                                "name": "Hut Treat Meal for 4 - Non Veg",
                                "category": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                                "description": "Serves 4 | Super saver meal combo @ 959 - 2 med non veg pizza of choice, 2 classic bread stix, 2 Pepsi PET. For Meals, refer to the nutritional data for individual products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/4bf86218-e9b2-4ff2-9c8b-bfc20e115efc_e6e2dc0f-10ed-4389-918b-45d3e32bfeda.png",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344479",
                                      "name": "Choose 1st Pizza",
                                      "variations": [
                                        {
                                          "name": "Chicken Sausage",
                                          "price": 616,
                                          "default": 1,
                                          "id": "135514258",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344481",
                                            "variationId": "135514269"
                                          }
                                        },
                                        {
                                          "name": "Sausage & Sweet Corn",
                                          "price": 616,
                                          "id": "135514259",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344481",
                                            "variationId": "135514269"
                                          }
                                        },
                                        {
                                          "name": "Dhabe Da Keema",
                                          "price": 616,
                                          "id": "135514260",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344481",
                                            "variationId": "135514269"
                                          }
                                        },
                                        {
                                          "name": "Sizzling Schezwan Chicken",
                                          "price": 616,
                                          "id": "135514261",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344481",
                                            "variationId": "135514269"
                                          }
                                        },
                                        {
                                          "name": "Murg Malai Chicken",
                                          "price": 671,
                                          "id": "135514263",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344481",
                                            "variationId": "135514269"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka",
                                          "price": 671,
                                          "id": "135514266",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344481",
                                            "variationId": "135514269"
                                          }
                                        },
                                        {
                                          "name": "Chicken Pepperoni",
                                          "price": 671,
                                          "id": "135514267",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344481",
                                            "variationId": "135514269"
                                          }
                                        },
                                        {
                                          "name": "Nawabi Murg Makhni",
                                          "price": 671,
                                          "id": "135514268",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344481",
                                            "variationId": "135514269"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344481",
                                      "name": "Choose 2nd Pizza",
                                      "variations": [
                                        {
                                          "name": "Chicken Sausage",
                                          "price": 343,
                                          "default": 1,
                                          "id": "135514269",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Sausage & Sweet Corn",
                                          "price": 343,
                                          "id": "135514270",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Dhabe Da Keema",
                                          "price": 343,
                                          "id": "135514271",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Sizzling Schezwan Chicken",
                                          "price": 343,
                                          "id": "135514273",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Murg Malai Chicken",
                                          "price": 398,
                                          "id": "135514275",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Tikka",
                                          "price": 398,
                                          "id": "135514277",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Pepperoni",
                                          "price": 398,
                                          "id": "135514279",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514258"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514269"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514258"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514270"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514258"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514271"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514258"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514273"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514258"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514275"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514258"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514277"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514258"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514279"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514259"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514269"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514259"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514270"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514259"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514271"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514259"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514273"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514259"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514275"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514259"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514277"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514259"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514279"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514260"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514269"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514260"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514270"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514260"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514271"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514260"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514273"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514260"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514275"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514260"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514277"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514260"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514279"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514261"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514269"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514261"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514270"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514261"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514271"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514261"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514273"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514261"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514275"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514261"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514277"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514261"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514279"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514263"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514269"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514263"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514270"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514263"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514271"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514263"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514273"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514263"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514275"
                                        }
                                      ],
                                      "price": 106900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514263"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514277"
                                        }
                                      ],
                                      "price": 106900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514263"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514279"
                                        }
                                      ],
                                      "price": 106900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514266"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514269"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514266"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514270"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514266"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514271"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514266"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514273"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514266"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514275"
                                        }
                                      ],
                                      "price": 106900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514266"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514277"
                                        }
                                      ],
                                      "price": 106900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514266"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514279"
                                        }
                                      ],
                                      "price": 106900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514267"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514269"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514267"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514270"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514267"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514271"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514267"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514273"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514267"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514275"
                                        }
                                      ],
                                      "price": 106900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514267"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514277"
                                        }
                                      ],
                                      "price": 106900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514267"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514279"
                                        }
                                      ],
                                      "price": 106900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514268"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514269"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514268"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514270"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514268"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514271"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514268"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514273"
                                        }
                                      ],
                                      "price": 101400
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514268"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514275"
                                        }
                                      ],
                                      "price": 106900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514268"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514277"
                                        }
                                      ],
                                      "price": 106900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344479",
                                          "variationId": "135514268"
                                        },
                                        {
                                          "groupId": "42344481",
                                          "variationId": "135514279"
                                        }
                                      ],
                                      "price": 106900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 4"
                                },
                                "defaultPrice": 95900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859676",
                                "name": "Hut Treat Meal for 4 - Veg",
                                "category": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                                "description": "Serves 4 | Super saver meal combo @ 859 - 2 med veg pizza of choice, 2 classic bread stix, 2 Pepsi PET. For Meals, refer to the nutritional data for individual products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/ca00e969-c65f-4436-85fc-a64408ddaa09_6f0ea04a-c96c-4a1e-893a-be49ead80ae0.png",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344492",
                                      "name": "Choose 1st Pizza",
                                      "variations": [
                                        {
                                          "name": "Margherita",
                                          "price": 566,
                                          "default": 1,
                                          "id": "135514325",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344495",
                                            "variationId": "135514345"
                                          }
                                        },
                                        {
                                          "name": "Schezwan Margherita",
                                          "price": 566,
                                          "id": "135514328",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344495",
                                            "variationId": "135514345"
                                          }
                                        },
                                        {
                                          "name": "Corn & Cheese",
                                          "price": 566,
                                          "id": "135514330",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344495",
                                            "variationId": "135514345"
                                          }
                                        },
                                        {
                                          "name": "Veggie Feast",
                                          "price": 566,
                                          "id": "135514332",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344495",
                                            "variationId": "135514345"
                                          }
                                        },
                                        {
                                          "name": "Spiced Paneer",
                                          "price": 566,
                                          "id": "135514334",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344495",
                                            "variationId": "135514345"
                                          }
                                        },
                                        {
                                          "name": "Mexican Fiesta",
                                          "price": 616,
                                          "id": "135514336",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344495",
                                            "variationId": "135514345"
                                          }
                                        },
                                        {
                                          "name": "Bold BBQ Veggies",
                                          "price": 616,
                                          "id": "135514338",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344495",
                                            "variationId": "135514345"
                                          }
                                        },
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 616,
                                          "id": "135514341",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344495",
                                            "variationId": "135514345"
                                          }
                                        },
                                        {
                                          "name": "Country Feast",
                                          "price": 616,
                                          "id": "135514343",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344495",
                                            "variationId": "135514345"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344495",
                                      "name": "Choose 2nd Pizza",
                                      "variations": [
                                        {
                                          "name": "Margherita",
                                          "price": 293,
                                          "default": 1,
                                          "id": "135514345",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Schezwan Margherita",
                                          "price": 293,
                                          "id": "135514348",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Corn & Cheese",
                                          "price": 293,
                                          "id": "135514350",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Veggie Feast",
                                          "price": 293,
                                          "id": "135514353",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Spiced Paneer",
                                          "price": 293,
                                          "id": "135514354",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mexican Fiesta",
                                          "price": 343,
                                          "id": "135514356",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Bold BBQ Veggies",
                                          "price": 343,
                                          "id": "135514358",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 343,
                                          "id": "135514361",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Country Feast",
                                          "price": 343,
                                          "id": "135514363",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514325"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514345"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514325"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514348"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514325"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514350"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514325"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514353"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514325"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514354"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514325"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514356"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514325"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514358"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514325"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514361"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514325"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514363"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514328"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514345"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514328"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514348"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514328"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514350"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514328"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514353"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514328"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514354"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514328"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514356"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514328"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514358"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514328"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514361"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514328"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514363"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514330"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514345"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514330"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514348"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514330"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514350"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514330"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514353"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514330"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514354"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514330"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514356"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514330"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514358"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514330"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514361"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514330"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514363"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514332"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514345"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514332"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514348"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514332"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514350"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514332"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514353"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514332"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514354"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514332"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514356"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514332"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514358"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514332"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514361"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514332"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514363"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514334"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514345"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514334"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514348"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514334"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514350"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514334"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514353"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514334"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514354"
                                        }
                                      ],
                                      "price": 85900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514334"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514356"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514334"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514358"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514334"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514361"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514334"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514363"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514336"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514345"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514336"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514348"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514336"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514350"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514336"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514353"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514336"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514354"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514336"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514356"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514336"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514358"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514336"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514361"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514336"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514363"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514338"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514345"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514338"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514348"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514338"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514350"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514338"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514353"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514338"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514354"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514338"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514356"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514338"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514358"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514338"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514361"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514338"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514363"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514341"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514345"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514341"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514348"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514341"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514350"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514341"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514353"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514341"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514354"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514341"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514356"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514341"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514358"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514341"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514361"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514341"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514363"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514343"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514345"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514343"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514348"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514343"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514350"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514343"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514353"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514343"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514354"
                                        }
                                      ],
                                      "price": 90900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514343"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514356"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514343"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514358"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514343"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514361"
                                        }
                                      ],
                                      "price": 95900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344492",
                                          "variationId": "135514343"
                                        },
                                        {
                                          "groupId": "42344495",
                                          "variationId": "135514363"
                                        }
                                      ],
                                      "price": 95900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 4"
                                },
                                "defaultPrice": 85900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859682",
                                "name": "Super Value Deal : 2 Medium Non-Veg Pizzas starting at Rs 749 (Save Upto 39%).",
                                "category": "One Plus One Medium @649",
                                "description": "Serves 4 | Choose any 2 of your favorite non-veg medium pizzas. For Meals, refer to the nutritional data for individual products.",
                                "imageId": "6110f28b77f670194674bbf318970656",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344533",
                                      "name": "Choose 1st Pizza",
                                      "variations": [
                                        {
                                          "name": "Chicken Sausage",
                                          "price": 374.5,
                                          "default": 1,
                                          "id": "135514521",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Sausage & Sweet Corn",
                                          "price": 374.5,
                                          "id": "135514523",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Dhabe Da Keema",
                                          "price": 424.5,
                                          "id": "135514524",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Sizzling Schezwan Chicken",
                                          "price": 374.5,
                                          "id": "135514526",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Murg Malai Chicken",
                                          "price": 424.5,
                                          "id": "135514527",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Awesome American Cheesy Chicken",
                                          "price": 424.5,
                                          "id": "135514528",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka",
                                          "price": 424.5,
                                          "id": "135514529",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Chicken Pepperoni",
                                          "price": 424.5,
                                          "id": "135514530",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Nawabi Murg Makhni",
                                          "price": 424.5,
                                          "id": "135514531",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Chicken Supreme",
                                          "price": 424.5,
                                          "id": "135514532",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka Supreme",
                                          "price": 424.5,
                                          "id": "135514533",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Triple Chicken Feast",
                                          "price": 424.5,
                                          "id": "135514534",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344536",
                                      "name": "Choose 2nd Pizza",
                                      "variations": [
                                        {
                                          "name": "Chicken Sausage",
                                          "price": 374.5,
                                          "default": 1,
                                          "id": "135514535",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Sausage & Sweet Corn",
                                          "price": 374.5,
                                          "id": "135514536",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Dhabe Da Keema",
                                          "price": 424.5,
                                          "id": "135514537",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Sizzling Schezwan Chicken",
                                          "price": 374.5,
                                          "id": "135514538",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Murg Malai Chicken",
                                          "price": 424.5,
                                          "id": "135514540",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Awesome American Cheesy Chicken",
                                          "price": 424.5,
                                          "id": "135514541",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Tikka",
                                          "price": 424.5,
                                          "id": "135514543",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Pepperoni",
                                          "price": 424.5,
                                          "id": "135514546",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Nawabi Murg Makhni",
                                          "price": 424.5,
                                          "id": "135514549",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Supreme",
                                          "price": 424.5,
                                          "id": "135514552",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Tikka Supreme",
                                          "price": 424.5,
                                          "id": "135514555",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Triple Chicken Feast",
                                          "price": 424.5,
                                          "id": "135514558",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 4"
                                },
                                "defaultPrice": 74900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859684",
                                "name": "Super Value Deal : 2 Medium Veg Pizzas starting at Rs 649 (Save Upto 41%).",
                                "category": "One Plus One Medium @649",
                                "description": "Serves 4 | Choose any 2 of your favorite veg medium pizzas. For Meals, refer to the nutritional data for individual products.",
                                "imageId": "2d34f1c2c669eab6821dd0ee068590e4",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344566",
                                      "name": "Choose 1st Pizza",
                                      "variations": [
                                        {
                                          "name": "Margherita",
                                          "price": 324.5,
                                          "default": 1,
                                          "id": "135514699",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Schezwan Margherita",
                                          "price": 324.5,
                                          "id": "135514702",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Corn & Cheese",
                                          "price": 324.5,
                                          "id": "135514707",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Veggie Feast",
                                          "price": 324.5,
                                          "id": "135514712",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Spiced Paneer",
                                          "price": 324.5,
                                          "id": "135514716",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Mexican Fiesta",
                                          "price": 374.5,
                                          "id": "135514721",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Bold BBQ Veggies",
                                          "price": 374.5,
                                          "id": "135514727",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 374.5,
                                          "id": "135514732",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Country Feast",
                                          "price": 374.5,
                                          "id": "135514736",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Tandoori Veggie",
                                          "price": 374.5,
                                          "id": "135514740",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Mazedar Makhni Paneer",
                                          "price": 374.5,
                                          "id": "135514743",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Awesome American Cheesy",
                                          "price": 374.5,
                                          "id": "135514745",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Veggie Supreme",
                                          "price": 374.5,
                                          "id": "135514747",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344575",
                                      "name": "Choose 2nd Pizza",
                                      "variations": [
                                        {
                                          "name": "Margherita",
                                          "price": 324.5,
                                          "default": 1,
                                          "id": "135514750",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Schezwan Margherita",
                                          "price": 324.5,
                                          "id": "135514752",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Corn & Cheese",
                                          "price": 324.5,
                                          "id": "135514754",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Veggie Feast",
                                          "price": 324.5,
                                          "id": "135514756",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Spiced Paneer",
                                          "price": 324.5,
                                          "id": "135514759",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mexican Fiesta",
                                          "price": 374.5,
                                          "id": "135514761",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Bold BBQ Veggies",
                                          "price": 374.5,
                                          "id": "135514763",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 374.5,
                                          "id": "135514764",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Country Feast",
                                          "price": 374.5,
                                          "id": "135514765",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Ultimate Tandoori Veggie",
                                          "price": 374.5,
                                          "id": "135514766",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mazedar Makhni Paneer",
                                          "price": 374.5,
                                          "id": "135514767",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Awesome American Cheesy",
                                          "price": 374.5,
                                          "id": "135514768",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Veggie Supreme",
                                          "price": 374.5,
                                          "id": "135514769",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 4"
                                },
                                "defaultPrice": 64900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859589",
                                "name": "Margherita",
                                "category": "Veg Pizza",
                                "description": "Pizza topped with our herb-infused signature pan sauce and 100% mozzarella cheese. A classic treat for all cheese lovers out there! (PAN Per/Med-292 Kcal/100g | TnC-293 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "dpventcrozvfni0lqb10",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266243",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400554",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266244",
                                            "variationId": "116400556"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400555",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266244",
                                            "variationId": "116400557"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962348",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266244",
                                            "variationId": "124962349"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266244",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 169,
                                          "default": 1,
                                          "id": "116400556",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 329,
                                          "id": "116400557",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 479,
                                          "id": "124962349",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 244,
                                          "id": "126057679",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 428,
                                          "id": "126057680",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266243",
                                          "variationId": "116400554"
                                        },
                                        {
                                          "groupId": "37266244",
                                          "variationId": "116400556"
                                        }
                                      ],
                                      "price": 16900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869389",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266243",
                                          "variationId": "116400554"
                                        },
                                        {
                                          "groupId": "37266244",
                                          "variationId": "126057679"
                                        }
                                      ],
                                      "price": 24400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869389",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266243",
                                          "variationId": "116400555"
                                        },
                                        {
                                          "groupId": "37266244",
                                          "variationId": "116400557"
                                        }
                                      ],
                                      "price": 32900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869396",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266243",
                                          "variationId": "116400555"
                                        },
                                        {
                                          "groupId": "37266244",
                                          "variationId": "126057680"
                                        }
                                      ],
                                      "price": 42800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869396",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266243",
                                          "variationId": "124962348"
                                        },
                                        {
                                          "groupId": "37266244",
                                          "variationId": "124962349"
                                        }
                                      ],
                                      "price": 47900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869399",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151869389",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151869399",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439439",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692544",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692545",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692546",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 16900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859593",
                                "name": "Tandoori Paneer",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | It's our signature. Spiced paneer, crunchy onions & green capsicum, spicy red paprika with delicious tandoori sauce and 100% mozzarella cheese! (PAN Per/Med-335 Kcal/100g | TnC-326 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "s5ld93rsknx0fhj6xarn",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266251",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400578",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266252",
                                            "variationId": "116400580"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400579",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266252",
                                            "variationId": "116400581"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962356",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266252",
                                            "variationId": "124962357"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266252",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 319,
                                          "default": 1,
                                          "id": "116400580",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 569,
                                          "id": "116400581",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 749,
                                          "id": "124962357",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 394,
                                          "id": "126057569",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 668,
                                          "id": "126057570",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266251",
                                          "variationId": "116400578"
                                        },
                                        {
                                          "groupId": "37266252",
                                          "variationId": "116400580"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869110",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266251",
                                          "variationId": "116400578"
                                        },
                                        {
                                          "groupId": "37266252",
                                          "variationId": "126057569"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869110",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266251",
                                          "variationId": "116400579"
                                        },
                                        {
                                          "groupId": "37266252",
                                          "variationId": "116400581"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869111",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266251",
                                          "variationId": "116400579"
                                        },
                                        {
                                          "groupId": "37266252",
                                          "variationId": "126057570"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869111",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266251",
                                          "variationId": "124962356"
                                        },
                                        {
                                          "groupId": "37266252",
                                          "variationId": "124962357"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869112",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151869110",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151869112",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439443",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692556",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692557",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692558",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859596",
                                "name": "Veggie Supreme",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | A supreme combination of black olives, green capsicum, mushroom, onion, spicy red paprika & juicy sweet corn with flavourful pan sauce and 100% mozzarella cheese. (PAN Per/Med-254 Kcal/100g | TnC-258 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "z0c4xpovma1qtmu4tlls",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266257",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400596",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266258",
                                            "variationId": "116400598"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400597",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266258",
                                            "variationId": "116400599"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962362",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266258",
                                            "variationId": "124962363"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266258",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 379,
                                          "default": 1,
                                          "id": "116400598",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 639,
                                          "id": "116400599",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 849,
                                          "id": "124962363",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 454,
                                          "id": "126057651",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 738,
                                          "id": "126057652",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266257",
                                          "variationId": "116400596"
                                        },
                                        {
                                          "groupId": "37266258",
                                          "variationId": "116400598"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869037",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266257",
                                          "variationId": "116400596"
                                        },
                                        {
                                          "groupId": "37266258",
                                          "variationId": "126057651"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869037",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266257",
                                          "variationId": "116400597"
                                        },
                                        {
                                          "groupId": "37266258",
                                          "variationId": "116400599"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869041",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266257",
                                          "variationId": "116400597"
                                        },
                                        {
                                          "groupId": "37266258",
                                          "variationId": "126057652"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869041",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266257",
                                          "variationId": "124962362"
                                        },
                                        {
                                          "groupId": "37266258",
                                          "variationId": "124962363"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869042",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151869037",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151869042",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439446",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692565",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692566",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692567",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "type": "CATEGORY_TYPE_RECOMMENDED"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Flavour Fun Range.",
                        "categories": [
                          {
                            "title": "Combos and Deals",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859635",
                                    "name": "Create Your Flavour Fun Combo - Box Of 2 - Veg Pizza",
                                    "category": "Flavour Fun Range.",
                                    "description": "Serves 2 | Choose any 2 veg personal pizzas from our flavour fun range. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "a58a3816c547ed1bc93f44818dd9e882",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37266297",
                                          "name": "Choose your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Classic Corn",
                                              "price": 109,
                                              "id": "116400694",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37266298",
                                                "variationId": "116400702"
                                              }
                                            },
                                            {
                                              "name": "Chatpata Tomato Onion & Chilli",
                                              "price": 149,
                                              "id": "117298545",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37266298",
                                                "variationId": "116400702"
                                              }
                                            },
                                            {
                                              "name": "Cheesy Spicy Delight",
                                              "price": 159,
                                              "id": "117298546",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37266298",
                                                "variationId": "116400702"
                                              }
                                            },
                                            {
                                              "name": "Chilli Paneer Sizzle",
                                              "price": 179,
                                              "id": "117298547",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37266298",
                                                "variationId": "116400702"
                                              }
                                            },
                                            {
                                              "name": "Spicy Sweet corn, Onion, Green Chilli",
                                              "price": 139,
                                              "id": "117298548",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37266298",
                                                "variationId": "116400702"
                                              }
                                            },
                                            {
                                              "name": "Classic Onion Capsicum",
                                              "price": 99,
                                              "default": 1,
                                              "id": "116400695",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37266298",
                                                "variationId": "116400702"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37266298",
                                          "name": "Choose your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Classic Corn",
                                              "price": 109,
                                              "id": "116400701",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chatpata Tomato Onion & Chilli",
                                              "price": 149,
                                              "id": "117298549",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Cheesy Spicy Delight",
                                              "price": 159,
                                              "id": "117298550",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chilli Paneer Sizzle",
                                              "price": 179,
                                              "id": "117298551",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Spicy Sweet corn, Onion, Green Chilli",
                                              "price": 139,
                                              "id": "117298552",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Classic Onion Capsicum",
                                              "price": 99,
                                              "default": 1,
                                              "id": "116400702",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "116400694"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "116400701"
                                            }
                                          ],
                                          "price": 21800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "116400694"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298549"
                                            }
                                          ],
                                          "price": 25800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "116400694"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298550"
                                            }
                                          ],
                                          "price": 26800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "116400694"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298551"
                                            }
                                          ],
                                          "price": 28800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "116400694"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298552"
                                            }
                                          ],
                                          "price": 24800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "116400694"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "116400702"
                                            }
                                          ],
                                          "price": 20800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298545"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "116400701"
                                            }
                                          ],
                                          "price": 25800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298545"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298549"
                                            }
                                          ],
                                          "price": 29800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298545"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298550"
                                            }
                                          ],
                                          "price": 30800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298545"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298551"
                                            }
                                          ],
                                          "price": 32800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298545"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298552"
                                            }
                                          ],
                                          "price": 28800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298545"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "116400702"
                                            }
                                          ],
                                          "price": 24800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298546"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "116400701"
                                            }
                                          ],
                                          "price": 26800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298546"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298549"
                                            }
                                          ],
                                          "price": 30800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298546"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298550"
                                            }
                                          ],
                                          "price": 31800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298546"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298551"
                                            }
                                          ],
                                          "price": 33800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298546"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298552"
                                            }
                                          ],
                                          "price": 29800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298546"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "116400702"
                                            }
                                          ],
                                          "price": 25800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298547"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "116400701"
                                            }
                                          ],
                                          "price": 28800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298547"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298549"
                                            }
                                          ],
                                          "price": 32800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298547"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298550"
                                            }
                                          ],
                                          "price": 33800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298547"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298551"
                                            }
                                          ],
                                          "price": 35800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298547"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298552"
                                            }
                                          ],
                                          "price": 31800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298547"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "116400702"
                                            }
                                          ],
                                          "price": 27800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298548"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "116400701"
                                            }
                                          ],
                                          "price": 24800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298548"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298549"
                                            }
                                          ],
                                          "price": 28800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298548"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298550"
                                            }
                                          ],
                                          "price": 29800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298548"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298551"
                                            }
                                          ],
                                          "price": 31800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298548"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298552"
                                            }
                                          ],
                                          "price": 27800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "117298548"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "116400702"
                                            }
                                          ],
                                          "price": 23800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "116400695"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "116400701"
                                            }
                                          ],
                                          "price": 20800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "116400695"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298549"
                                            }
                                          ],
                                          "price": 24800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "116400695"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298550"
                                            }
                                          ],
                                          "price": 25800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "116400695"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298551"
                                            }
                                          ],
                                          "price": 27800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "116400695"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "117298552"
                                            }
                                          ],
                                          "price": 23800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266297",
                                              "variationId": "116400695"
                                            },
                                            {
                                              "groupId": "37266298",
                                              "variationId": "116400702"
                                            }
                                          ],
                                          "price": 19800
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 2"
                                    },
                                    "defaultPrice": 19800,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "96 ratings",
                                        "ratingCountV2": "96"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859632",
                                    "name": "Create Your Flavour Fun Combo - Box Of 2 - Non Veg Pizza",
                                    "category": "Flavour Fun Range.",
                                    "description": "Serves 2 | Choose any 2 non veg personal pizzas from our flavour fun range. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "3eb63332d8012c536aaa0f1b2c5fb1ba",
                                    "inStock": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37266295",
                                          "name": "Choose your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Chatpata Chicken Feast",
                                              "price": 189,
                                              "id": "117298553",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37266296",
                                                "variationId": "117298557"
                                              }
                                            },
                                            {
                                              "name": "Classic Chicken Pepperoni & Onion",
                                              "price": 149,
                                              "default": 1,
                                              "id": "117298554",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37266296",
                                                "variationId": "117298557"
                                              }
                                            },
                                            {
                                              "name": "Classic Herbed Chicken & Capsicum",
                                              "price": 169,
                                              "id": "117298555",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37266296",
                                                "variationId": "117298557"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37266296",
                                          "name": "Choose your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Chatpata Chicken Feast",
                                              "price": 189,
                                              "id": "117298556",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Classic Chicken Pepperoni & Onion",
                                              "price": 149,
                                              "default": 1,
                                              "id": "117298557",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Classic Herbed Chicken & Capsicum",
                                              "price": 169,
                                              "id": "117298558",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266295",
                                              "variationId": "117298553"
                                            },
                                            {
                                              "groupId": "37266296",
                                              "variationId": "117298556"
                                            }
                                          ],
                                          "price": 37800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266295",
                                              "variationId": "117298553"
                                            },
                                            {
                                              "groupId": "37266296",
                                              "variationId": "117298557"
                                            }
                                          ],
                                          "price": 33800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266295",
                                              "variationId": "117298553"
                                            },
                                            {
                                              "groupId": "37266296",
                                              "variationId": "117298558"
                                            }
                                          ],
                                          "price": 35800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266295",
                                              "variationId": "117298554"
                                            },
                                            {
                                              "groupId": "37266296",
                                              "variationId": "117298556"
                                            }
                                          ],
                                          "price": 33800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266295",
                                              "variationId": "117298554"
                                            },
                                            {
                                              "groupId": "37266296",
                                              "variationId": "117298557"
                                            }
                                          ],
                                          "price": 29800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266295",
                                              "variationId": "117298554"
                                            },
                                            {
                                              "groupId": "37266296",
                                              "variationId": "117298558"
                                            }
                                          ],
                                          "price": 31800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266295",
                                              "variationId": "117298555"
                                            },
                                            {
                                              "groupId": "37266296",
                                              "variationId": "117298556"
                                            }
                                          ],
                                          "price": 35800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266295",
                                              "variationId": "117298555"
                                            },
                                            {
                                              "groupId": "37266296",
                                              "variationId": "117298557"
                                            }
                                          ],
                                          "price": 31800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266295",
                                              "variationId": "117298555"
                                            },
                                            {
                                              "groupId": "37266296",
                                              "variationId": "117298558"
                                            }
                                          ],
                                          "price": 33800
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG",
                                      "portionSize": "Serves 2"
                                    },
                                    "defaultPrice": 29800,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "16 ratings",
                                        "ratingCountV2": "16"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859653",
                                    "name": "Create Your Flavour Fun Combo - Box Of 4 - Non Veg",
                                    "category": "Flavour Fun Range.",
                                    "description": "Get 4 assorted flavor fun personal pizzas. Perfect personal pizza crust topped with exciting new sauces, cheesy dressing & your favorite toppings. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "c35b484cdf1cde4831b0a6283768bf43",
                                    "inStock": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344445",
                                          "name": "Choose your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Chatpata Chicken Feast",
                                              "price": 166.25,
                                              "id": "135514078",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344448",
                                                "variationId": "135514089"
                                              }
                                            },
                                            {
                                              "name": "Classic Chicken Pepperoni & Onion",
                                              "price": 136.25,
                                              "default": 1,
                                              "id": "135514080",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344448",
                                                "variationId": "135514089"
                                              }
                                            },
                                            {
                                              "name": "Classic Herbed Chicken & Capsicum",
                                              "price": 146.25,
                                              "id": "135514084",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344448",
                                                "variationId": "135514089"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344448",
                                          "name": "Choose your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Chatpata Chicken Feast",
                                              "price": 166.25,
                                              "id": "135514088",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344450",
                                                "variationId": "135514093"
                                              }
                                            },
                                            {
                                              "name": "Classic Chicken Pepperoni & Onion",
                                              "price": 136.25,
                                              "default": 1,
                                              "id": "135514089",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344450",
                                                "variationId": "135514093"
                                              }
                                            },
                                            {
                                              "name": "Classic Herbed Chicken & Capsicum",
                                              "price": 146.25,
                                              "id": "135514091",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344450",
                                                "variationId": "135514093"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344450",
                                          "name": "Choose your 3rd Pizza",
                                          "variations": [
                                            {
                                              "name": "Chatpata Chicken Feast",
                                              "price": 166.25,
                                              "id": "135514092",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344451",
                                                "variationId": "135514097"
                                              }
                                            },
                                            {
                                              "name": "Classic Chicken Pepperoni & Onion",
                                              "price": 136.25,
                                              "default": 1,
                                              "id": "135514093",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344451",
                                                "variationId": "135514097"
                                              }
                                            },
                                            {
                                              "name": "Classic Herbed Chicken & Capsicum",
                                              "price": 146.25,
                                              "id": "135514094",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344451",
                                                "variationId": "135514097"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344451",
                                          "name": "Choose your 4th Pizza",
                                          "variations": [
                                            {
                                              "name": "Chatpata Chicken Feast",
                                              "price": 166.25,
                                              "id": "135514095",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Classic Chicken Pepperoni & Onion",
                                              "price": 136.25,
                                              "default": 1,
                                              "id": "135514097",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Classic Herbed Chicken & Capsicum",
                                              "price": 146.25,
                                              "id": "135514101",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 66500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 63500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 64500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 63500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 64500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 63500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 64500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514078"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 63500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514080"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 64500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514088"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514089"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514092"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514093"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514095"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514097"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344445",
                                              "variationId": "135514084"
                                            },
                                            {
                                              "groupId": "42344448",
                                              "variationId": "135514091"
                                            },
                                            {
                                              "groupId": "42344450",
                                              "variationId": "135514094"
                                            },
                                            {
                                              "groupId": "42344451",
                                              "variationId": "135514101"
                                            }
                                          ],
                                          "price": 58500
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 54500,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859650",
                                    "name": "Create Your Flavour Fun Combo - Box Of 4 - Veg",
                                    "category": "Flavour Fun Range.",
                                    "description": "Get 4 assorted flavor fun personal pizzas. Perfect personal pizza crust topped with exciting new sauces, cheesy dressing & your favorite toppings. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "5ab57368f8d7c4c5d546776135fa4f63",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344424",
                                          "name": "Choose your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Classic Corn",
                                              "price": 106.25,
                                              "default": 1,
                                              "id": "135513981",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344426",
                                                "variationId": "135513994"
                                              }
                                            },
                                            {
                                              "name": "Chatpata Tomato Onion & Chilli",
                                              "price": 136.25,
                                              "id": "135513982",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344426",
                                                "variationId": "135513994"
                                              }
                                            },
                                            {
                                              "name": "Cheesy Spicy Delight",
                                              "price": 146.25,
                                              "id": "135513983",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344426",
                                                "variationId": "135513994"
                                              }
                                            },
                                            {
                                              "name": "Chilli Paneer Sizzle",
                                              "price": 156.25,
                                              "id": "135513984",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344426",
                                                "variationId": "135513994"
                                              }
                                            },
                                            {
                                              "name": "Spicy Sweet corn, Onion, Green Chilli",
                                              "price": 126.25,
                                              "id": "135513985",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344426",
                                                "variationId": "135513994"
                                              }
                                            },
                                            {
                                              "name": "Classic Onion Capsicum",
                                              "price": 106.25,
                                              "id": "135513988",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344426",
                                                "variationId": "135513994"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344426",
                                          "name": "Choose your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Classic Corn",
                                              "price": 106.25,
                                              "default": 1,
                                              "id": "135513994",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344429",
                                                "variationId": "135514008"
                                              }
                                            },
                                            {
                                              "name": "Chatpata Tomato Onion & Chilli",
                                              "price": 136.25,
                                              "id": "135513997",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344429",
                                                "variationId": "135514008"
                                              }
                                            },
                                            {
                                              "name": "Cheesy Spicy Delight",
                                              "price": 146.25,
                                              "id": "135514000",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344429",
                                                "variationId": "135514008"
                                              }
                                            },
                                            {
                                              "name": "Chilli Paneer Sizzle",
                                              "price": 156.25,
                                              "id": "135514002",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344429",
                                                "variationId": "135514008"
                                              }
                                            },
                                            {
                                              "name": "Spicy Sweet corn, Onion, Green Chilli",
                                              "price": 126.25,
                                              "id": "135514004",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344429",
                                                "variationId": "135514008"
                                              }
                                            },
                                            {
                                              "name": "Classic Onion Capsicum",
                                              "price": 106.25,
                                              "id": "135514006",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344429",
                                                "variationId": "135514008"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344429",
                                          "name": "Choose your 3rd Pizza",
                                          "variations": [
                                            {
                                              "name": "Classic Corn",
                                              "price": 106.25,
                                              "default": 1,
                                              "id": "135514008",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344431",
                                                "variationId": "135514015"
                                              }
                                            },
                                            {
                                              "name": "Chatpata Tomato Onion & Chilli",
                                              "price": 136.25,
                                              "id": "135514009",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344431",
                                                "variationId": "135514015"
                                              }
                                            },
                                            {
                                              "name": "Cheesy Spicy Delight",
                                              "price": 146.25,
                                              "id": "135514010",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344431",
                                                "variationId": "135514015"
                                              }
                                            },
                                            {
                                              "name": "Chilli Paneer Sizzle",
                                              "price": 156.25,
                                              "id": "135514011",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344431",
                                                "variationId": "135514015"
                                              }
                                            },
                                            {
                                              "name": "Spicy Sweet corn, Onion, Green Chilli",
                                              "price": 126.25,
                                              "id": "135514012",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344431",
                                                "variationId": "135514015"
                                              }
                                            },
                                            {
                                              "name": "Classic Onion Capsicum",
                                              "price": 106.25,
                                              "id": "135514013",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344431",
                                                "variationId": "135514015"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344431",
                                          "name": "Choose your 4th Pizza",
                                          "variations": [
                                            {
                                              "name": "Classic Corn",
                                              "price": 106.25,
                                              "default": 1,
                                              "id": "135514015",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chatpata Tomato Onion & Chilli",
                                              "price": 136.25,
                                              "id": "135514017",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Cheesy Spicy Delight",
                                              "price": 146.25,
                                              "id": "135514019",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chilli Paneer Sizzle",
                                              "price": 156.25,
                                              "id": "135514022",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Spicy Sweet corn, Onion, Green Chilli",
                                              "price": 126.25,
                                              "id": "135514024",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Classic Onion Capsicum",
                                              "price": 106.25,
                                              "id": "135514026",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513981"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513982"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513983"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513984"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513985"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513994"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135513997"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514000"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514002"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514004"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514008"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514009"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514010"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514011"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514012"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514015"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514017"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514019"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514022"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514024"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344424",
                                              "variationId": "135513988"
                                            },
                                            {
                                              "groupId": "42344426",
                                              "variationId": "135514006"
                                            },
                                            {
                                              "groupId": "42344429",
                                              "variationId": "135514013"
                                            },
                                            {
                                              "groupId": "42344431",
                                              "variationId": "135514026"
                                            }
                                          ],
                                          "price": 42500
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 42500,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              }
                            ]
                          },
                          {
                            "title": "Veg Pizza",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859656",
                                    "name": "Classic Corn",
                                    "category": "Flavour Fun Range.",
                                    "description": "Serves 1 | Personal pizza topped with our classic pan sauce, sweet corn and cheesy dressing. An all-time favorite (319 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "aed52ab0d028996e060b772f11ff31d8",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37266317",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "116400783",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37266318",
                                                "variationId": "116400787"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37266318",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 109,
                                              "default": 1,
                                              "id": "116400787",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266317",
                                              "variationId": "116400783"
                                            },
                                            {
                                              "groupId": "37266318",
                                              "variationId": "116400787"
                                            }
                                          ],
                                          "price": 10900,
                                          "addonCombinations": [
                                            {
                                              "groupId": "133692615",
                                              "addonId": "112193863"
                                            },
                                            {
                                              "groupId": "133692615",
                                              "addonId": "112193860"
                                            },
                                            {
                                              "groupId": "133692615",
                                              "addonId": "112193859"
                                            },
                                            {
                                              "groupId": "133692615",
                                              "addonId": "115290079"
                                            },
                                            {
                                              "groupId": "133692615",
                                              "addonId": "112193858"
                                            },
                                            {
                                              "groupId": "133692615",
                                              "addonId": "112193861"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "133692615",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "112193863",
                                            "name": "Pepsi Pet Bottle",
                                            "price": 5700,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "112193860",
                                            "name": "Classic BreadStix : Flat Rs 20 Off",
                                            "price": 9900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "112193859",
                                            "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "112193858",
                                            "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "112193861",
                                            "name": "Choco Volcano : Flat Rs 20 Off",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "115290079",
                                            "name": "Loaded BreadStix : Flat Rs 20 Off",
                                            "price": 14900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "defaultPrice": 10900,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "33 ratings",
                                        "ratingCountV2": "33"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859658",
                                    "name": "Classic Onion Capsicum",
                                    "category": "Flavour Fun Range.",
                                    "description": "Serves 1 | Personal pizza topped with our classic pan sauce, crunchy onion & capsicum and cheesy dressing (307 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "ed6a84173f69cdd4f676e94c2332c5e7",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37266321",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "116400794",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37266322",
                                                "variationId": "116400795"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37266322",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 99,
                                              "default": 1,
                                              "id": "116400795",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37266321",
                                              "variationId": "116400794"
                                            },
                                            {
                                              "groupId": "37266322",
                                              "variationId": "116400795"
                                            }
                                          ],
                                          "price": 9900,
                                          "addonCombinations": [
                                            {
                                              "groupId": "133692619",
                                              "addonId": "112193863"
                                            },
                                            {
                                              "groupId": "133692619",
                                              "addonId": "112193860"
                                            },
                                            {
                                              "groupId": "133692619",
                                              "addonId": "112193859"
                                            },
                                            {
                                              "groupId": "133692619",
                                              "addonId": "115290079"
                                            },
                                            {
                                              "groupId": "133692619",
                                              "addonId": "112193858"
                                            },
                                            {
                                              "groupId": "133692619",
                                              "addonId": "112193861"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "133692619",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "112193863",
                                            "name": "Pepsi Pet Bottle",
                                            "price": 5700,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "112193860",
                                            "name": "Classic BreadStix : Flat Rs 20 Off",
                                            "price": 9900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "112193859",
                                            "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "112193858",
                                            "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "112193861",
                                            "name": "Choco Volcano : Flat Rs 20 Off",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "115290079",
                                            "name": "Loaded BreadStix : Flat Rs 20 Off",
                                            "price": 14900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "defaultPrice": 9900,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "23 ratings",
                                        "ratingCountV2": "23"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133116149",
                                    "name": "Chilli Paneer Sizzle",
                                    "category": "Flavour Fun Range.",
                                    "description": "Pizza topped with spiced paneer, a spicy schezwan sauce, juicy tomato, crunchy onion & capsicum and cheesy dressing (298 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "fc2d0de600d6649eaea5ca50d84ab5ec",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37483143",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117298894",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37483144",
                                                "variationId": "117298895"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37483144",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 179,
                                              "default": 1,
                                              "id": "117298895",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37483143",
                                              "variationId": "117298894"
                                            },
                                            {
                                              "groupId": "37483144",
                                              "variationId": "117298895"
                                            }
                                          ],
                                          "price": 17900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 17900,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "8 ratings",
                                        "ratingCountV2": "8"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133116146",
                                    "name": "Cheesy Spicy Delight",
                                    "category": "Flavour Fun Range.",
                                    "description": "Pizza topped 100% mozzarella cheese, cheesy dressing for thst extraaa cheesy flavour, onion and spicy green chilli, sprinkled with our signature spiced seasoning (367 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "2d16764980d14b46323559a539f77910",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37483137",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117298888",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37483138",
                                                "variationId": "117298889"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37483138",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 159,
                                              "default": 1,
                                              "id": "117298889",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37483137",
                                              "variationId": "117298888"
                                            },
                                            {
                                              "groupId": "37483138",
                                              "variationId": "117298889"
                                            }
                                          ],
                                          "price": 15900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 15900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133116147",
                                    "name": "Spicy Sweet Corn, Onion, Green Chilli",
                                    "category": "Flavour Fun Range.",
                                    "description": "Pizza topped with a spicy tandoori sauce, juicy sweet corn, crunchy onion & spicy green chilli and cheesy dressing (327 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "04b1310428ad6814cf48e3544e4fd00e",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37483139",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117298890",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37483140",
                                                "variationId": "117298891"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37483140",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 139,
                                              "default": 1,
                                              "id": "117298891",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37483139",
                                              "variationId": "117298890"
                                            },
                                            {
                                              "groupId": "37483140",
                                              "variationId": "117298891"
                                            }
                                          ],
                                          "price": 13900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 13900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133116148",
                                    "name": "Chatpata Tomato Onion & Chilli",
                                    "category": "Flavour Fun Range.",
                                    "description": "Pizza topped with a spicy tandoori sauce, juicy tomato, crunchy onion & green chilli for an extra zing and cheesy dressing (328 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "3b229da1719952a564c2bf297bb731b3",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37483141",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117298892",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37483142",
                                                "variationId": "117298893"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37483142",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 149,
                                              "default": 1,
                                              "id": "117298893",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37483141",
                                              "variationId": "117298892"
                                            },
                                            {
                                              "groupId": "37483142",
                                              "variationId": "117298893"
                                            }
                                          ],
                                          "price": 14900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 14900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              }
                            ]
                          },
                          {
                            "title": "Non-Veg Pizza",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133116151",
                                    "name": "Classic Chicken Pepperoni & Onion",
                                    "category": "Flavour Fun Range.",
                                    "description": "Pizza topped with our classic signature pan sauce, chicken pepperoni, crunchy onion and cheesy dressing (332 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "e35bac2a83cd54e364af7b62305da271",
                                    "inStock": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37483147",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117298898",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37483148",
                                                "variationId": "117298899"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37483148",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 149,
                                              "default": 1,
                                              "id": "117298899",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37483147",
                                              "variationId": "117298898"
                                            },
                                            {
                                              "groupId": "37483148",
                                              "variationId": "117298899"
                                            }
                                          ],
                                          "price": 14900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 14900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133116150",
                                    "name": "Chatpata Chicken Feast",
                                    "category": "Flavour Fun Range.",
                                    "description": "Pizza topped with a spicy tandoori sauce, schezwan chicken meatballs, crunchy onion & capsisum, green chilli, juicy tomato and cheesy dressing (294 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "ca7df89f4cbf23526d4a440eb6ad2be3",
                                    "inStock": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37483145",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117298896",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37483146",
                                                "variationId": "117298897"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37483146",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 189,
                                              "default": 1,
                                              "id": "117298897",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37483145",
                                              "variationId": "117298896"
                                            },
                                            {
                                              "groupId": "37483146",
                                              "variationId": "117298897"
                                            }
                                          ],
                                          "price": 18900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 18900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133116152",
                                    "name": "Classic Herbed Chicken & Capsicum",
                                    "category": "Flavour Fun Range.",
                                    "description": "Pizza topped with our classic signature pan sauce, herbed chicken, crunchy capsicum and cheesy dressing (331 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "1dd1e4c79a90aa5e70e2fa44493b8c6e",
                                    "inStock": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37483149",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117298900",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37483150",
                                                "variationId": "117298901"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37483150",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 169,
                                              "default": 1,
                                              "id": "117298901",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37483149",
                                              "variationId": "117298900"
                                            },
                                            {
                                              "groupId": "37483150",
                                              "variationId": "117298901"
                                            }
                                          ],
                                          "price": 16900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 16900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              }
                            ]
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Veg Pizza",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859609",
                                "name": "Margherita Pizza",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Pizza topped with our herb-infused signature pan sauce and 100% mozzarella cheese. A classic treat for all cheese lovers out there! (292 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "dpventcrozvfni0lqb10",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 16900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "55 ratings",
                                    "ratingCountV2": "55"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859589",
                                "name": "Margherita",
                                "category": "Veg Pizza",
                                "description": "Pizza topped with our herb-infused signature pan sauce and 100% mozzarella cheese. A classic treat for all cheese lovers out there! (PAN Per/Med-292 Kcal/100g | TnC-293 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "dpventcrozvfni0lqb10",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266243",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400554",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266244",
                                            "variationId": "116400556"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400555",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266244",
                                            "variationId": "116400557"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962348",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266244",
                                            "variationId": "124962349"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266244",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 169,
                                          "default": 1,
                                          "id": "116400556",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 329,
                                          "id": "116400557",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 479,
                                          "id": "124962349",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 244,
                                          "id": "126057679",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 428,
                                          "id": "126057680",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266243",
                                          "variationId": "116400554"
                                        },
                                        {
                                          "groupId": "37266244",
                                          "variationId": "116400556"
                                        }
                                      ],
                                      "price": 16900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869389",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266243",
                                          "variationId": "116400554"
                                        },
                                        {
                                          "groupId": "37266244",
                                          "variationId": "126057679"
                                        }
                                      ],
                                      "price": 24400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692546",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869389",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266243",
                                          "variationId": "116400555"
                                        },
                                        {
                                          "groupId": "37266244",
                                          "variationId": "116400557"
                                        }
                                      ],
                                      "price": 32900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869396",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266243",
                                          "variationId": "116400555"
                                        },
                                        {
                                          "groupId": "37266244",
                                          "variationId": "126057680"
                                        }
                                      ],
                                      "price": 42800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869396",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692545",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266243",
                                          "variationId": "124962348"
                                        },
                                        {
                                          "groupId": "37266244",
                                          "variationId": "124962349"
                                        }
                                      ],
                                      "price": 47900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692544",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869399",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439439",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151869389",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151869399",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439439",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692544",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692545",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692546",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 16900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859593",
                                "name": "Tandoori Paneer",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | It's our signature. Spiced paneer, crunchy onions & green capsicum, spicy red paprika with delicious tandoori sauce and 100% mozzarella cheese! (PAN Per/Med-335 Kcal/100g | TnC-326 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "s5ld93rsknx0fhj6xarn",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266251",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400578",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266252",
                                            "variationId": "116400580"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400579",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266252",
                                            "variationId": "116400581"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962356",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266252",
                                            "variationId": "124962357"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266252",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 319,
                                          "default": 1,
                                          "id": "116400580",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 569,
                                          "id": "116400581",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 749,
                                          "id": "124962357",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 394,
                                          "id": "126057569",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 668,
                                          "id": "126057570",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266251",
                                          "variationId": "116400578"
                                        },
                                        {
                                          "groupId": "37266252",
                                          "variationId": "116400580"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869110",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266251",
                                          "variationId": "116400578"
                                        },
                                        {
                                          "groupId": "37266252",
                                          "variationId": "126057569"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692558",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869110",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266251",
                                          "variationId": "116400579"
                                        },
                                        {
                                          "groupId": "37266252",
                                          "variationId": "116400581"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869111",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266251",
                                          "variationId": "116400579"
                                        },
                                        {
                                          "groupId": "37266252",
                                          "variationId": "126057570"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869111",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692557",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266251",
                                          "variationId": "124962356"
                                        },
                                        {
                                          "groupId": "37266252",
                                          "variationId": "124962357"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692556",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869112",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439443",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151869110",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151869112",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439443",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692556",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692557",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692558",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859709",
                                "name": "Mexican Fiesta",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Flavourful mix of red capsicum, green capsicum, jalapeno, onion, black olives, sweet corn and 100% mozzarella cheese with a signature spice sprinkle & our flavourful pan sauce (PAN Per/Med-266 Kcal/100g | TnC-258 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "0c4c12819d98a35144e3f08451ae64f3",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266399",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116401086",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266401",
                                            "variationId": "116401089"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116401087",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266401",
                                            "variationId": "116401091"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962408",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266401",
                                            "variationId": "124962409"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266401",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 319,
                                          "default": 1,
                                          "id": "116401089",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 569,
                                          "id": "116401091",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 749,
                                          "id": "124962409",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 394,
                                          "id": "126057975",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 668,
                                          "id": "126057978",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266399",
                                          "variationId": "116401086"
                                        },
                                        {
                                          "groupId": "37266401",
                                          "variationId": "116401089"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "150927359",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266399",
                                          "variationId": "116401086"
                                        },
                                        {
                                          "groupId": "37266401",
                                          "variationId": "126057975"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692680",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "150927359",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266399",
                                          "variationId": "116401087"
                                        },
                                        {
                                          "groupId": "37266401",
                                          "variationId": "116401091"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "150927360",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266399",
                                          "variationId": "116401087"
                                        },
                                        {
                                          "groupId": "37266401",
                                          "variationId": "126057978"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "150927360",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692679",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266399",
                                          "variationId": "124962408"
                                        },
                                        {
                                          "groupId": "37266401",
                                          "variationId": "124962409"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692677",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "150927361",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439470",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439470",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439470",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439470",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439470",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439470",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439470",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439470",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439470",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439470",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439470",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439470",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439470",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "150927359",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "150927361",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439470",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692677",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692679",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692680",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859698",
                                "name": "Mazedar Makhni Paneer",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | A treat for all makhni lovers. Spiced paneer, onion, juicy red bell peppers with our new flavourful makhni sauce, topped with 100% mozzarella cheese and buttery spice sprinkle (PAN Per/Med-288 Kcal/100g | TnC-290 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "bf62afee565475fb92a204206321a41c",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266377",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116401050",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266378",
                                            "variationId": "116401052"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116401051",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266378",
                                            "variationId": "116401053"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962400",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266378",
                                            "variationId": "124962401"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266378",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 379,
                                          "default": 1,
                                          "id": "116401052",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 639,
                                          "id": "116401053",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 849,
                                          "id": "124962401",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 454,
                                          "id": "126057723",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 738,
                                          "id": "126057724",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266377",
                                          "variationId": "116401050"
                                        },
                                        {
                                          "groupId": "37266378",
                                          "variationId": "116401052"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151868772",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266377",
                                          "variationId": "116401050"
                                        },
                                        {
                                          "groupId": "37266378",
                                          "variationId": "126057723"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692663",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151868772",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266377",
                                          "variationId": "116401051"
                                        },
                                        {
                                          "groupId": "37266378",
                                          "variationId": "116401053"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151868778",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266377",
                                          "variationId": "116401051"
                                        },
                                        {
                                          "groupId": "37266378",
                                          "variationId": "126057724"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151868778",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692661",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266377",
                                          "variationId": "124962400"
                                        },
                                        {
                                          "groupId": "37266378",
                                          "variationId": "124962401"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692660",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151868780",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439465",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439465",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439465",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439465",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439465",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439465",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439465",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439465",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439465",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439465",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439465",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439465",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439465",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151868772",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151868780",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439465",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692660",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692661",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692663",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859596",
                                "name": "Veggie Supreme",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | A supreme combination of black olives, green capsicum, mushroom, onion, spicy red paprika & juicy sweet corn with flavourful pan sauce and 100% mozzarella cheese. (PAN Per/Med-254 Kcal/100g | TnC-258 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "z0c4xpovma1qtmu4tlls",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266257",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400596",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266258",
                                            "variationId": "116400598"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400597",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266258",
                                            "variationId": "116400599"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962362",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266258",
                                            "variationId": "124962363"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266258",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 379,
                                          "default": 1,
                                          "id": "116400598",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 639,
                                          "id": "116400599",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 849,
                                          "id": "124962363",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 454,
                                          "id": "126057651",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 738,
                                          "id": "126057652",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266257",
                                          "variationId": "116400596"
                                        },
                                        {
                                          "groupId": "37266258",
                                          "variationId": "116400598"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869037",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266257",
                                          "variationId": "116400596"
                                        },
                                        {
                                          "groupId": "37266258",
                                          "variationId": "126057651"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692567",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869037",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266257",
                                          "variationId": "116400597"
                                        },
                                        {
                                          "groupId": "37266258",
                                          "variationId": "116400599"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869041",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266257",
                                          "variationId": "116400597"
                                        },
                                        {
                                          "groupId": "37266258",
                                          "variationId": "126057652"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869041",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692566",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266257",
                                          "variationId": "124962362"
                                        },
                                        {
                                          "groupId": "37266258",
                                          "variationId": "124962363"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692565",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869042",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439446",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151869037",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151869042",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439446",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692565",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692566",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692567",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859595",
                                "name": "Country Feast",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Loaded with herbed onion & green capsicum, sweet corn, tomato with signature pan sauce and 100% mozzarella cheese. It's a feast you can't refuse (PAN Per/Med-244 Kcal/100g | TnC-282 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "c3832837392378cca98e484b89c313ba",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266255",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400590",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266256",
                                            "variationId": "116400592"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400591",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266256",
                                            "variationId": "116400593"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962376",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266256",
                                            "variationId": "124962377"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266256",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 319,
                                          "default": 1,
                                          "id": "116400592",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 569,
                                          "id": "116400593",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 749,
                                          "id": "124962377",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 394,
                                          "id": "126057615",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 668,
                                          "id": "126057616",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266255",
                                          "variationId": "116400590"
                                        },
                                        {
                                          "groupId": "37266256",
                                          "variationId": "116400592"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869346",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266255",
                                          "variationId": "116400590"
                                        },
                                        {
                                          "groupId": "37266256",
                                          "variationId": "126057615"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692564",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869346",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266255",
                                          "variationId": "116400591"
                                        },
                                        {
                                          "groupId": "37266256",
                                          "variationId": "116400593"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266255",
                                          "variationId": "116400591"
                                        },
                                        {
                                          "groupId": "37266256",
                                          "variationId": "126057616"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692563",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266255",
                                          "variationId": "124962376"
                                        },
                                        {
                                          "groupId": "37266256",
                                          "variationId": "124962377"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692562",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869343",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439453",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439453",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439453",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439453",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439453",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439453",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439453",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439453",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439453",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439453",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439453",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439453",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439453",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151869343",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151869346",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439453",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692562",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692563",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692564",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859590",
                                "name": "Corn & Cheese",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | A combination of juicy sweet corn & 100% mozzarella cheese with flavourful signature pan sauce (PAN Per/Med-320 Kcal/100g | TnC-304 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "ckbnw98n6tffy50wvuzm",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266245",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400560",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266246",
                                            "variationId": "116400562"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400561",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266246",
                                            "variationId": "116400563"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962366",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266246",
                                            "variationId": "124962367"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266246",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 219,
                                          "default": 1,
                                          "id": "116400562",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 409,
                                          "id": "116400563",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 575,
                                          "id": "124962367",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 294,
                                          "id": "126057631",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 508,
                                          "id": "126057632",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266245",
                                          "variationId": "116400560"
                                        },
                                        {
                                          "groupId": "37266246",
                                          "variationId": "116400562"
                                        }
                                      ],
                                      "price": 21900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869243",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266245",
                                          "variationId": "116400560"
                                        },
                                        {
                                          "groupId": "37266246",
                                          "variationId": "126057631"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692549",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869243",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266245",
                                          "variationId": "116400561"
                                        },
                                        {
                                          "groupId": "37266246",
                                          "variationId": "116400563"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869245",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266245",
                                          "variationId": "116400561"
                                        },
                                        {
                                          "groupId": "37266246",
                                          "variationId": "126057632"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869245",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692548",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266245",
                                          "variationId": "124962366"
                                        },
                                        {
                                          "groupId": "37266246",
                                          "variationId": "124962367"
                                        }
                                      ],
                                      "price": 57500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692547",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869248",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439448",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439448",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439448",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439448",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439448",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439448",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439448",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439448",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439448",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439448",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439448",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439448",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439448",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151869243",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151869248",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439448",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692547",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692548",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692549",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859702",
                                "name": "Ultimate Tandoori Veggie",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | An ultimate combination of your favourite veggies-onion, green capsicum, mushroom, tomato, spicy jalapeno on tandoori sauce, topped with 100% mozzarella cheese & generous drizzle of mint mayo (PAN Per/Med-314 Kcal/100g | TnC-395 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "b7d1f56df6414f8b6e49001af95e259a",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266385",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116401062",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266387",
                                            "variationId": "116401065"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116401063",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266387",
                                            "variationId": "116401067"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962346",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266387",
                                            "variationId": "124962347"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266387",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 379,
                                          "default": 1,
                                          "id": "116401065",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 639,
                                          "id": "116401067",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 849,
                                          "id": "124962347",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 454,
                                          "id": "126057761",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 738,
                                          "id": "126057762",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266385",
                                          "variationId": "116401062"
                                        },
                                        {
                                          "groupId": "37266387",
                                          "variationId": "116401065"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151868970",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266385",
                                          "variationId": "116401062"
                                        },
                                        {
                                          "groupId": "37266387",
                                          "variationId": "126057761"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692670",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151868970",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266385",
                                          "variationId": "116401063"
                                        },
                                        {
                                          "groupId": "37266387",
                                          "variationId": "116401067"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151868974",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266385",
                                          "variationId": "116401063"
                                        },
                                        {
                                          "groupId": "37266387",
                                          "variationId": "126057762"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151868974",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692668",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266385",
                                          "variationId": "124962346"
                                        },
                                        {
                                          "groupId": "37266387",
                                          "variationId": "124962347"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692667",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151868976",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439438",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439438",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439438",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439438",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439438",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439438",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439438",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439438",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439438",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439438",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439438",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439438",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439438",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151868970",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151868976",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439438",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692667",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692668",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692670",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859591",
                                "name": "Veggie Feast",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Herbed onion and green capsicum, juicy sweet corn & 100% mozzarella cheese with flavourful pan sauce (PAN Per/Med-269 Kcal/100g | TnC-274 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "cbye9x7wxeopwqvenn7g",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266247",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400566",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266248",
                                            "variationId": "116400568"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400567",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266248",
                                            "variationId": "116400569"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962414",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266248",
                                            "variationId": "124962415"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266248",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 259,
                                          "default": 1,
                                          "id": "116400568",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 489,
                                          "id": "116400569",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 649,
                                          "id": "124962415",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 334,
                                          "id": "126057598",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 588,
                                          "id": "126057600",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266247",
                                          "variationId": "116400566"
                                        },
                                        {
                                          "groupId": "37266248",
                                          "variationId": "116400568"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869562",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266247",
                                          "variationId": "116400566"
                                        },
                                        {
                                          "groupId": "37266248",
                                          "variationId": "126057598"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692552",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869562",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266247",
                                          "variationId": "116400567"
                                        },
                                        {
                                          "groupId": "37266248",
                                          "variationId": "116400569"
                                        }
                                      ],
                                      "price": 48900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869567",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266247",
                                          "variationId": "116400567"
                                        },
                                        {
                                          "groupId": "37266248",
                                          "variationId": "126057600"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869567",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692551",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266247",
                                          "variationId": "124962414"
                                        },
                                        {
                                          "groupId": "37266248",
                                          "variationId": "124962415"
                                        }
                                      ],
                                      "price": 64900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692550",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869569",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439473",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439473",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439473",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439473",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439473",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439473",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439473",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439473",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439473",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439473",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439473",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439473",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439473",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151869562",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151869569",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439473",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692550",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692551",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692552",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859730",
                                "name": "Schezwan Margherita",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Your very own margherita, now with a spicy twist! Loaded with our signature spicy schezwan sauce & 100% mozzarella cheese (PAN Per/Med-300 Kcal/100g | TnC-309 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "0e7df98b7cffdb0b88856464014ad2ff",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266425",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116401198",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266426",
                                            "variationId": "116401200"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116401199",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266426",
                                            "variationId": "116401201"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962406",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266426",
                                            "variationId": "124962407"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266426",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 219,
                                          "default": 1,
                                          "id": "116401200",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 409,
                                          "id": "116401201",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 575,
                                          "id": "124962407",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 294,
                                          "id": "126057841",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 508,
                                          "id": "126057842",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266425",
                                          "variationId": "116401198"
                                        },
                                        {
                                          "groupId": "37266426",
                                          "variationId": "116401200"
                                        }
                                      ],
                                      "price": 21900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "150927424",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266425",
                                          "variationId": "116401198"
                                        },
                                        {
                                          "groupId": "37266426",
                                          "variationId": "126057841"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692701",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "150927424",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266425",
                                          "variationId": "116401199"
                                        },
                                        {
                                          "groupId": "37266426",
                                          "variationId": "116401201"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "150927425",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266425",
                                          "variationId": "116401199"
                                        },
                                        {
                                          "groupId": "37266426",
                                          "variationId": "126057842"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "150927425",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692700",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266425",
                                          "variationId": "124962406"
                                        },
                                        {
                                          "groupId": "37266426",
                                          "variationId": "124962407"
                                        }
                                      ],
                                      "price": 57500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692699",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "150927426",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439469",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439469",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439469",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439469",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439469",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439469",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439469",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439469",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439469",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439469",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439469",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439469",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439469",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "150927424",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "150927426",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439469",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692699",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692700",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692701",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859592",
                                "name": "Spiced Paneer",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Spiced paneer, crunchy onion, juicy tomato & 100% mozzarella cheese, with our classic pan sauce (PAN Per/Med-276 Kcal/100g | TnC-283 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "a89yqx09ppwlecyqterp",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266249",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400572",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266250",
                                            "variationId": "116400574"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400573",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266250",
                                            "variationId": "116400575"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962374",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266250",
                                            "variationId": "124962375"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266250",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 259,
                                          "default": 1,
                                          "id": "116400574",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 489,
                                          "id": "116400575",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 649,
                                          "id": "124962375",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 334,
                                          "id": "126057770",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 588,
                                          "id": "126057772",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266249",
                                          "variationId": "116400572"
                                        },
                                        {
                                          "groupId": "37266250",
                                          "variationId": "116400574"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869166",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266249",
                                          "variationId": "116400572"
                                        },
                                        {
                                          "groupId": "37266250",
                                          "variationId": "126057770"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692555",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869166",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266249",
                                          "variationId": "116400573"
                                        },
                                        {
                                          "groupId": "37266250",
                                          "variationId": "116400575"
                                        }
                                      ],
                                      "price": 48900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869168",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266249",
                                          "variationId": "116400573"
                                        },
                                        {
                                          "groupId": "37266250",
                                          "variationId": "126057772"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869168",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692554",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266249",
                                          "variationId": "124962374"
                                        },
                                        {
                                          "groupId": "37266250",
                                          "variationId": "124962375"
                                        }
                                      ],
                                      "price": 64900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692553",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869169",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439452",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439452",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439452",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439452",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439452",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439452",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439452",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439452",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439452",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439452",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439452",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439452",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439452",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151869166",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151869169",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439452",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692553",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692554",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692555",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859726",
                                "name": "Awesome American Cheesy",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Our divine peruvian flavoured cheesy sauce, topped with sweet corn, green capsicum, red paprika and 100% mozzarella cheese, finished with a generous drizzle of texas garlic sauce (PAN Per/Med-290 Kcal/100g | TnC-300 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "9bd233c76aaf2d2745c5c07332609a8c",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266423",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116401192",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266424",
                                            "variationId": "116401194"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116401193",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266424",
                                            "variationId": "116401195"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124962396",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266424",
                                            "variationId": "124962397"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266424",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 379,
                                          "default": 1,
                                          "id": "116401194",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 639,
                                          "id": "116401195",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 849,
                                          "id": "124962397",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 454,
                                          "id": "126057919",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 738,
                                          "id": "126057921",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266423",
                                          "variationId": "116401192"
                                        },
                                        {
                                          "groupId": "37266424",
                                          "variationId": "116401194"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869473",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266423",
                                          "variationId": "116401192"
                                        },
                                        {
                                          "groupId": "37266424",
                                          "variationId": "126057919"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "133692698",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "151869473",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266423",
                                          "variationId": "116401193"
                                        },
                                        {
                                          "groupId": "37266424",
                                          "variationId": "116401195"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869474",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266423",
                                          "variationId": "116401193"
                                        },
                                        {
                                          "groupId": "37266424",
                                          "variationId": "126057921"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869474",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "133692696",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266423",
                                          "variationId": "124962396"
                                        },
                                        {
                                          "groupId": "37266424",
                                          "variationId": "124962397"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692695",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "151869475",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439463",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140439463",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140439463",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140439463",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140439463",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140439463",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140439463",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140439463",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140439463",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140439463",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140439463",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140439463",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140439463",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151869473",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151869475",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140439463",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692695",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692696",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692698",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135326954",
                                "name": "Bold BBQ Veggies",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Our signature pan sauce, with BBQ Sauce drizzle, topped with mushroom, onion, green capsicum, & red paprika (PAN Per/Med-242 Kcal/100g | TnC-266 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "d4d697a58b3a97a46676fa8712e90ed7",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "39237178",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "124781099",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "39237179",
                                            "variationId": "124781102"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "124781100",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "39237179",
                                            "variationId": "124781103"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124781101",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "39237179",
                                            "variationId": "124781104"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "39237179",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 319,
                                          "default": 1,
                                          "id": "124781102",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 569,
                                          "id": "124781103",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 749,
                                          "id": "124781104",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 394,
                                          "id": "126057929",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 668,
                                          "id": "126057930",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "39237178",
                                          "variationId": "124781099"
                                        },
                                        {
                                          "groupId": "39237179",
                                          "variationId": "124781102"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "150927372",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "39237178",
                                          "variationId": "124781099"
                                        },
                                        {
                                          "groupId": "39237179",
                                          "variationId": "126057929"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193878"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "150927376",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "150927372",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "39237178",
                                          "variationId": "124781100"
                                        },
                                        {
                                          "groupId": "39237179",
                                          "variationId": "124781103"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "150927373",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "39237178",
                                          "variationId": "124781100"
                                        },
                                        {
                                          "groupId": "39237179",
                                          "variationId": "126057930"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "150927373",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "150927375",
                                          "addonId": "112193866"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "39237178",
                                          "variationId": "124781101"
                                        },
                                        {
                                          "groupId": "39237179",
                                          "variationId": "124781104"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "150927374",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140233255",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "140233255",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "140233255",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "140233255",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "140233255",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "140233255",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "140233255",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "140233255",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "140233255",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "140233255",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "140233255",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "140233255",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "140233255",
                                          "addonId": "114785294"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "150927372",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "150927374",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140233255",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "150927375",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "150927376",
                                    "groupName": "Add. Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193878",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Non Veg Pizza",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859601",
                                "name": "Chicken Tikka",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Mouth-watering chicken tikka, crunchy onion & tomato with delicious tandoori sauce and 100% mozzarella cheese (PAN Per/Med-275 Kcal/100g | TnC-283 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "juplqft4tmub5hqocwxk",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266267",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400632",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266268",
                                            "variationId": "116400634"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400633",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266268",
                                            "variationId": "116400635"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124780879",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266268",
                                            "variationId": "124780881"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266268",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 379,
                                          "default": 1,
                                          "id": "116400634",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 639,
                                          "id": "116400635",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 454,
                                          "id": "116400636",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 738,
                                          "id": "116400637",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 849,
                                          "id": "124780881",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 454,
                                          "id": "126057701",
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 738,
                                          "id": "126057702",
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266267",
                                          "variationId": "116400632"
                                        },
                                        {
                                          "groupId": "37266268",
                                          "variationId": "116400634"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144159",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266267",
                                          "variationId": "116400632"
                                        },
                                        {
                                          "groupId": "37266268",
                                          "variationId": "116400636"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144173",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144159",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266267",
                                          "variationId": "116400632"
                                        },
                                        {
                                          "groupId": "37266268",
                                          "variationId": "126057701"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692581",
                                          "addonId": "112193846"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266267",
                                          "variationId": "116400633"
                                        },
                                        {
                                          "groupId": "37266268",
                                          "variationId": "116400635"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144160",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266267",
                                          "variationId": "116400633"
                                        },
                                        {
                                          "groupId": "37266268",
                                          "variationId": "116400637"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144160",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266267",
                                          "variationId": "116400633"
                                        },
                                        {
                                          "groupId": "37266268",
                                          "variationId": "126057702"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144160",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144184",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692582",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266267",
                                          "variationId": "124780879"
                                        },
                                        {
                                          "groupId": "37266268",
                                          "variationId": "124780881"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692580",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144161",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144166",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "152144166",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144166",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "152144166",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "152144166",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "152144166",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "152144166",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "152144166",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "152144166",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "152144166",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "152144166",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "152144166",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "152144166",
                                          "addonId": "114785294"
                                        },
                                        {
                                          "groupId": "140233218",
                                          "addonId": "114785291"
                                        },
                                        {
                                          "groupId": "140233218",
                                          "addonId": "114785295"
                                        },
                                        {
                                          "groupId": "140233218",
                                          "addonId": "114785296"
                                        },
                                        {
                                          "groupId": "140233218",
                                          "addonId": "114785305"
                                        },
                                        {
                                          "groupId": "140233218",
                                          "addonId": "114785306"
                                        },
                                        {
                                          "groupId": "140233218",
                                          "addonId": "114785307"
                                        },
                                        {
                                          "groupId": "140233218",
                                          "addonId": "114785304"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "152144159",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144161",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140233218",
                                    "groupName": "Add Non Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "114785291",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785295",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785296",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785305",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785306",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785307",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785304",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144166",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144173",
                                    "groupName": "Add Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692581",
                                    "groupName": "Add Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193837",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193876",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193869",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193864",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193835",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193868",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193846",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692580",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144184",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692582",
                                    "groupName": "Add. Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193847",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193875",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193879",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193862",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193834",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193836",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193874",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859603",
                                "name": "Chicken Tikka Supreme",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | A divine combination of delicious chicken tikka & malai chicken tikka, onion, spicy red paprika with flavourful pan sauce and 100% mozzarella cheese (PAN Per/Med-267 Kcal/100g |TnC-274 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "d3bnas8nxt9dr13jhipu",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266271",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400648",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266272",
                                            "variationId": "116400650"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400649",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266272",
                                            "variationId": "116400651"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124780658",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266272",
                                            "variationId": "124780662"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266272",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 409,
                                          "default": 1,
                                          "id": "116400650",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 699,
                                          "id": "116400651",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 484,
                                          "id": "116400652",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 798,
                                          "id": "116400653",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 949,
                                          "id": "124780662",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 484,
                                          "id": "126057825",
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 798,
                                          "id": "126057826",
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266271",
                                          "variationId": "116400648"
                                        },
                                        {
                                          "groupId": "37266272",
                                          "variationId": "116400650"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144679",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266271",
                                          "variationId": "116400648"
                                        },
                                        {
                                          "groupId": "37266272",
                                          "variationId": "116400652"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144679",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266271",
                                          "variationId": "116400648"
                                        },
                                        {
                                          "groupId": "37266272",
                                          "variationId": "126057825"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144687",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692587",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144679",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266271",
                                          "variationId": "116400649"
                                        },
                                        {
                                          "groupId": "37266272",
                                          "variationId": "116400651"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144681",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266271",
                                          "variationId": "116400649"
                                        },
                                        {
                                          "groupId": "37266272",
                                          "variationId": "116400653"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144681",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266271",
                                          "variationId": "116400649"
                                        },
                                        {
                                          "groupId": "37266272",
                                          "variationId": "126057826"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144681",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144691",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692588",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266271",
                                          "variationId": "124780658"
                                        },
                                        {
                                          "groupId": "37266272",
                                          "variationId": "124780662"
                                        }
                                      ],
                                      "price": 94900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692586",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144683",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144685",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "152144685",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144685",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "152144685",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "152144685",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "152144685",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "152144685",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "152144685",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "152144685",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "152144685",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "152144685",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "152144685",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "152144685",
                                          "addonId": "114785294"
                                        },
                                        {
                                          "groupId": "140233178",
                                          "addonId": "114785291"
                                        },
                                        {
                                          "groupId": "140233178",
                                          "addonId": "114785295"
                                        },
                                        {
                                          "groupId": "140233178",
                                          "addonId": "114785296"
                                        },
                                        {
                                          "groupId": "140233178",
                                          "addonId": "114785305"
                                        },
                                        {
                                          "groupId": "140233178",
                                          "addonId": "114785306"
                                        },
                                        {
                                          "groupId": "140233178",
                                          "addonId": "114785307"
                                        },
                                        {
                                          "groupId": "140233178",
                                          "addonId": "114785304"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "152144679",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144683",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140233178",
                                    "groupName": "Add Non Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "114785291",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785295",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785296",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785305",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785306",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785307",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785304",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144685",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144687",
                                    "groupName": "Add Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692587",
                                    "groupName": "Add Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193837",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193876",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193869",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193864",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193835",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193868",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193846",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692586",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144691",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692588",
                                    "groupName": "Add. Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193847",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193875",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193879",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193862",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193834",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193836",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193874",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 40900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859600",
                                "name": "Murg Malai Chicken",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Amazingly flavourful chicken malai tikka, herbed onion & green capsicum, spicy red paprika with flavourful pan sauce and 100% mozzarella cheese (PAN Per/Med-269 Kcal/100g | TnC-299 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "t1stinhga3alitdpr6yt",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266265",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400624",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266266",
                                            "variationId": "116400626"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400625",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266266",
                                            "variationId": "116400627"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124780555",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266266",
                                            "variationId": "124780556"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266266",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 379,
                                          "default": 1,
                                          "id": "116400626",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 639,
                                          "id": "116400627",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 454,
                                          "id": "116400628",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 738,
                                          "id": "116400629",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 849,
                                          "id": "124780556",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 454,
                                          "id": "126057911",
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 738,
                                          "id": "126057912",
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266265",
                                          "variationId": "116400624"
                                        },
                                        {
                                          "groupId": "37266266",
                                          "variationId": "116400626"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152143987",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266265",
                                          "variationId": "116400624"
                                        },
                                        {
                                          "groupId": "37266266",
                                          "variationId": "116400628"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152143987",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266265",
                                          "variationId": "116400624"
                                        },
                                        {
                                          "groupId": "37266266",
                                          "variationId": "126057911"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152143991",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692578",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152143987",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266265",
                                          "variationId": "116400625"
                                        },
                                        {
                                          "groupId": "37266266",
                                          "variationId": "116400627"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152143988",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266265",
                                          "variationId": "116400625"
                                        },
                                        {
                                          "groupId": "37266266",
                                          "variationId": "116400629"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152143988",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266265",
                                          "variationId": "116400625"
                                        },
                                        {
                                          "groupId": "37266266",
                                          "variationId": "126057912"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152143988",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152143994",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692579",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266265",
                                          "variationId": "124780555"
                                        },
                                        {
                                          "groupId": "37266266",
                                          "variationId": "124780556"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692577",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152143989",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152143990",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "152143990",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152143990",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "152143990",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "152143990",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "152143990",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "152143990",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "152143990",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "152143990",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "152143990",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "152143990",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "152143990",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "152143990",
                                          "addonId": "114785294"
                                        },
                                        {
                                          "groupId": "140233165",
                                          "addonId": "114785291"
                                        },
                                        {
                                          "groupId": "140233165",
                                          "addonId": "114785295"
                                        },
                                        {
                                          "groupId": "140233165",
                                          "addonId": "114785296"
                                        },
                                        {
                                          "groupId": "140233165",
                                          "addonId": "114785305"
                                        },
                                        {
                                          "groupId": "140233165",
                                          "addonId": "114785306"
                                        },
                                        {
                                          "groupId": "140233165",
                                          "addonId": "114785307"
                                        },
                                        {
                                          "groupId": "140233165",
                                          "addonId": "114785304"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "152143987",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152143989",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140233165",
                                    "groupName": "Add Non Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "114785291",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785295",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785296",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785305",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785306",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785307",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785304",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152143990",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152143991",
                                    "groupName": "Add Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692578",
                                    "groupName": "Add Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193837",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193876",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193869",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193864",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193835",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193868",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193846",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692577",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152143994",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692579",
                                    "groupName": "Add. Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193847",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193875",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193879",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193862",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193834",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193836",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193874",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859604",
                                "name": "Chicken Supreme",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Loaded with delicious chicken tikka, flavourful herbed chicken, spicy schezwan chicken meatball with flavourful pan sauce and 100% mozzarella cheese. (PAN Per/Med-273 Kcal/100g | TnC-284 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "dlvdmsn1uotbdn4vzvap",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266273",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400656",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266274",
                                            "variationId": "116400658"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400657",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266274",
                                            "variationId": "116400659"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124780636",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266274",
                                            "variationId": "124780638"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266274",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 409,
                                          "default": 1,
                                          "id": "116400658",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 699,
                                          "id": "116400659",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 484,
                                          "id": "116400660",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 798,
                                          "id": "116400661",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 949,
                                          "id": "124780638",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 484,
                                          "id": "126057559",
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 798,
                                          "id": "126057560",
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266273",
                                          "variationId": "116400656"
                                        },
                                        {
                                          "groupId": "37266274",
                                          "variationId": "116400658"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144540",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266273",
                                          "variationId": "116400656"
                                        },
                                        {
                                          "groupId": "37266274",
                                          "variationId": "116400660"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144540",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266273",
                                          "variationId": "116400656"
                                        },
                                        {
                                          "groupId": "37266274",
                                          "variationId": "126057559"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144551",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692590",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144540",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266273",
                                          "variationId": "116400657"
                                        },
                                        {
                                          "groupId": "37266274",
                                          "variationId": "116400659"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144543",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266273",
                                          "variationId": "116400657"
                                        },
                                        {
                                          "groupId": "37266274",
                                          "variationId": "116400661"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144543",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266273",
                                          "variationId": "116400657"
                                        },
                                        {
                                          "groupId": "37266274",
                                          "variationId": "126057560"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144543",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144558",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692591",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266273",
                                          "variationId": "124780636"
                                        },
                                        {
                                          "groupId": "37266274",
                                          "variationId": "124780638"
                                        }
                                      ],
                                      "price": 94900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692589",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144546",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144549",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "152144549",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144549",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "152144549",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "152144549",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "152144549",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "152144549",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "152144549",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "152144549",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "152144549",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "152144549",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "152144549",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "152144549",
                                          "addonId": "114785294"
                                        },
                                        {
                                          "groupId": "140233176",
                                          "addonId": "114785291"
                                        },
                                        {
                                          "groupId": "140233176",
                                          "addonId": "114785295"
                                        },
                                        {
                                          "groupId": "140233176",
                                          "addonId": "114785296"
                                        },
                                        {
                                          "groupId": "140233176",
                                          "addonId": "114785305"
                                        },
                                        {
                                          "groupId": "140233176",
                                          "addonId": "114785306"
                                        },
                                        {
                                          "groupId": "140233176",
                                          "addonId": "114785307"
                                        },
                                        {
                                          "groupId": "140233176",
                                          "addonId": "114785304"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "152144540",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144546",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140233176",
                                    "groupName": "Add Non Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "114785291",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785295",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785296",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785305",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785306",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785307",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785304",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144549",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144551",
                                    "groupName": "Add Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692590",
                                    "groupName": "Add Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193837",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193876",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193869",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193864",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193835",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193868",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193846",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692589",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144558",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692591",
                                    "groupName": "Add. Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193847",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193875",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193879",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193862",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193834",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193836",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193874",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 40900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859599",
                                "name": "Chicken Pepperoni",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Yummy chicken pepperoni & 100% mozzarella cheese with signature pan sauce. Its a classic! (PAN Per/Med-301 Kcal/100g | TnC-311 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "gdz44c9hirco09bdafoq",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266263",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400616",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266264",
                                            "variationId": "116400618"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400617",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266264",
                                            "variationId": "116400619"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124780453",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266264",
                                            "variationId": "124780458"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266264",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 379,
                                          "default": 1,
                                          "id": "116400618",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 639,
                                          "id": "116400619",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 454,
                                          "id": "116400620",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 738,
                                          "id": "116400621",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 849,
                                          "id": "124780458",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 454,
                                          "id": "126057893",
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 738,
                                          "id": "126057894",
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266263",
                                          "variationId": "116400616"
                                        },
                                        {
                                          "groupId": "37266264",
                                          "variationId": "116400618"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144469",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266263",
                                          "variationId": "116400616"
                                        },
                                        {
                                          "groupId": "37266264",
                                          "variationId": "116400620"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144469",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266263",
                                          "variationId": "116400616"
                                        },
                                        {
                                          "groupId": "37266264",
                                          "variationId": "126057893"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144481",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692575",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144469",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266263",
                                          "variationId": "116400617"
                                        },
                                        {
                                          "groupId": "37266264",
                                          "variationId": "116400619"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144471",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266263",
                                          "variationId": "116400617"
                                        },
                                        {
                                          "groupId": "37266264",
                                          "variationId": "116400621"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144471",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266263",
                                          "variationId": "116400617"
                                        },
                                        {
                                          "groupId": "37266264",
                                          "variationId": "126057894"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144471",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144486",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692576",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266263",
                                          "variationId": "124780453"
                                        },
                                        {
                                          "groupId": "37266264",
                                          "variationId": "124780458"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692574",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144473",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144476",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "152144476",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144476",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "152144476",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "152144476",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "152144476",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "152144476",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "152144476",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "152144476",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "152144476",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "152144476",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "152144476",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "152144476",
                                          "addonId": "114785294"
                                        },
                                        {
                                          "groupId": "140233146",
                                          "addonId": "114785291"
                                        },
                                        {
                                          "groupId": "140233146",
                                          "addonId": "114785295"
                                        },
                                        {
                                          "groupId": "140233146",
                                          "addonId": "114785296"
                                        },
                                        {
                                          "groupId": "140233146",
                                          "addonId": "114785305"
                                        },
                                        {
                                          "groupId": "140233146",
                                          "addonId": "114785306"
                                        },
                                        {
                                          "groupId": "140233146",
                                          "addonId": "114785307"
                                        },
                                        {
                                          "groupId": "140233146",
                                          "addonId": "114785304"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "152144469",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144473",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140233146",
                                    "groupName": "Add Non Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "114785291",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785295",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785296",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785305",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785306",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785307",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785304",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144476",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144481",
                                    "groupName": "Add Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692575",
                                    "groupName": "Add Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193837",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193876",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193869",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193864",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193835",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193868",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193846",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692574",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144486",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692576",
                                    "groupName": "Add. Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193847",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193875",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193879",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193862",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193834",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193836",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193874",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859602",
                                "name": "Triple Chicken Feast",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Spicy schezwan chicken meatball, flavourful herbed chicken, juicy chicken sausage, green capsicum & onion, spicy red paprika with classic pan sauce and 100% mozzarella cheese (PAN Per/Med-262 Kcal/100g | TnC-277 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "quxirmjttzksp7xlhysc",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266269",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400640",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266270",
                                            "variationId": "116400642"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400641",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266270",
                                            "variationId": "116400643"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124781073",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266270",
                                            "variationId": "124781074"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266270",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 409,
                                          "default": 1,
                                          "id": "116400642",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 699,
                                          "id": "116400643",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 484,
                                          "id": "116400644",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 798,
                                          "id": "116400645",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 949,
                                          "id": "124781074",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 484,
                                          "id": "126057733",
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 798,
                                          "id": "126057735",
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266269",
                                          "variationId": "116400640"
                                        },
                                        {
                                          "groupId": "37266270",
                                          "variationId": "116400642"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144590",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266269",
                                          "variationId": "116400640"
                                        },
                                        {
                                          "groupId": "37266270",
                                          "variationId": "116400644"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144590",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266269",
                                          "variationId": "116400640"
                                        },
                                        {
                                          "groupId": "37266270",
                                          "variationId": "126057733"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144594",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692584",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144590",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266269",
                                          "variationId": "116400641"
                                        },
                                        {
                                          "groupId": "37266270",
                                          "variationId": "116400643"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144591",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266269",
                                          "variationId": "116400641"
                                        },
                                        {
                                          "groupId": "37266270",
                                          "variationId": "116400645"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144591",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266269",
                                          "variationId": "116400641"
                                        },
                                        {
                                          "groupId": "37266270",
                                          "variationId": "126057735"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144591",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144596",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692585",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266269",
                                          "variationId": "124781073"
                                        },
                                        {
                                          "groupId": "37266270",
                                          "variationId": "124781074"
                                        }
                                      ],
                                      "price": 94900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692583",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144592",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144593",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "152144593",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144593",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "152144593",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "152144593",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "152144593",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "152144593",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "152144593",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "152144593",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "152144593",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "152144593",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "152144593",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "152144593",
                                          "addonId": "114785294"
                                        },
                                        {
                                          "groupId": "140233247",
                                          "addonId": "114785291"
                                        },
                                        {
                                          "groupId": "140233247",
                                          "addonId": "114785295"
                                        },
                                        {
                                          "groupId": "140233247",
                                          "addonId": "114785296"
                                        },
                                        {
                                          "groupId": "140233247",
                                          "addonId": "114785305"
                                        },
                                        {
                                          "groupId": "140233247",
                                          "addonId": "114785306"
                                        },
                                        {
                                          "groupId": "140233247",
                                          "addonId": "114785307"
                                        },
                                        {
                                          "groupId": "140233247",
                                          "addonId": "114785304"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "152144590",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144592",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140233247",
                                    "groupName": "Add Non Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "114785291",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785295",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785296",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785305",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785306",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785307",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785304",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144593",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144594",
                                    "groupName": "Add Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692584",
                                    "groupName": "Add Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193837",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193876",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193869",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193864",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193835",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193868",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193846",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692583",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144596",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692585",
                                    "groupName": "Add. Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193847",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193875",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193879",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193862",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193834",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193836",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193874",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 40900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859688",
                                "name": "Nawabi Murg Makhni",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | A chicken lovers delight! Combination of chicken malai tikka, flavourful chicken keema masala, crunchy onion, juicy tomato on our new makhni sauce with 100% mozzarella cheese and buttery spice sprinkle (PAN Per/Med-252 Kcal/100g | TnC-269 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "eb7467f9836bde6741eff6cf81b996da",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266369",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116401032",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266370",
                                            "variationId": "116401034"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116401033",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266370",
                                            "variationId": "116401035"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124780852",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266370",
                                            "variationId": "124780855"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266370",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 409,
                                          "default": 1,
                                          "id": "116401034",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 699,
                                          "id": "116401035",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 484,
                                          "id": "116401038",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 798,
                                          "id": "116401039",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 949,
                                          "id": "124780855",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 484,
                                          "id": "126057747",
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 798,
                                          "id": "126057748",
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266369",
                                          "variationId": "116401032"
                                        },
                                        {
                                          "groupId": "37266370",
                                          "variationId": "116401034"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144439",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266369",
                                          "variationId": "116401032"
                                        },
                                        {
                                          "groupId": "37266370",
                                          "variationId": "126057747"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144439",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266369",
                                          "variationId": "116401032"
                                        },
                                        {
                                          "groupId": "37266370",
                                          "variationId": "116401038"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144450",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692653",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144439",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266369",
                                          "variationId": "116401033"
                                        },
                                        {
                                          "groupId": "37266370",
                                          "variationId": "116401035"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144442",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266369",
                                          "variationId": "116401033"
                                        },
                                        {
                                          "groupId": "37266370",
                                          "variationId": "126057748"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144442",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266369",
                                          "variationId": "116401033"
                                        },
                                        {
                                          "groupId": "37266370",
                                          "variationId": "116401039"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144442",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144451",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692654",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266369",
                                          "variationId": "124780852"
                                        },
                                        {
                                          "groupId": "37266370",
                                          "variationId": "124780855"
                                        }
                                      ],
                                      "price": 94900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692652",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144444",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144448",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "152144448",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144448",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "152144448",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "152144448",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "152144448",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "152144448",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "152144448",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "152144448",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "152144448",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "152144448",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "152144448",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "152144448",
                                          "addonId": "114785294"
                                        },
                                        {
                                          "groupId": "140233208",
                                          "addonId": "114785291"
                                        },
                                        {
                                          "groupId": "140233208",
                                          "addonId": "114785295"
                                        },
                                        {
                                          "groupId": "140233208",
                                          "addonId": "114785296"
                                        },
                                        {
                                          "groupId": "140233208",
                                          "addonId": "114785305"
                                        },
                                        {
                                          "groupId": "140233208",
                                          "addonId": "114785306"
                                        },
                                        {
                                          "groupId": "140233208",
                                          "addonId": "114785307"
                                        },
                                        {
                                          "groupId": "140233208",
                                          "addonId": "114785304"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "152144439",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144444",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140233208",
                                    "groupName": "Add Non Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "114785291",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785295",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785296",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785305",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785306",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785307",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785304",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144448",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144450",
                                    "groupName": "Add Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692653",
                                    "groupName": "Add Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193837",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193876",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193869",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193864",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193835",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193868",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193846",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692652",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144451",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692654",
                                    "groupName": "Add. Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193847",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193875",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193879",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193862",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193834",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193836",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193874",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 40900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859713",
                                "name": "Sizzling Schezwan Chicken",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Loaded with our signature spicy schezwan sauce, juicy schezwan chicken meatballs & 100% mozzarella cheese (PAN Per/Med-277 Kcal/100g | TnC-286 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "4061af0525c00c89f0d1edbe7216765c",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266405",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116401116",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266406",
                                            "variationId": "116401118"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116401117",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266406",
                                            "variationId": "116401119"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124780591",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266406",
                                            "variationId": "124780596"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266406",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 319,
                                          "default": 1,
                                          "id": "116401118",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 569,
                                          "id": "116401119",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 394,
                                          "id": "116401122",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 668,
                                          "id": "116401123",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 749,
                                          "id": "124780596",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 394,
                                          "id": "126057908",
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 668,
                                          "id": "126057910",
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266405",
                                          "variationId": "116401116"
                                        },
                                        {
                                          "groupId": "37266406",
                                          "variationId": "116401118"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144408",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266405",
                                          "variationId": "116401116"
                                        },
                                        {
                                          "groupId": "37266406",
                                          "variationId": "126057908"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144408",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266405",
                                          "variationId": "116401116"
                                        },
                                        {
                                          "groupId": "37266406",
                                          "variationId": "116401122"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144423",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692684",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144408",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266405",
                                          "variationId": "116401117"
                                        },
                                        {
                                          "groupId": "37266406",
                                          "variationId": "116401119"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144409",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266405",
                                          "variationId": "116401117"
                                        },
                                        {
                                          "groupId": "37266406",
                                          "variationId": "126057910"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144409",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266405",
                                          "variationId": "116401117"
                                        },
                                        {
                                          "groupId": "37266406",
                                          "variationId": "116401123"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144409",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144426",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692685",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266405",
                                          "variationId": "124780591"
                                        },
                                        {
                                          "groupId": "37266406",
                                          "variationId": "124780596"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692682",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144412",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144419",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "152144419",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144419",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "152144419",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "152144419",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "152144419",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "152144419",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "152144419",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "152144419",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "152144419",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "152144419",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "152144419",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "152144419",
                                          "addonId": "114785294"
                                        },
                                        {
                                          "groupId": "140233170",
                                          "addonId": "114785291"
                                        },
                                        {
                                          "groupId": "140233170",
                                          "addonId": "114785295"
                                        },
                                        {
                                          "groupId": "140233170",
                                          "addonId": "114785296"
                                        },
                                        {
                                          "groupId": "140233170",
                                          "addonId": "114785305"
                                        },
                                        {
                                          "groupId": "140233170",
                                          "addonId": "114785306"
                                        },
                                        {
                                          "groupId": "140233170",
                                          "addonId": "114785307"
                                        },
                                        {
                                          "groupId": "140233170",
                                          "addonId": "114785304"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "152144408",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144412",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140233170",
                                    "groupName": "Add Non Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "114785291",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785295",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785296",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785305",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785306",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785307",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785304",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144419",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144423",
                                    "groupName": "Add Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692684",
                                    "groupName": "Add Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193837",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193876",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193869",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193864",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193835",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193868",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193846",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692682",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144426",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692685",
                                    "groupName": "Add. Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193847",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193875",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193879",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193862",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193834",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193836",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193874",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859721",
                                "name": "Awesome American Cheesy Chicken",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Our divine peruvian flavoured cheesy sauce, topped with classic chicken pepperoni, cheese and chicken sausage black olives, spicy jalapeno and 100% mozzarella cheese, finished with a generous drizzle of texas garlic sauce. (PAN Per/Med-297 Kcal/100g | TnC-301 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "f55016931d13f7489c6140de76fa16aa",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266413",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116401160",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266414",
                                            "variationId": "116401162"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116401161",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266414",
                                            "variationId": "116401163"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124781041",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266414",
                                            "variationId": "124781042"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266414",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 379,
                                          "default": 1,
                                          "id": "116401162",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 639,
                                          "id": "116401163",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 454,
                                          "id": "116401166",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 738,
                                          "id": "116401167",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 949,
                                          "id": "124781042",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 454,
                                          "id": "126057639",
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 738,
                                          "id": "126057640",
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266413",
                                          "variationId": "116401160"
                                        },
                                        {
                                          "groupId": "37266414",
                                          "variationId": "116401162"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144237",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266413",
                                          "variationId": "116401160"
                                        },
                                        {
                                          "groupId": "37266414",
                                          "variationId": "126057639"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144237",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266413",
                                          "variationId": "116401160"
                                        },
                                        {
                                          "groupId": "37266414",
                                          "variationId": "116401166"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144252",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692690",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144237",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266413",
                                          "variationId": "116401161"
                                        },
                                        {
                                          "groupId": "37266414",
                                          "variationId": "116401163"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144240",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266413",
                                          "variationId": "116401161"
                                        },
                                        {
                                          "groupId": "37266414",
                                          "variationId": "126057640"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144240",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266413",
                                          "variationId": "116401161"
                                        },
                                        {
                                          "groupId": "37266414",
                                          "variationId": "116401167"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144240",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144258",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692691",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266413",
                                          "variationId": "124781041"
                                        },
                                        {
                                          "groupId": "37266414",
                                          "variationId": "124781042"
                                        }
                                      ],
                                      "price": 94900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692689",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144242",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144248",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "152144248",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144248",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "152144248",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "152144248",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "152144248",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "152144248",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "152144248",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "152144248",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "152144248",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "152144248",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "152144248",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "152144248",
                                          "addonId": "114785294"
                                        },
                                        {
                                          "groupId": "140233238",
                                          "addonId": "114785291"
                                        },
                                        {
                                          "groupId": "140233238",
                                          "addonId": "114785295"
                                        },
                                        {
                                          "groupId": "140233238",
                                          "addonId": "114785296"
                                        },
                                        {
                                          "groupId": "140233238",
                                          "addonId": "114785305"
                                        },
                                        {
                                          "groupId": "140233238",
                                          "addonId": "114785306"
                                        },
                                        {
                                          "groupId": "140233238",
                                          "addonId": "114785307"
                                        },
                                        {
                                          "groupId": "140233238",
                                          "addonId": "114785304"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "152144237",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144242",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140233238",
                                    "groupName": "Add Non Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "114785291",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785295",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785296",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785305",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785306",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785307",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785304",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144248",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144252",
                                    "groupName": "Add Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692690",
                                    "groupName": "Add Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193837",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193876",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193869",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193864",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193835",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193868",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193846",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692689",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144258",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692691",
                                    "groupName": "Add. Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193847",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193875",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193879",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193862",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193834",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193836",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193874",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859598",
                                "name": "Chicken Sausage",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Pizza topped with chicken n cheese sausages & crunchy onions, flavourful pan sauce and 100% mozzarella cheese (PAN Per/Med-310 Kcal/100g | TnC-312 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "aylqpxx08pltowbzxhd3",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266261",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116400608",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266262",
                                            "variationId": "116400610"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116400609",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266262",
                                            "variationId": "116400611"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124780743",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266262",
                                            "variationId": "124780748"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266262",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 259,
                                          "default": 1,
                                          "id": "116400610",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 489,
                                          "id": "116400611",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 334,
                                          "id": "116400612",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 588,
                                          "id": "116400613",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 649,
                                          "id": "124780748",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 334,
                                          "id": "126057765",
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 588,
                                          "id": "126057766",
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266261",
                                          "variationId": "116400608"
                                        },
                                        {
                                          "groupId": "37266262",
                                          "variationId": "116400610"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144208",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266261",
                                          "variationId": "116400608"
                                        },
                                        {
                                          "groupId": "37266262",
                                          "variationId": "116400612"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144208",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266261",
                                          "variationId": "116400608"
                                        },
                                        {
                                          "groupId": "37266262",
                                          "variationId": "126057765"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144213",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692572",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144208",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266261",
                                          "variationId": "116400609"
                                        },
                                        {
                                          "groupId": "37266262",
                                          "variationId": "116400611"
                                        }
                                      ],
                                      "price": 48900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144209",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266261",
                                          "variationId": "116400609"
                                        },
                                        {
                                          "groupId": "37266262",
                                          "variationId": "116400613"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144209",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266261",
                                          "variationId": "116400609"
                                        },
                                        {
                                          "groupId": "37266262",
                                          "variationId": "126057766"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144209",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144220",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692573",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266261",
                                          "variationId": "124780743"
                                        },
                                        {
                                          "groupId": "37266262",
                                          "variationId": "124780748"
                                        }
                                      ],
                                      "price": 64900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692571",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144210",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144211",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "152144211",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144211",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "152144211",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "152144211",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "152144211",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "152144211",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "152144211",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "152144211",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "152144211",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "152144211",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "152144211",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "152144211",
                                          "addonId": "114785294"
                                        },
                                        {
                                          "groupId": "140233188",
                                          "addonId": "114785291"
                                        },
                                        {
                                          "groupId": "140233188",
                                          "addonId": "114785295"
                                        },
                                        {
                                          "groupId": "140233188",
                                          "addonId": "114785296"
                                        },
                                        {
                                          "groupId": "140233188",
                                          "addonId": "114785305"
                                        },
                                        {
                                          "groupId": "140233188",
                                          "addonId": "114785306"
                                        },
                                        {
                                          "groupId": "140233188",
                                          "addonId": "114785307"
                                        },
                                        {
                                          "groupId": "140233188",
                                          "addonId": "114785304"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "152144208",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144210",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140233188",
                                    "groupName": "Add Non Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "114785291",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785295",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785296",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785305",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785306",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785307",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785304",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144211",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144213",
                                    "groupName": "Add Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692572",
                                    "groupName": "Add Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193837",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193876",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193869",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193864",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193835",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193868",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193846",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692571",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144220",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692573",
                                    "groupName": "Add. Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193847",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193875",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193879",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193862",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193834",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193836",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193874",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859706",
                                "name": "Dhabe Da Keema",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Dhaba style chicken keema masala, with green chiili, crunchy onion with flavourful pan sauce, 100 % mozzarella cheese & a generous drizzle of mint mayo (PAN Per/Med-270 Kcal/100g | TnC-290 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "d9eddb1993da4e5dc65ef2ceaa8503f7",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266393",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116401074",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266394",
                                            "variationId": "116401076"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116401075",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266394",
                                            "variationId": "116401077"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124781089",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266394",
                                            "variationId": "124781092"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266394",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 319,
                                          "default": 1,
                                          "id": "116401076",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 569,
                                          "id": "116401077",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 394,
                                          "id": "116401080",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 668,
                                          "id": "116401081",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 749,
                                          "id": "124781092",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 394,
                                          "id": "126057811",
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 668,
                                          "id": "126057812",
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266393",
                                          "variationId": "116401074"
                                        },
                                        {
                                          "groupId": "37266394",
                                          "variationId": "116401076"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152143876",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152143876",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152143876",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152143876",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152143876",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152143876",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152143876",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152143876",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152143876",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152143876",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152143876",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152143873",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266393",
                                          "variationId": "116401074"
                                        },
                                        {
                                          "groupId": "37266394",
                                          "variationId": "126057811"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193846"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266393",
                                          "variationId": "116401074"
                                        },
                                        {
                                          "groupId": "37266394",
                                          "variationId": "116401080"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692673",
                                          "addonId": "112193846"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266393",
                                          "variationId": "116401075"
                                        },
                                        {
                                          "groupId": "37266394",
                                          "variationId": "116401077"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266393",
                                          "variationId": "116401075"
                                        },
                                        {
                                          "groupId": "37266394",
                                          "variationId": "126057812"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266393",
                                          "variationId": "116401075"
                                        },
                                        {
                                          "groupId": "37266394",
                                          "variationId": "116401081"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692675",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266393",
                                          "variationId": "124781089"
                                        },
                                        {
                                          "groupId": "37266394",
                                          "variationId": "124781092"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692672",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152143874",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152143875",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "152143875",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152143875",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "152143875",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "152143875",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "152143875",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "152143875",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "152143875",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "152143875",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "152143875",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "152143875",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "152143875",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "152143875",
                                          "addonId": "114785294"
                                        },
                                        {
                                          "groupId": "140233252",
                                          "addonId": "114785291"
                                        },
                                        {
                                          "groupId": "140233252",
                                          "addonId": "114785295"
                                        },
                                        {
                                          "groupId": "140233252",
                                          "addonId": "114785296"
                                        },
                                        {
                                          "groupId": "140233252",
                                          "addonId": "114785305"
                                        },
                                        {
                                          "groupId": "140233252",
                                          "addonId": "114785306"
                                        },
                                        {
                                          "groupId": "140233252",
                                          "addonId": "114785307"
                                        },
                                        {
                                          "groupId": "140233252",
                                          "addonId": "114785304"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "152143873",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152143874",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140233252",
                                    "groupName": "Add Non Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "114785291",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785295",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785296",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785305",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785306",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785307",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785304",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152143875",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152143876",
                                    "groupName": "Add Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692673",
                                    "groupName": "Add Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193837",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193876",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193869",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193864",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193835",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193868",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193846",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692672",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692675",
                                    "groupName": "Add. Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193847",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193875",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193879",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193862",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193834",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193836",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193874",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859718",
                                "name": "Sausage & Sweet Corn.",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Our classic chicken & cheese sausage, juicy sweet corn and 100% mozzarella cheese with flavourful pan sauce (PAN Per/Med-277 Kcal/100g | TnC-282 Kcal/100g | Stuffed Crust Add : Per: 227 Kcal/100g | Med: 216 Kcal/100g | Stuff Crust Chicken Seekh Kebab Add : Per: 256 Kcal/100g | Med: 253 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "190c84ffc8773254c38b3b993e31ba73",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37266407",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "116401124",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266408",
                                            "variationId": "116401126"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "116401125",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266408",
                                            "variationId": "116401127"
                                          }
                                        },
                                        {
                                          "name": "Thin n Large",
                                          "id": "124780864",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37266408",
                                            "variationId": "124780867"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37266408",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 289,
                                          "default": 1,
                                          "id": "116401126",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 529,
                                          "id": "116401127",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 388,
                                          "id": "116401130",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 628,
                                          "id": "116401131",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "price": 699,
                                          "id": "124780867",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 388,
                                          "id": "126057787",
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "price": 628,
                                          "id": "126057788",
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266407",
                                          "variationId": "116401124"
                                        },
                                        {
                                          "groupId": "37266408",
                                          "variationId": "116401126"
                                        }
                                      ],
                                      "price": 28900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144354",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266407",
                                          "variationId": "116401124"
                                        },
                                        {
                                          "groupId": "37266408",
                                          "variationId": "126057787"
                                        }
                                      ],
                                      "price": 38800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144354",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266407",
                                          "variationId": "116401124"
                                        },
                                        {
                                          "groupId": "37266408",
                                          "variationId": "116401130"
                                        }
                                      ],
                                      "price": 38800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193873"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193870"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193872"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193838"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193840"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193842"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193844"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193849"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193845"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193851"
                                        },
                                        {
                                          "groupId": "152144367",
                                          "addonId": "112193853"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193837"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193876"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193869"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193864"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193835"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193868"
                                        },
                                        {
                                          "groupId": "133692687",
                                          "addonId": "112193846"
                                        },
                                        {
                                          "groupId": "152144354",
                                          "addonId": "112193873"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266407",
                                          "variationId": "116401125"
                                        },
                                        {
                                          "groupId": "37266408",
                                          "variationId": "116401127"
                                        }
                                      ],
                                      "price": 52900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144356",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266407",
                                          "variationId": "116401125"
                                        },
                                        {
                                          "groupId": "37266408",
                                          "variationId": "126057788"
                                        }
                                      ],
                                      "price": 62800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144356",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266407",
                                          "variationId": "116401125"
                                        },
                                        {
                                          "groupId": "37266408",
                                          "variationId": "116401131"
                                        }
                                      ],
                                      "price": 62800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144356",
                                          "addonId": "117361301"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193843"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193839"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193841"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193877"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193848"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193850"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193852"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193854"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193856"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193855"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193865"
                                        },
                                        {
                                          "groupId": "152144369",
                                          "addonId": "112193866"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193847"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193875"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193879"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193862"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193834"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193836"
                                        },
                                        {
                                          "groupId": "133692688",
                                          "addonId": "112193874"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37266407",
                                          "variationId": "124780864"
                                        },
                                        {
                                          "groupId": "37266408",
                                          "variationId": "124780867"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193863"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193860"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193859"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "115290079"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193858"
                                        },
                                        {
                                          "groupId": "133692686",
                                          "addonId": "112193861"
                                        },
                                        {
                                          "groupId": "152144359",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144363",
                                          "addonId": "114785287"
                                        },
                                        {
                                          "groupId": "152144363",
                                          "addonId": "114785288"
                                        },
                                        {
                                          "groupId": "152144363",
                                          "addonId": "114785289"
                                        },
                                        {
                                          "groupId": "152144363",
                                          "addonId": "114785290"
                                        },
                                        {
                                          "groupId": "152144363",
                                          "addonId": "114785286"
                                        },
                                        {
                                          "groupId": "152144363",
                                          "addonId": "114785301"
                                        },
                                        {
                                          "groupId": "152144363",
                                          "addonId": "114785302"
                                        },
                                        {
                                          "groupId": "152144363",
                                          "addonId": "114785297"
                                        },
                                        {
                                          "groupId": "152144363",
                                          "addonId": "114785298"
                                        },
                                        {
                                          "groupId": "152144363",
                                          "addonId": "114785299"
                                        },
                                        {
                                          "groupId": "152144363",
                                          "addonId": "114785300"
                                        },
                                        {
                                          "groupId": "152144363",
                                          "addonId": "114785293"
                                        },
                                        {
                                          "groupId": "152144363",
                                          "addonId": "114785294"
                                        },
                                        {
                                          "groupId": "140233211",
                                          "addonId": "114785291"
                                        },
                                        {
                                          "groupId": "140233211",
                                          "addonId": "114785295"
                                        },
                                        {
                                          "groupId": "140233211",
                                          "addonId": "114785296"
                                        },
                                        {
                                          "groupId": "140233211",
                                          "addonId": "114785305"
                                        },
                                        {
                                          "groupId": "140233211",
                                          "addonId": "114785306"
                                        },
                                        {
                                          "groupId": "140233211",
                                          "addonId": "114785307"
                                        },
                                        {
                                          "groupId": "140233211",
                                          "addonId": "114785304"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "152144354",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144359",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140233211",
                                    "groupName": "Add Non Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "114785291",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785295",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785296",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785305",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785306",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785307",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785304",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144363",
                                    "groupName": "Add Veg Toppings,",
                                    "choices": [
                                      {
                                        "id": "114785287",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785288",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785289",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785290",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785286",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785301",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785302",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785297",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785298",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785299",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785300",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785293",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114785294",
                                        "name": "Veg Kebab",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144367",
                                    "groupName": "Add Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193873",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193870",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193872",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193838",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193840",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193842",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193844",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193849",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193845",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193851",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193853",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692687",
                                    "groupName": "Add Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193837",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193876",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193869",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193864",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193835",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193868",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193846",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692686",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "112193863",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193860",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193859",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193858",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193861",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115290079",
                                        "name": "Loaded BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "152144369",
                                    "groupName": "Add. Veg Toppings..",
                                    "choices": [
                                      {
                                        "id": "112193843",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193839",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193841",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193877",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193848",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193850",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193852",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193854",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193856",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193855",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193865",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193866",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133692688",
                                    "groupName": "Add. Non-Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "112193847",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193875",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193879",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193862",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193834",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193836",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "112193874",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 28900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "New MELTS - Crispy. Cheesy. Loaded.",
                        "categories": [
                          {
                            "title": "Melts - Meal for 2",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "135326957",
                                    "name": "Create your Melts Box of 2 - Veg",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 2 | Choose any 2 Melts. Double the flavour, double the satisfaction. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).",
                                    "imageId": "e6072e97754de0c6c6030103e0fb50d3",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344700",
                                          "name": "Choose your 1st Melt",
                                          "variations": [
                                            {
                                              "name": "Loaded Veggie BBQ",
                                              "price": 189.5,
                                              "default": 1,
                                              "id": "135515557",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344701",
                                                "variationId": "135515565"
                                              }
                                            },
                                            {
                                              "name": "Cheezy Cheese Veg",
                                              "price": 219,
                                              "id": "135515559",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344701",
                                                "variationId": "135515565"
                                              }
                                            },
                                            {
                                              "name": "Magical Makhni Paneer",
                                              "price": 299,
                                              "id": "135515561",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344701",
                                                "variationId": "135515565"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344701",
                                          "name": "Choose your 2nd Melt",
                                          "variations": [
                                            {
                                              "name": "Loaded Veggie BBQ",
                                              "price": 189.5,
                                              "default": 1,
                                              "id": "135515565",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Cheezy Cheese Veg",
                                              "price": 219,
                                              "id": "135515567",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Magical Makhni Paneer",
                                              "price": 299,
                                              "id": "135515569",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344700",
                                              "variationId": "135515557"
                                            },
                                            {
                                              "groupId": "42344701",
                                              "variationId": "135515565"
                                            }
                                          ],
                                          "price": 37900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344700",
                                              "variationId": "135515557"
                                            },
                                            {
                                              "groupId": "42344701",
                                              "variationId": "135515567"
                                            }
                                          ],
                                          "price": 40850
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344700",
                                              "variationId": "135515557"
                                            },
                                            {
                                              "groupId": "42344701",
                                              "variationId": "135515569"
                                            }
                                          ],
                                          "price": 48850
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344700",
                                              "variationId": "135515559"
                                            },
                                            {
                                              "groupId": "42344701",
                                              "variationId": "135515565"
                                            }
                                          ],
                                          "price": 40850
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344700",
                                              "variationId": "135515559"
                                            },
                                            {
                                              "groupId": "42344701",
                                              "variationId": "135515567"
                                            }
                                          ],
                                          "price": 43800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344700",
                                              "variationId": "135515559"
                                            },
                                            {
                                              "groupId": "42344701",
                                              "variationId": "135515569"
                                            }
                                          ],
                                          "price": 51800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344700",
                                              "variationId": "135515561"
                                            },
                                            {
                                              "groupId": "42344701",
                                              "variationId": "135515565"
                                            }
                                          ],
                                          "price": 48850
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344700",
                                              "variationId": "135515561"
                                            },
                                            {
                                              "groupId": "42344701",
                                              "variationId": "135515567"
                                            }
                                          ],
                                          "price": 51800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344700",
                                              "variationId": "135515561"
                                            },
                                            {
                                              "groupId": "42344701",
                                              "variationId": "135515569"
                                            }
                                          ],
                                          "price": 59800
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 2"
                                    },
                                    "defaultPrice": 37900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.5",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "135326960",
                                    "name": "Create your Melts Box of 2 Non-Veg",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 2 | Choose any 2 Melts. Double the flavour, double the satisfaction. Cheezy Cheese Chicken : (268 Kcal/100g), Loaded BBQ Non-Veg : (330 Kcal/100g), Chicken Tikka Keema : (283 Kcal/100g).",
                                    "imageId": "e7620274ab99ba415f3e00480020cb48",
                                    "inStock": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344725",
                                          "name": "Choose your 1st Melt",
                                          "variations": [
                                            {
                                              "name": "Loaded Chicken BBQ",
                                              "price": 249,
                                              "default": 1,
                                              "id": "135515716",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344726",
                                                "variationId": "135515724"
                                              }
                                            },
                                            {
                                              "name": "Cheezy Cheese Chicken",
                                              "price": 269,
                                              "id": "135515719",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344726",
                                                "variationId": "135515724"
                                              }
                                            },
                                            {
                                              "name": "Chicken Tikka & Keema",
                                              "price": 309,
                                              "id": "135515721",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344726",
                                                "variationId": "135515724"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344726",
                                          "name": "Choose your 2nd Melt",
                                          "variations": [
                                            {
                                              "name": "Loaded Chicken BBQ",
                                              "price": 249,
                                              "default": 1,
                                              "id": "135515724",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Cheezy Cheese Chicken",
                                              "price": 269,
                                              "id": "135515725",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chicken Tikka & Keema",
                                              "price": 309,
                                              "id": "135515727",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344725",
                                              "variationId": "135515716"
                                            },
                                            {
                                              "groupId": "42344726",
                                              "variationId": "135515724"
                                            }
                                          ],
                                          "price": 49800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344725",
                                              "variationId": "135515716"
                                            },
                                            {
                                              "groupId": "42344726",
                                              "variationId": "135515725"
                                            }
                                          ],
                                          "price": 51800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344725",
                                              "variationId": "135515716"
                                            },
                                            {
                                              "groupId": "42344726",
                                              "variationId": "135515727"
                                            }
                                          ],
                                          "price": 55800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344725",
                                              "variationId": "135515719"
                                            },
                                            {
                                              "groupId": "42344726",
                                              "variationId": "135515724"
                                            }
                                          ],
                                          "price": 51800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344725",
                                              "variationId": "135515719"
                                            },
                                            {
                                              "groupId": "42344726",
                                              "variationId": "135515725"
                                            }
                                          ],
                                          "price": 53800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344725",
                                              "variationId": "135515719"
                                            },
                                            {
                                              "groupId": "42344726",
                                              "variationId": "135515727"
                                            }
                                          ],
                                          "price": 57800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344725",
                                              "variationId": "135515721"
                                            },
                                            {
                                              "groupId": "42344726",
                                              "variationId": "135515724"
                                            }
                                          ],
                                          "price": 55800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344725",
                                              "variationId": "135515721"
                                            },
                                            {
                                              "groupId": "42344726",
                                              "variationId": "135515725"
                                            }
                                          ],
                                          "price": 57800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344725",
                                              "variationId": "135515721"
                                            },
                                            {
                                              "groupId": "42344726",
                                              "variationId": "135515727"
                                            }
                                          ],
                                          "price": 61800
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG",
                                      "portionSize": "Serves 2"
                                    },
                                    "defaultPrice": 49800,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "135337391",
                                    "name": "Cheezy Cheese Chicken & Loaded BBQ Non-Veg Combo",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 1 | Satisfy your non veg cravings with Cheezy Cheese Chicken & Loaded Chicken BBQ Melts. Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts: (330 Kcal/100g).",
                                    "imageId": "3779ffaf02380c80f951a1ed2b90c997",
                                    "inStock": 1,
                                    "price": 48900,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "135703516",
                                    "name": "Cheezy Cheese Veg & Loaded BBQ Veg Combo",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 2 | Double the satisfaction with Cheezy Cheese Veg & Loaded BBQ Veg Melts. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g).",
                                    "imageId": "0b816322be7e8731246e9492e4b44b84",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 39900,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 2"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "135337392",
                                    "name": "Makhni Paneer & Chicken Tikka Keema Combo",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 2 | Satisfy your desi flavour cravings with Makhni Paneer & Chicken Tikka Keema Melts. Makhni Paneer Melts: (265 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g).",
                                    "imageId": "a6c351a9a53ae0c5fa2e5e401b8bf27a",
                                    "inStock": 1,
                                    "price": 54900,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG",
                                      "portionSize": "Serves 2"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              }
                            ]
                          },
                          {
                            "title": "Melts",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "138775924",
                                    "name": "Cheezy Cheese Chicken",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 1 | Thin & Crispy crust, loaded with juicy Chicken Sausage, Crunchy Onion, Green Capsicum, Red Bell Pepper, 100% mozzarella cheese, flavorful sauce, folded over and baked then brushed with herbed butter and sprinkled with cheezy seasoning. (268 Kcal/100g)",
                                    "imageId": "ddccb1c56496e83496c4975840beaada",
                                    "inStock": 1,
                                    "price": 26900,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "138775923",
                                    "name": "Chicken Tikka & Keema",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 1 | Thin & Crispy crust, loaded with flavorful chicken tikka, dhaba style masala keema, crunchy onion, green capsicum, 100% mozzarella cheese, flavorful sauce folded over and baked , then brushed with herbed butter and sprinkled with a flavor packed Makhni seasoning (283 Kcal/100g)",
                                    "imageId": "51e91bd6deadd0e8fd1bae5a94c0c6ff",
                                    "inStock": 1,
                                    "price": 30900,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "138775925",
                                    "name": "Loaded Chicken BBQ",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 1 | Thin & Crispy crust, loaded with Juicy Chicken Sausage, Herbed Chicken, 100% mozzarella cheese, flavorful sauce and a generous drizzle of signature barbeque sauce, folded over and baked, then brushed with herbed butter and sprinkled with our signature spice seasoning (330 Kcal/100g)",
                                    "imageId": "5410d354e29d05ebbdc0337436c1f67e",
                                    "inStock": 1,
                                    "price": 24900,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "138775926",
                                    "name": "Magical Makhni Paneer",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 1 | Thin & Crispy crust, loaded with Spiced paneer, crunchy onion, green capsicum, 100% mozzarella cheese, flavorful sauce your favourite delicious Makhni sauce folded over and baked, then brushed with herbed butter and sprinkled with a flavor packed Makhni seasoning (265 Kcal/100g)",
                                    "imageId": "f696af5ddf972eba40b75e0af840e2c8",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 29900,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "138775927",
                                    "name": "Cheezy Cheese Veg",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 1 | Thin & Crispy crust, loaded with Crunchy Onion, Green Capsicum, Red Bell Pepper, Juicy Sweet Corn, 100% mozzarella cheese, flavorful sauce, folded over and baked then brushed with herbed butter and sprinkled with cheezy seasoning. (296 Kcal/100g)",
                                    "imageId": "bb4e4f27e81fc6c6714d4ce9cbc2ffe8",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 21900,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "138775922",
                                    "name": "Loaded Veggie BBQ",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 1 | Thin & Crispy crust, loaded with Crunchy Onion, Green Capsicum, Red Bell Pepper, Juicy Corn, Mushroom, 100% mozzarella cheese, flavorful sauce and a generous drizzle of signature barbeque sauce, folded over and baked, then brushed with herbed butter and sprinkled with our signature spice seasoning (255 Kcal/100g)",
                                    "imageId": "8d4fcd37ebb334f0e9f347445722313e",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19900,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              }
                            ]
                          },
                          {
                            "title": "Melts - Meal for 1",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "135326956",
                                    "name": "Melts Meal for 1 with Fries - Veg",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 1 | Choose your favourite Melts & Fries. Customize your satisfaction. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).",
                                    "imageId": "77b13d58799f70f670be31e6fe53374e",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344688",
                                          "name": "Choose your Melt",
                                          "variations": [
                                            {
                                              "name": "Loaded Veggie BBQ",
                                              "price": 199,
                                              "default": 1,
                                              "id": "135515512",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344690",
                                                "variationId": "135515519"
                                              }
                                            },
                                            {
                                              "name": "Cheezy Cheese Veg",
                                              "price": 219,
                                              "id": "135515514",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344690",
                                                "variationId": "135515519"
                                              }
                                            },
                                            {
                                              "name": "Magical Makhni Paneer",
                                              "price": 299,
                                              "id": "135515517",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344690",
                                                "variationId": "135515519"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344690",
                                          "name": "Side",
                                          "variations": [
                                            {
                                              "name": "Sprinkled Fries",
                                              "price": 60,
                                              "default": 1,
                                              "id": "135515519",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344688",
                                              "variationId": "135515512"
                                            },
                                            {
                                              "groupId": "42344690",
                                              "variationId": "135515519"
                                            }
                                          ],
                                          "price": 25900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344688",
                                              "variationId": "135515514"
                                            },
                                            {
                                              "groupId": "42344690",
                                              "variationId": "135515519"
                                            }
                                          ],
                                          "price": 27900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344688",
                                              "variationId": "135515517"
                                            },
                                            {
                                              "groupId": "42344690",
                                              "variationId": "135515519"
                                            }
                                          ],
                                          "price": 35900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "defaultPrice": 25900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "9 ratings",
                                        "ratingCountV2": "9"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "135326959",
                                    "name": "Melts Meal for 1 with Fries Non-Veg",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 1 | Choose your favourite Melts & Fries combo. Customize your satisfaction.Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts : (330 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g).",
                                    "imageId": "da8429720566b8992d5c1c6bfeecdd2c",
                                    "inStock": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344720",
                                          "name": "Choose your Melt",
                                          "variations": [
                                            {
                                              "name": "Loaded Chicken BBQ",
                                              "price": 249,
                                              "default": 1,
                                              "id": "135515671",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344722",
                                                "variationId": "135515682"
                                              }
                                            },
                                            {
                                              "name": "Cheezy Cheese Chicken",
                                              "price": 269,
                                              "id": "135515673",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344722",
                                                "variationId": "135515682"
                                              }
                                            },
                                            {
                                              "name": "Chicken Tikka & Keema",
                                              "price": 309,
                                              "id": "135515676",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344722",
                                                "variationId": "135515682"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344722",
                                          "name": "Side",
                                          "variations": [
                                            {
                                              "name": "Sprinkled Fries",
                                              "price": 60,
                                              "default": 1,
                                              "id": "135515682",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344720",
                                              "variationId": "135515671"
                                            },
                                            {
                                              "groupId": "42344722",
                                              "variationId": "135515682"
                                            }
                                          ],
                                          "price": 30900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344720",
                                              "variationId": "135515673"
                                            },
                                            {
                                              "groupId": "42344722",
                                              "variationId": "135515682"
                                            }
                                          ],
                                          "price": 32900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344720",
                                              "variationId": "135515676"
                                            },
                                            {
                                              "groupId": "42344722",
                                              "variationId": "135515682"
                                            }
                                          ],
                                          "price": 36900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "defaultPrice": 30900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "135326961",
                                    "name": "Melts 3 Course Meal for 1 Non-Veg",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 1 | The perfect \"Me Time\" meal. Choose your favourite Melts & Fries accompanied with 1 Pepsi PET. Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts : (330 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g).",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/26d48552-a554-4b30-93d0-7462c255adc2_cc625cc1-b13b-44d4-a394-969d224b4c6c.jpg_compressed",
                                    "inStock": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344733",
                                          "name": "Choose your Melt",
                                          "variations": [
                                            {
                                              "name": "Loaded Chicken BBQ",
                                              "price": 359,
                                              "default": 1,
                                              "id": "135515737",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Cheezy Cheese Chicken",
                                              "price": 379,
                                              "id": "135515738",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chicken Tikka & Keema",
                                              "price": 419,
                                              "id": "135515740",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344733",
                                              "variationId": "135515737"
                                            }
                                          ],
                                          "price": 35900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344733",
                                              "variationId": "135515738"
                                            }
                                          ],
                                          "price": 37900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344733",
                                              "variationId": "135515740"
                                            }
                                          ],
                                          "price": 41900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "defaultPrice": 35900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "135326958",
                                    "name": "Melts 3 Course Meal for 1 - Veg",
                                    "category": "New MELTS - Crispy. Cheesy. Loaded.",
                                    "description": "Serves 1 | The perfect \"Me Time\" meal. Choose your favourite Melts & Fries accompanied with 1 Pepsi PET. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/bfee1036-41ea-40c1-addc-4fcbfb9475ee_37545bf3-2f63-458b-a7bc-fbeeaa7c41bc.jpg_compressed",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344711",
                                          "name": "Choose your Melt",
                                          "variations": [
                                            {
                                              "name": "Loaded Veggie BBQ",
                                              "price": 309,
                                              "default": 1,
                                              "id": "135515601",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Cheezy Cheese Veg",
                                              "price": 329,
                                              "id": "135515604",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Magical Makhni Paneer",
                                              "price": 409,
                                              "id": "135515607",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344711",
                                              "variationId": "135515601"
                                            }
                                          ],
                                          "price": 30900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344711",
                                              "variationId": "135515604"
                                            }
                                          ],
                                          "price": 32900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344711",
                                              "variationId": "135515607"
                                            }
                                          ],
                                          "price": 40900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "defaultPrice": 30900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              }
                            ]
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                        "categories": [
                          {
                            "title": "Meal for 4",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859675",
                                    "name": "Hut Treat Meal for 4 - Non Veg",
                                    "category": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                                    "description": "Serves 4 | Super saver meal combo @ 959 - 2 med non veg pizza of choice, 2 classic bread stix, 2 Pepsi PET. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/4bf86218-e9b2-4ff2-9c8b-bfc20e115efc_e6e2dc0f-10ed-4389-918b-45d3e32bfeda.png",
                                    "inStock": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344479",
                                          "name": "Choose 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Sausage",
                                              "price": 616,
                                              "default": 1,
                                              "id": "135514258",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344481",
                                                "variationId": "135514269"
                                              }
                                            },
                                            {
                                              "name": "Sausage & Sweet Corn",
                                              "price": 616,
                                              "id": "135514259",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344481",
                                                "variationId": "135514269"
                                              }
                                            },
                                            {
                                              "name": "Dhabe Da Keema",
                                              "price": 616,
                                              "id": "135514260",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344481",
                                                "variationId": "135514269"
                                              }
                                            },
                                            {
                                              "name": "Sizzling Schezwan Chicken",
                                              "price": 616,
                                              "id": "135514261",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344481",
                                                "variationId": "135514269"
                                              }
                                            },
                                            {
                                              "name": "Murg Malai Chicken",
                                              "price": 671,
                                              "id": "135514263",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344481",
                                                "variationId": "135514269"
                                              }
                                            },
                                            {
                                              "name": "Chicken Tikka",
                                              "price": 671,
                                              "id": "135514266",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344481",
                                                "variationId": "135514269"
                                              }
                                            },
                                            {
                                              "name": "Chicken Pepperoni",
                                              "price": 671,
                                              "id": "135514267",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344481",
                                                "variationId": "135514269"
                                              }
                                            },
                                            {
                                              "name": "Nawabi Murg Makhni",
                                              "price": 671,
                                              "id": "135514268",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344481",
                                                "variationId": "135514269"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344481",
                                          "name": "Choose 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Sausage",
                                              "price": 343,
                                              "default": 1,
                                              "id": "135514269",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Sausage & Sweet Corn",
                                              "price": 343,
                                              "id": "135514270",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Dhabe Da Keema",
                                              "price": 343,
                                              "id": "135514271",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Sizzling Schezwan Chicken",
                                              "price": 343,
                                              "id": "135514273",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Murg Malai Chicken",
                                              "price": 398,
                                              "id": "135514275",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chicken Tikka",
                                              "price": 398,
                                              "id": "135514277",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chicken Pepperoni",
                                              "price": 398,
                                              "id": "135514279",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514258"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514269"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514258"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514270"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514258"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514271"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514258"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514273"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514258"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514275"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514258"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514277"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514258"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514279"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514259"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514269"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514259"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514270"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514259"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514271"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514259"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514273"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514259"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514275"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514259"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514277"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514259"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514279"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514260"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514269"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514260"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514270"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514260"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514271"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514260"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514273"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514260"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514275"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514260"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514277"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514260"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514279"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514261"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514269"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514261"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514270"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514261"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514271"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514261"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514273"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514261"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514275"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514261"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514277"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514261"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514279"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514263"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514269"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514263"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514270"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514263"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514271"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514263"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514273"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514263"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514275"
                                            }
                                          ],
                                          "price": 106900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514263"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514277"
                                            }
                                          ],
                                          "price": 106900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514263"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514279"
                                            }
                                          ],
                                          "price": 106900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514266"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514269"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514266"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514270"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514266"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514271"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514266"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514273"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514266"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514275"
                                            }
                                          ],
                                          "price": 106900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514266"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514277"
                                            }
                                          ],
                                          "price": 106900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514266"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514279"
                                            }
                                          ],
                                          "price": 106900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514267"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514269"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514267"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514270"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514267"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514271"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514267"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514273"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514267"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514275"
                                            }
                                          ],
                                          "price": 106900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514267"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514277"
                                            }
                                          ],
                                          "price": 106900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514267"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514279"
                                            }
                                          ],
                                          "price": 106900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514268"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514269"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514268"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514270"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514268"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514271"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514268"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514273"
                                            }
                                          ],
                                          "price": 101400
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514268"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514275"
                                            }
                                          ],
                                          "price": 106900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514268"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514277"
                                            }
                                          ],
                                          "price": 106900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344479",
                                              "variationId": "135514268"
                                            },
                                            {
                                              "groupId": "42344481",
                                              "variationId": "135514279"
                                            }
                                          ],
                                          "price": 106900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG",
                                      "portionSize": "Serves 4"
                                    },
                                    "defaultPrice": 95900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859676",
                                    "name": "Hut Treat Meal for 4 - Veg",
                                    "category": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                                    "description": "Serves 4 | Super saver meal combo @ 859 - 2 med veg pizza of choice, 2 classic bread stix, 2 Pepsi PET. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/ca00e969-c65f-4436-85fc-a64408ddaa09_6f0ea04a-c96c-4a1e-893a-be49ead80ae0.png",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344492",
                                          "name": "Choose 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Margherita",
                                              "price": 566,
                                              "default": 1,
                                              "id": "135514325",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344495",
                                                "variationId": "135514345"
                                              }
                                            },
                                            {
                                              "name": "Schezwan Margherita",
                                              "price": 566,
                                              "id": "135514328",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344495",
                                                "variationId": "135514345"
                                              }
                                            },
                                            {
                                              "name": "Corn & Cheese",
                                              "price": 566,
                                              "id": "135514330",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344495",
                                                "variationId": "135514345"
                                              }
                                            },
                                            {
                                              "name": "Veggie Feast",
                                              "price": 566,
                                              "id": "135514332",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344495",
                                                "variationId": "135514345"
                                              }
                                            },
                                            {
                                              "name": "Spiced Paneer",
                                              "price": 566,
                                              "id": "135514334",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344495",
                                                "variationId": "135514345"
                                              }
                                            },
                                            {
                                              "name": "Mexican Fiesta",
                                              "price": 616,
                                              "id": "135514336",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344495",
                                                "variationId": "135514345"
                                              }
                                            },
                                            {
                                              "name": "Bold BBQ Veggies",
                                              "price": 616,
                                              "id": "135514338",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344495",
                                                "variationId": "135514345"
                                              }
                                            },
                                            {
                                              "name": "Tandoori Paneer",
                                              "price": 616,
                                              "id": "135514341",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344495",
                                                "variationId": "135514345"
                                              }
                                            },
                                            {
                                              "name": "Country Feast",
                                              "price": 616,
                                              "id": "135514343",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344495",
                                                "variationId": "135514345"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344495",
                                          "name": "Choose 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Margherita",
                                              "price": 293,
                                              "default": 1,
                                              "id": "135514345",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Schezwan Margherita",
                                              "price": 293,
                                              "id": "135514348",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Corn & Cheese",
                                              "price": 293,
                                              "id": "135514350",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Veggie Feast",
                                              "price": 293,
                                              "id": "135514353",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Spiced Paneer",
                                              "price": 293,
                                              "id": "135514354",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Mexican Fiesta",
                                              "price": 343,
                                              "id": "135514356",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Bold BBQ Veggies",
                                              "price": 343,
                                              "id": "135514358",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tandoori Paneer",
                                              "price": 343,
                                              "id": "135514361",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Country Feast",
                                              "price": 343,
                                              "id": "135514363",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514325"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514345"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514325"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514348"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514325"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514350"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514325"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514353"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514325"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514354"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514325"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514356"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514325"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514358"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514325"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514361"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514325"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514363"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514328"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514345"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514328"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514348"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514328"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514350"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514328"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514353"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514328"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514354"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514328"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514356"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514328"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514358"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514328"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514361"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514328"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514363"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514330"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514345"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514330"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514348"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514330"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514350"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514330"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514353"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514330"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514354"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514330"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514356"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514330"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514358"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514330"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514361"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514330"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514363"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514332"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514345"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514332"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514348"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514332"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514350"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514332"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514353"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514332"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514354"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514332"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514356"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514332"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514358"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514332"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514361"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514332"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514363"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514334"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514345"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514334"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514348"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514334"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514350"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514334"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514353"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514334"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514354"
                                            }
                                          ],
                                          "price": 85900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514334"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514356"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514334"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514358"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514334"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514361"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514334"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514363"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514336"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514345"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514336"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514348"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514336"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514350"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514336"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514353"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514336"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514354"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514336"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514356"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514336"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514358"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514336"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514361"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514336"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514363"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514338"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514345"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514338"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514348"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514338"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514350"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514338"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514353"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514338"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514354"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514338"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514356"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514338"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514358"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514338"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514361"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514338"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514363"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514341"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514345"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514341"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514348"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514341"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514350"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514341"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514353"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514341"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514354"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514341"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514356"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514341"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514358"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514341"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514361"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514341"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514363"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514343"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514345"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514343"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514348"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514343"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514350"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514343"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514353"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514343"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514354"
                                            }
                                          ],
                                          "price": 90900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514343"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514356"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514343"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514358"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514343"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514361"
                                            }
                                          ],
                                          "price": 95900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344492",
                                              "variationId": "135514343"
                                            },
                                            {
                                              "groupId": "42344495",
                                              "variationId": "135514363"
                                            }
                                          ],
                                          "price": 95900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 4"
                                    },
                                    "defaultPrice": 85900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              }
                            ]
                          },
                          {
                            "title": "Meal for 1",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859678",
                                    "name": "My Box - Non Veg",
                                    "category": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                                    "description": "Serves 1 | 1 personal non veg pizza, 2 pc garlic bread & 1 Pepsi PET. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/3330ac68-19aa-4598-a9f9-ac1f538ab52c_e1e7be34-7ff1-475b-a69b-4b99de6a2b09.png",
                                    "inStock": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344507",
                                          "name": "Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Sausage",
                                              "price": 212,
                                              "default": 1,
                                              "id": "135514405",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344512",
                                                "variationId": "135514436"
                                              }
                                            },
                                            {
                                              "name": "Sausage & Sweet Corn",
                                              "price": 252,
                                              "id": "135514407",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344512",
                                                "variationId": "135514436"
                                              }
                                            },
                                            {
                                              "name": "Dhabe Da Keema",
                                              "price": 252,
                                              "id": "135514408",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344512",
                                                "variationId": "135514436"
                                              }
                                            },
                                            {
                                              "name": "Sizzling Schezwan Chicken",
                                              "price": 252,
                                              "id": "135514411",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344512",
                                                "variationId": "135514436"
                                              }
                                            },
                                            {
                                              "name": "Murg Malai Chicken",
                                              "price": 272,
                                              "id": "135514413",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344512",
                                                "variationId": "135514436"
                                              }
                                            },
                                            {
                                              "name": "Awesome American Cheesy Chicken",
                                              "price": 272,
                                              "id": "135514416",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344512",
                                                "variationId": "135514436"
                                              }
                                            },
                                            {
                                              "name": "Chicken Tikka",
                                              "price": 272,
                                              "id": "135514418",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344512",
                                                "variationId": "135514436"
                                              }
                                            },
                                            {
                                              "name": "Chicken Pepperoni",
                                              "price": 272,
                                              "id": "135514421",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344512",
                                                "variationId": "135514436"
                                              }
                                            },
                                            {
                                              "name": "Nawabi Murg Makhni",
                                              "price": 292,
                                              "id": "135514424",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344512",
                                                "variationId": "135514436"
                                              }
                                            },
                                            {
                                              "name": "Chicken Supreme",
                                              "price": 292,
                                              "id": "135514427",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344512",
                                                "variationId": "135514436"
                                              }
                                            },
                                            {
                                              "name": "Chicken Tikka Supreme",
                                              "price": 292,
                                              "id": "135514430",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344512",
                                                "variationId": "135514436"
                                              }
                                            },
                                            {
                                              "name": "Triple Chicken Feast",
                                              "price": 292,
                                              "id": "135514432",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344512",
                                                "variationId": "135514436"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344512",
                                          "name": "Garlic Bread",
                                          "variations": [
                                            {
                                              "name": "2 Pcs Cheese Garlic Bread",
                                              "price": 70,
                                              "id": "135514434",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344514",
                                                "variationId": "135514439"
                                              }
                                            },
                                            {
                                              "name": "2 Pcs Garlic Bread",
                                              "price": 50,
                                              "default": 1,
                                              "id": "135514436",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344514",
                                                "variationId": "135514439"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344514",
                                          "name": "Beverage",
                                          "variations": [
                                            {
                                              "name": "Pepsi Pet Bottle",
                                              "price": 57,
                                              "default": 1,
                                              "id": "135514439",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514405"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514434"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 33900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514405"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514436"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 31900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514407"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514434"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 37900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514407"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514436"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 35900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514408"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514434"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 37900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514408"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514436"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 35900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514411"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514434"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 37900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514411"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514436"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 35900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514413"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514434"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 39900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514413"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514436"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 37900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514416"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514434"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 39900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514416"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514436"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 37900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514418"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514434"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 39900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514418"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514436"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 37900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514421"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514434"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 39900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514421"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514436"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 37900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514424"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514434"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 41900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514424"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514436"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 39900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514427"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514434"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 41900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514427"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514436"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 39900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514430"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514434"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 41900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514430"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514436"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 39900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514432"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514434"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 41900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344507",
                                              "variationId": "135514432"
                                            },
                                            {
                                              "groupId": "42344512",
                                              "variationId": "135514436"
                                            },
                                            {
                                              "groupId": "42344514",
                                              "variationId": "135514439"
                                            }
                                          ],
                                          "price": 39900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "defaultPrice": 31900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859680",
                                    "name": "My Box - Veg",
                                    "category": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                                    "description": "Serves 1 | 1 personal veg pizza, 2 pc garlic bread & 1 Pepsi PET ! For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/a1efbc7d-6165-4b69-8fe8-e88335921678_0c2d69b5-8aef-4ff2-962c-7c9d75bb84ce.png",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344517",
                                          "name": "Pizza",
                                          "variations": [
                                            {
                                              "name": "Margherita",
                                              "price": 142,
                                              "default": 1,
                                              "id": "135514454",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344523",
                                                "variationId": "135514483"
                                              }
                                            },
                                            {
                                              "name": "Schezwan Margherita",
                                              "price": 142,
                                              "id": "135514456",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344523",
                                                "variationId": "135514483"
                                              }
                                            },
                                            {
                                              "name": "Corn & Cheese",
                                              "price": 192,
                                              "id": "135514457",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344523",
                                                "variationId": "135514483"
                                              }
                                            },
                                            {
                                              "name": "Veggie Feast",
                                              "price": 212,
                                              "id": "135514459",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344523",
                                                "variationId": "135514483"
                                              }
                                            },
                                            {
                                              "name": "Spiced Paneer",
                                              "price": 212,
                                              "id": "135514460",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344523",
                                                "variationId": "135514483"
                                              }
                                            },
                                            {
                                              "name": "Mexican Fiesta",
                                              "price": 232,
                                              "id": "135514462",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344523",
                                                "variationId": "135514483"
                                              }
                                            },
                                            {
                                              "name": "Bold BBQ Veggies",
                                              "price": 232,
                                              "id": "135514464",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344523",
                                                "variationId": "135514483"
                                              }
                                            },
                                            {
                                              "name": "Tandoori Paneer",
                                              "price": 232,
                                              "id": "135514466",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344523",
                                                "variationId": "135514483"
                                              }
                                            },
                                            {
                                              "name": "Country Feast",
                                              "price": 232,
                                              "id": "135514468",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344523",
                                                "variationId": "135514483"
                                              }
                                            },
                                            {
                                              "name": "Ultimate Tandoori Veggie",
                                              "price": 252,
                                              "id": "135514469",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344523",
                                                "variationId": "135514483"
                                              }
                                            },
                                            {
                                              "name": "Mazedar Makhni Paneer",
                                              "price": 252,
                                              "id": "135514470",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344523",
                                                "variationId": "135514483"
                                              }
                                            },
                                            {
                                              "name": "Awesome American Cheesy",
                                              "price": 252,
                                              "id": "135514473",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344523",
                                                "variationId": "135514483"
                                              }
                                            },
                                            {
                                              "name": "Veggie Supreme",
                                              "price": 252,
                                              "id": "135514476",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344523",
                                                "variationId": "135514483"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344523",
                                          "name": "Garlic Bread",
                                          "variations": [
                                            {
                                              "name": "2 Pcs Cheese Garlic Bread",
                                              "price": 70,
                                              "id": "135514480",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344525",
                                                "variationId": "135514488"
                                              }
                                            },
                                            {
                                              "name": "2 Pcs Garlic Bread",
                                              "price": 50,
                                              "default": 1,
                                              "id": "135514483",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344525",
                                                "variationId": "135514488"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344525",
                                          "name": "Beverage",
                                          "variations": [
                                            {
                                              "name": "Pepsi Pet Bottle",
                                              "price": 57,
                                              "default": 1,
                                              "id": "135514488",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514454"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514480"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 26900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514454"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514483"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 24900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514456"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514480"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 26900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514456"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514483"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 24900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514457"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514480"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 31900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514457"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514483"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 29900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514459"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514480"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 33900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514459"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514483"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 31900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514460"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514480"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 33900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514460"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514483"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 31900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514462"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514480"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 35900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514462"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514483"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 33900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514464"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514480"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 35900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514464"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514483"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 33900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514466"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514480"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 35900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514466"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514483"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 33900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514468"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514480"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 35900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514468"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514483"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 33900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514469"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514480"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 37900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514469"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514483"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 35900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514470"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514480"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 37900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514470"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514483"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 35900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514473"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514480"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 37900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514473"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514483"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 35900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514476"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514480"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 37900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344517",
                                              "variationId": "135514476"
                                            },
                                            {
                                              "groupId": "42344523",
                                              "variationId": "135514483"
                                            },
                                            {
                                              "groupId": "42344525",
                                              "variationId": "135514488"
                                            }
                                          ],
                                          "price": 35900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "defaultPrice": 24900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "8 ratings",
                                        "ratingCountV2": "8"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859611",
                                    "name": "Garlic Breadstix with Pepsi",
                                    "category": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                                    "description": "Serves 1 | Get a Garlic Breadstix and Pepsi. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/ed7774f7-4466-4217-8a96-77b376b2fe4a_b7199cb3-6f82-4ccb-b701-2636fb99686e.jpg_compressed",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 17600,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              }
                            ]
                          },
                          {
                            "title": "Meal for 2",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859672",
                                    "name": "Hut Treat Meal for 2 - Non Veg",
                                    "category": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                                    "description": "Serves 2 | 1 medium non-veg pizza upto signature, 1 classic bread stix, 1 Pepsi PET. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/fc115b57-9536-4c2d-8876-bcedf630ea7b_b7818aa0-4ccb-4cfa-acb5-df7a9cace4e5.png_compressed",
                                    "inStock": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344462",
                                          "name": "Choose Your Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Sausage",
                                              "price": 433,
                                              "default": 1,
                                              "id": "135514147",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344464",
                                                "variationId": "135514175"
                                              }
                                            },
                                            {
                                              "name": "Sausage & Sweet Corn",
                                              "price": 433,
                                              "id": "135514151",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344464",
                                                "variationId": "135514175"
                                              }
                                            },
                                            {
                                              "name": "Dhabe Da Keema",
                                              "price": 433,
                                              "id": "135514154",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344464",
                                                "variationId": "135514175"
                                              }
                                            },
                                            {
                                              "name": "Sizzling Schezwan Chicken",
                                              "price": 433,
                                              "id": "135514159",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344464",
                                                "variationId": "135514175"
                                              }
                                            },
                                            {
                                              "name": "Murg Malai Chicken",
                                              "price": 483,
                                              "id": "135514162",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344464",
                                                "variationId": "135514175"
                                              }
                                            },
                                            {
                                              "name": "Awesome American Cheesy Chicken",
                                              "price": 483,
                                              "id": "135514165",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344464",
                                                "variationId": "135514175"
                                              }
                                            },
                                            {
                                              "name": "Chicken Tikka",
                                              "price": 483,
                                              "id": "135514168",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344464",
                                                "variationId": "135514175"
                                              }
                                            },
                                            {
                                              "name": "Chicken Pepperoni",
                                              "price": 433,
                                              "id": "135514170",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344464",
                                                "variationId": "135514175"
                                              }
                                            },
                                            {
                                              "name": "Nawabi Murg Makhni",
                                              "price": 483,
                                              "id": "135514171",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344464",
                                                "variationId": "135514175"
                                              }
                                            },
                                            {
                                              "name": "Chicken Supreme",
                                              "price": 483,
                                              "id": "135514172",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344464",
                                                "variationId": "135514175"
                                              }
                                            },
                                            {
                                              "name": "Chicken Tikka Supreme",
                                              "price": 483,
                                              "id": "135514173",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344464",
                                                "variationId": "135514175"
                                              }
                                            },
                                            {
                                              "name": "Triple Chicken Feast",
                                              "price": 483,
                                              "id": "135514174",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344464",
                                                "variationId": "135514175"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344464",
                                          "name": "Side",
                                          "variations": [
                                            {
                                              "name": "Classic BreadStix",
                                              "price": 99,
                                              "default": 1,
                                              "id": "135514175",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344465",
                                                "variationId": "135514176"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344465",
                                          "name": "Beverage",
                                          "variations": [
                                            {
                                              "name": "Pepsi PET Bottle",
                                              "price": 57,
                                              "default": 1,
                                              "id": "135514176",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344462",
                                              "variationId": "135514147"
                                            },
                                            {
                                              "groupId": "42344464",
                                              "variationId": "135514175"
                                            },
                                            {
                                              "groupId": "42344465",
                                              "variationId": "135514176"
                                            }
                                          ],
                                          "price": 58900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344462",
                                              "variationId": "135514151"
                                            },
                                            {
                                              "groupId": "42344464",
                                              "variationId": "135514175"
                                            },
                                            {
                                              "groupId": "42344465",
                                              "variationId": "135514176"
                                            }
                                          ],
                                          "price": 58900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344462",
                                              "variationId": "135514154"
                                            },
                                            {
                                              "groupId": "42344464",
                                              "variationId": "135514175"
                                            },
                                            {
                                              "groupId": "42344465",
                                              "variationId": "135514176"
                                            }
                                          ],
                                          "price": 58900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344462",
                                              "variationId": "135514159"
                                            },
                                            {
                                              "groupId": "42344464",
                                              "variationId": "135514175"
                                            },
                                            {
                                              "groupId": "42344465",
                                              "variationId": "135514176"
                                            }
                                          ],
                                          "price": 58900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344462",
                                              "variationId": "135514162"
                                            },
                                            {
                                              "groupId": "42344464",
                                              "variationId": "135514175"
                                            },
                                            {
                                              "groupId": "42344465",
                                              "variationId": "135514176"
                                            }
                                          ],
                                          "price": 63900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344462",
                                              "variationId": "135514165"
                                            },
                                            {
                                              "groupId": "42344464",
                                              "variationId": "135514175"
                                            },
                                            {
                                              "groupId": "42344465",
                                              "variationId": "135514176"
                                            }
                                          ],
                                          "price": 63900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344462",
                                              "variationId": "135514168"
                                            },
                                            {
                                              "groupId": "42344464",
                                              "variationId": "135514175"
                                            },
                                            {
                                              "groupId": "42344465",
                                              "variationId": "135514176"
                                            }
                                          ],
                                          "price": 63900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344462",
                                              "variationId": "135514170"
                                            },
                                            {
                                              "groupId": "42344464",
                                              "variationId": "135514175"
                                            },
                                            {
                                              "groupId": "42344465",
                                              "variationId": "135514176"
                                            }
                                          ],
                                          "price": 58900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344462",
                                              "variationId": "135514171"
                                            },
                                            {
                                              "groupId": "42344464",
                                              "variationId": "135514175"
                                            },
                                            {
                                              "groupId": "42344465",
                                              "variationId": "135514176"
                                            }
                                          ],
                                          "price": 63900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344462",
                                              "variationId": "135514172"
                                            },
                                            {
                                              "groupId": "42344464",
                                              "variationId": "135514175"
                                            },
                                            {
                                              "groupId": "42344465",
                                              "variationId": "135514176"
                                            }
                                          ],
                                          "price": 63900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344462",
                                              "variationId": "135514173"
                                            },
                                            {
                                              "groupId": "42344464",
                                              "variationId": "135514175"
                                            },
                                            {
                                              "groupId": "42344465",
                                              "variationId": "135514176"
                                            }
                                          ],
                                          "price": 63900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344462",
                                              "variationId": "135514174"
                                            },
                                            {
                                              "groupId": "42344464",
                                              "variationId": "135514175"
                                            },
                                            {
                                              "groupId": "42344465",
                                              "variationId": "135514176"
                                            }
                                          ],
                                          "price": 63900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG",
                                      "portionSize": "Serves 2"
                                    },
                                    "defaultPrice": 58900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859673",
                                    "name": "Hut Treat Meal for 2 - Veg",
                                    "category": "Meals and Deals : Better With Pepsi (Save upto 38%)",
                                    "description": "Serves 2 | 1 medium veg pizza upto signature, 1 classic bread stix, 1 Pepsi PET. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/9004b4ef-3454-40d3-babb-641082675270_4fd584b6-55b0-4a17-b519-d42e6fff8af9.png",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "42344471",
                                          "name": "Choose Your Pizza",
                                          "variations": [
                                            {
                                              "name": "Margherita",
                                              "price": 373,
                                              "default": 1,
                                              "id": "135514221",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344474",
                                                "variationId": "135514238"
                                              }
                                            },
                                            {
                                              "name": "Schezwan Margherita",
                                              "price": 373,
                                              "id": "135514224",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344474",
                                                "variationId": "135514238"
                                              }
                                            },
                                            {
                                              "name": "Corn & Cheese",
                                              "price": 373,
                                              "id": "135514226",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344474",
                                                "variationId": "135514238"
                                              }
                                            },
                                            {
                                              "name": "Veggie Feast",
                                              "price": 373,
                                              "id": "135514227",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344474",
                                                "variationId": "135514238"
                                              }
                                            },
                                            {
                                              "name": "Spiced Paneer",
                                              "price": 373,
                                              "id": "135514228",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344474",
                                                "variationId": "135514238"
                                              }
                                            },
                                            {
                                              "name": "Mexican Fiesta",
                                              "price": 433,
                                              "id": "135514229",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344474",
                                                "variationId": "135514238"
                                              }
                                            },
                                            {
                                              "name": "Bold BBQ Veggies",
                                              "price": 433,
                                              "id": "135514230",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344474",
                                                "variationId": "135514238"
                                              }
                                            },
                                            {
                                              "name": "Tandoori Paneer",
                                              "price": 433,
                                              "id": "135514231",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344474",
                                                "variationId": "135514238"
                                              }
                                            },
                                            {
                                              "name": "Country Feast",
                                              "price": 433,
                                              "id": "135514232",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344474",
                                                "variationId": "135514238"
                                              }
                                            },
                                            {
                                              "name": "Veggie Supreme",
                                              "price": 433,
                                              "id": "135514235",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344474",
                                                "variationId": "135514238"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344474",
                                          "name": "Side",
                                          "variations": [
                                            {
                                              "name": "Classic BreadStix",
                                              "price": 99,
                                              "default": 1,
                                              "id": "135514238",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "42344475",
                                                "variationId": "135514239"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "42344475",
                                          "name": "Beverage",
                                          "variations": [
                                            {
                                              "name": "Pepsi PET Bottle",
                                              "price": 57,
                                              "default": 1,
                                              "id": "135514239",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344471",
                                              "variationId": "135514221"
                                            },
                                            {
                                              "groupId": "42344474",
                                              "variationId": "135514238"
                                            },
                                            {
                                              "groupId": "42344475",
                                              "variationId": "135514239"
                                            }
                                          ],
                                          "price": 52900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344471",
                                              "variationId": "135514224"
                                            },
                                            {
                                              "groupId": "42344474",
                                              "variationId": "135514238"
                                            },
                                            {
                                              "groupId": "42344475",
                                              "variationId": "135514239"
                                            }
                                          ],
                                          "price": 52900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344471",
                                              "variationId": "135514226"
                                            },
                                            {
                                              "groupId": "42344474",
                                              "variationId": "135514238"
                                            },
                                            {
                                              "groupId": "42344475",
                                              "variationId": "135514239"
                                            }
                                          ],
                                          "price": 52900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344471",
                                              "variationId": "135514227"
                                            },
                                            {
                                              "groupId": "42344474",
                                              "variationId": "135514238"
                                            },
                                            {
                                              "groupId": "42344475",
                                              "variationId": "135514239"
                                            }
                                          ],
                                          "price": 52900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344471",
                                              "variationId": "135514228"
                                            },
                                            {
                                              "groupId": "42344474",
                                              "variationId": "135514238"
                                            },
                                            {
                                              "groupId": "42344475",
                                              "variationId": "135514239"
                                            }
                                          ],
                                          "price": 52900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344471",
                                              "variationId": "135514229"
                                            },
                                            {
                                              "groupId": "42344474",
                                              "variationId": "135514238"
                                            },
                                            {
                                              "groupId": "42344475",
                                              "variationId": "135514239"
                                            }
                                          ],
                                          "price": 58900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344471",
                                              "variationId": "135514230"
                                            },
                                            {
                                              "groupId": "42344474",
                                              "variationId": "135514238"
                                            },
                                            {
                                              "groupId": "42344475",
                                              "variationId": "135514239"
                                            }
                                          ],
                                          "price": 58900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344471",
                                              "variationId": "135514231"
                                            },
                                            {
                                              "groupId": "42344474",
                                              "variationId": "135514238"
                                            },
                                            {
                                              "groupId": "42344475",
                                              "variationId": "135514239"
                                            }
                                          ],
                                          "price": 58900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344471",
                                              "variationId": "135514232"
                                            },
                                            {
                                              "groupId": "42344474",
                                              "variationId": "135514238"
                                            },
                                            {
                                              "groupId": "42344475",
                                              "variationId": "135514239"
                                            }
                                          ],
                                          "price": 58900
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "42344471",
                                              "variationId": "135514235"
                                            },
                                            {
                                              "groupId": "42344474",
                                              "variationId": "135514238"
                                            },
                                            {
                                              "groupId": "42344475",
                                              "variationId": "135514239"
                                            }
                                          ],
                                          "price": 58900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 2"
                                    },
                                    "defaultPrice": 52900,
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              }
                            ]
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "New Thin n Crispy Pizzas",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "136105864",
                                "name": "Chicken Supreme Thin n Crispy",
                                "category": "New Thin n Crispy Pizzas",
                                "description": "Serves 4 | New Thin n Crispy crust with delicious chicken tikka, flavourful herbed chicken, spicy schezwan chicken meatball with flavourful pan sauce and 100% mozzarella cheese. (TnC-284 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "252a01784a4caa78e1d7d1a4206f8b2f",
                                "inStock": 1,
                                "price": 94900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 4"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "136105863",
                                "name": "Chicken Pepperoni Thin n Crispy",
                                "category": "New Thin n Crispy Pizzas",
                                "description": "Serves 4 | New Thin n Crispy crust with yummy chicken pepperoni & 100% mozzarella cheese with signature pan sauce. Its a classic! (TnC-311 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "364fbbed964a25498f7413762ebed513",
                                "inStock": 1,
                                "price": 84900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 4"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "136105860",
                                "name": "Tandoori Paneer Thin n Crispy",
                                "category": "New Thin n Crispy Pizzas",
                                "description": "Serves 4 | New Thin n Crispy crust topped with spiced paneer, crunchy onions & green capsicum, spicy red paprika, delicious tandoori sauce and 100% mozzarella cheese (TnC-326 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/7/a365b1af-5d17-4639-994b-1f4e177c757e_f2e7acc3-9370-49e3-829b-296ea2754eaf_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 74900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 4"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "136105861",
                                "name": "Mexican Fiesta Thin n Crispy",
                                "category": "New Thin n Crispy Pizzas",
                                "description": "Serves 4 | New Thin n Crispy crust topped with red capsicum, green capsicum, jalapeno, onion, black olives, sweet corn, 100% mozzarella cheese, signature spice sprinkle & our flavourful pan sauce (TnC-258 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "fcdc4615f6c0fa952da88c394d732fad",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 74900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 4"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "136105862",
                                "name": "Dhabe Da Keema Thin n Crispy",
                                "category": "New Thin n Crispy Pizzas",
                                "description": "Serves 4 | New Thin n Crispy crust with dhaba style chicken keema masala, green chiili, crunchy onion with flavourful pan sauce, 100 % mozzarella cheese & a generous drizzle of mint mayo (TnC-290 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/7/74ad756e-dc60-4b84-bdc2-2ddf65fda8f7_b340bd7e-a978-47fb-9fc1-d08ed1ad35b1_compressed",
                                "inStock": 1,
                                "price": 74900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 4"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "136105859",
                                "name": "Bold BBQ Veggie Thin n Crispy",
                                "category": "New Thin n Crispy Pizzas",
                                "description": "Serves 4 | New Thin n Crispy crust with our signature pan sauce, with BBQ sauce drizzle, topped with mushroom, onion, green capsicum, & red paprika (TnC-266 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "e2f207fda70413b191db2683e4d471df",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 74900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 4"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Appetizer",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859608",
                                "name": "Cheesy Dip",
                                "category": "Appetizer",
                                "description": "Serves 1 | Cheesy jalapeno dip 20 gm (49 Kcal/100g) Contains Cereals containing Gluten (Wheat) & Soya.",
                                "imageId": "l7twhqhybkdlsvkyq3pj",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 2375,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "15 ratings",
                                    "ratingCountV2": "15"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859575",
                                "name": "Zesty Chicken Pocket",
                                "category": "Appetizer",
                                "description": "Serves 1 | Freshly baked pocket stuffed with chicken, veggies & smoked texas garlic sauce (216 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "wukqmbrmv0vngtlrczgw",
                                "inStock": 1,
                                "price": 14900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859610",
                                "name": "Sprinkled Fries - New",
                                "category": "Appetizer",
                                "description": "Serves 1 | Baked fries seasoned with our signature peruvian seasoning (204 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "frgza6cm1sjezw79pjtu",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.5",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135326955",
                                "name": "Cheezy Sprinkled Fries",
                                "category": "Appetizer",
                                "description": "Serves 1 | Baked fries seasoned with cheezy seasoning (213 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "8bef47cab8863c1bcd113a28e30ffee4",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859581",
                                "name": "Jalapeno Poppers",
                                "category": "Appetizer",
                                "description": "Serves 1 | Jalapano poppers with gooey white sauce. (250 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "oqfrpjaw6v4q3p3qafww",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 11900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.8",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859574",
                                "name": "Zesty Paneer Pocket",
                                "category": "Appetizer",
                                "description": "Serves 1 | Freshly baked pocket stuffed with flavourful paneer, veggies & smoked texas garlic sauce (264 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "spmefmk8u9ftwbvdk6ay",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 12900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.1",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859606",
                                "name": "Tomato Ketchup",
                                "category": "Appetizer",
                                "description": "Serves 1 | Ketchup sachet (11 Kcal/100g)",
                                "imageId": "hovlvq3ceumkhyivd0ik",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 95,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "23 ratings",
                                    "ratingCountV2": "23"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859605",
                                "name": "Momo Dip",
                                "category": "Appetizer",
                                "description": "Serves 1 | Schezwan dip (18 Kcal/100g)",
                                "imageId": "ygx3tiuj7ygbp1jyw1ce",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 3000,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Pasta",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "137422757",
                                "name": "Penne McN Cheese Pasta",
                                "category": "Pasta",
                                "description": "Serves 1 | Penne pasta baked in flavourful sauce along with green capsicum, onion and red capsicum topped with 100% mozzarella cheese & cheesy dressing (227 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "skfbhz264euhvsoayprt",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 20900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "137422755",
                                "name": "Penne McN Cheese & Chicken Pasta",
                                "category": "Pasta",
                                "description": "Serves 1 | Penne pasta baked in flavourful sauce along with herbed chicken, green capsicum, onion and red capsicum topped with 100% mozzarella cheese & cheesy dressing (224 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "pfwyjsgapi6u5hswj302",
                                "inStock": 1,
                                "price": 22900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.6",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "136550635",
                                "name": "Tandoori Paneer Pasta",
                                "category": "Pasta",
                                "description": "Serves 1 | Baked penne pasta with your favorite tandoori sauce topped with flavorful soft paneer and green capsicum, onion, red capsicum & cheesy dressing (232 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "f1bnld6zrlutewe7vi9a",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 16900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.3",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859671",
                                "name": "Spicy Schezwan Pasta Chicken",
                                "category": "Pasta",
                                "description": "Serves 1 | Fusilli pasta baked in spicy schezwan sauce with schezwan chicken meatballs, green capsicum, onion, red capsicum and red paprika, topped with cheesy dressing (178 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "e4d3b61ab38a0e86db994a9c1db2d0a9",
                                "inStock": 1,
                                "price": 19900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "136550634",
                                "name": "Tandoori Murg Pasta",
                                "category": "Pasta",
                                "description": "Serves 1 | Baked penne pasta with your favorite tandoori sauce topped with chicken tikka, green capsicum, onion, red capsicum and cheesy dressing (214 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "afetxjkwly3qhzheetjm",
                                "inStock": 1,
                                "price": 18900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "136550633",
                                "name": "Spicy Red Schezwan Pasta",
                                "category": "Pasta",
                                "description": "Serves 1 | Fusilli pasta baked in spicy schezwan sauce, green capsicum, onion and red capsicum topped with paprika for an added zing & cheesy dressing (191 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "c6aea671a74704ce9f39dba98d5846dd",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "136550632",
                                "name": "Tomato Twist Red Sauce Pasta",
                                "category": "Pasta",
                                "description": "Serves 1 | Fusilli pasta baked in tangy flavorful tomato sauce infused with heavenly herbs & spices topped with green capsicum, onion and red capsicum and cheesy dressing (175 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "nzq6soxhtqgeslmqufrq",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 16900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Garlic Bread",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859573",
                                "name": "Classic Bread Stix",
                                "category": "Garlic Bread",
                                "description": "Serves 1 | Freshly baked buttery bread stix, sprinkled with herbs (287 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "n2ycmete7ehes9mrerlw",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 11900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "15 ratings",
                                    "ratingCountV2": "15"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135775465",
                                "name": "Loaded Bread Stix",
                                "category": "Garlic Bread",
                                "description": "Serves 1 | Freshly baked bread stix, topped with cheesy dressing & herbs (320 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "o0zibtrbtyjwznptrsgy",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 16900,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "10 ratings",
                                    "ratingCountV2": "10"
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Drinks & Desserts",
                        "categories": [
                          {
                            "title": "Beverages",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859579",
                                    "name": "Pepsi 475ml",
                                    "category": "Drinks & Desserts",
                                    "description": "Serves 1 | Pepsi PET 475ml. Contains Caffeine (43 Kcal/100ml)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/19/8df1017a-bfa8-45c0-a643-be8dc39b36d6_f2aec0bf-0d44-4a94-ab17-e75f87c2c128.png",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 5700,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.8",
                                        "ratingCount": "14 ratings",
                                        "ratingCountV2": "14"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859578",
                                    "name": "Mirinda 475ml",
                                    "category": "Drinks & Desserts",
                                    "description": "Serves 1 | Mirinda PET 475ml. Contains Caffeine (55 Kcal/100ml)",
                                    "imageId": "wjmrbgifbxdmqnumj84h",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 5700,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              }
                            ]
                          },
                          {
                            "title": "Dessert",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859660",
                                    "name": "Brow-wow-nie",
                                    "category": "Drinks & Desserts",
                                    "description": "Serves 1 | A divine choco brownie for your all time chocolate cravings (273 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "7ac7f4004c86ebb381fa1c0c3bd58722",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 10900,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.6",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132859576",
                                    "name": "Choco Volcano",
                                    "category": "Drinks & Desserts",
                                    "description": "Serves 1 | Warm choco cake with gooey center (262 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "k76b8gwkiskwhc9p7nbt",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 12900,
                                    "variants": {
                                      
                                    },
                                    "variantsV2": {
                                      
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {
                                      
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "30% OFF",
                                        "subTitle": "USE TRYNEW",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3"
                                      }
                                    ],
                                    "itemBadge": {
                                      
                                    },
                                    "badgesV2": {
                                      
                                    },
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "1.7",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      }
                                    }
                                  },
                                  "analytics": {
                                    
                                  },
                                  "hideRestaurantDetails": true
                                }
                              }
                            ]
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "One Plus One Medium @649",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859682",
                                "name": "Super Value Deal : 2 Medium Non-Veg Pizzas starting at Rs 749 (Save Upto 39%).",
                                "category": "One Plus One Medium @649",
                                "description": "Serves 4 | Choose any 2 of your favorite non-veg medium pizzas. For Meals, refer to the nutritional data for individual products.",
                                "imageId": "6110f28b77f670194674bbf318970656",
                                "inStock": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344533",
                                      "name": "Choose 1st Pizza",
                                      "variations": [
                                        {
                                          "name": "Chicken Sausage",
                                          "price": 374.5,
                                          "default": 1,
                                          "id": "135514521",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Sausage & Sweet Corn",
                                          "price": 374.5,
                                          "id": "135514523",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Dhabe Da Keema",
                                          "price": 424.5,
                                          "id": "135514524",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Sizzling Schezwan Chicken",
                                          "price": 374.5,
                                          "id": "135514526",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Murg Malai Chicken",
                                          "price": 424.5,
                                          "id": "135514527",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Awesome American Cheesy Chicken",
                                          "price": 424.5,
                                          "id": "135514528",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka",
                                          "price": 424.5,
                                          "id": "135514529",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Chicken Pepperoni",
                                          "price": 424.5,
                                          "id": "135514530",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Nawabi Murg Makhni",
                                          "price": 424.5,
                                          "id": "135514531",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Chicken Supreme",
                                          "price": 424.5,
                                          "id": "135514532",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka Supreme",
                                          "price": 424.5,
                                          "id": "135514533",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        },
                                        {
                                          "name": "Triple Chicken Feast",
                                          "price": 424.5,
                                          "id": "135514534",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344536",
                                            "variationId": "135514535"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344536",
                                      "name": "Choose 2nd Pizza",
                                      "variations": [
                                        {
                                          "name": "Chicken Sausage",
                                          "price": 374.5,
                                          "default": 1,
                                          "id": "135514535",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Sausage & Sweet Corn",
                                          "price": 374.5,
                                          "id": "135514536",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Dhabe Da Keema",
                                          "price": 424.5,
                                          "id": "135514537",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Sizzling Schezwan Chicken",
                                          "price": 374.5,
                                          "id": "135514538",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Murg Malai Chicken",
                                          "price": 424.5,
                                          "id": "135514540",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Awesome American Cheesy Chicken",
                                          "price": 424.5,
                                          "id": "135514541",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Tikka",
                                          "price": 424.5,
                                          "id": "135514543",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Pepperoni",
                                          "price": 424.5,
                                          "id": "135514546",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Nawabi Murg Makhni",
                                          "price": 424.5,
                                          "id": "135514549",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Supreme",
                                          "price": 424.5,
                                          "id": "135514552",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Tikka Supreme",
                                          "price": 424.5,
                                          "id": "135514555",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Triple Chicken Feast",
                                          "price": 424.5,
                                          "id": "135514558",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514521"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514523"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514524"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514526"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514527"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514528"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514529"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514530"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514531"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514532"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514533"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514535"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514536"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514537"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514538"
                                        }
                                      ],
                                      "price": 79900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514540"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514541"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514543"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514546"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514549"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514552"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514555"
                                        }
                                      ],
                                      "price": 84900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344533",
                                          "variationId": "135514534"
                                        },
                                        {
                                          "groupId": "42344536",
                                          "variationId": "135514558"
                                        }
                                      ],
                                      "price": 84900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 4"
                                },
                                "defaultPrice": 74900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "132859684",
                                "name": "Super Value Deal : 2 Medium Veg Pizzas starting at Rs 649 (Save Upto 41%).",
                                "category": "One Plus One Medium @649",
                                "description": "Serves 4 | Choose any 2 of your favorite veg medium pizzas. For Meals, refer to the nutritional data for individual products.",
                                "imageId": "2d34f1c2c669eab6821dd0ee068590e4",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344566",
                                      "name": "Choose 1st Pizza",
                                      "variations": [
                                        {
                                          "name": "Margherita",
                                          "price": 324.5,
                                          "default": 1,
                                          "id": "135514699",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Schezwan Margherita",
                                          "price": 324.5,
                                          "id": "135514702",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Corn & Cheese",
                                          "price": 324.5,
                                          "id": "135514707",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Veggie Feast",
                                          "price": 324.5,
                                          "id": "135514712",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Spiced Paneer",
                                          "price": 324.5,
                                          "id": "135514716",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Mexican Fiesta",
                                          "price": 374.5,
                                          "id": "135514721",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Bold BBQ Veggies",
                                          "price": 374.5,
                                          "id": "135514727",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 374.5,
                                          "id": "135514732",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Country Feast",
                                          "price": 374.5,
                                          "id": "135514736",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Tandoori Veggie",
                                          "price": 374.5,
                                          "id": "135514740",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Mazedar Makhni Paneer",
                                          "price": 374.5,
                                          "id": "135514743",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Awesome American Cheesy",
                                          "price": 374.5,
                                          "id": "135514745",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        },
                                        {
                                          "name": "Veggie Supreme",
                                          "price": 374.5,
                                          "id": "135514747",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344575",
                                            "variationId": "135514750"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344575",
                                      "name": "Choose 2nd Pizza",
                                      "variations": [
                                        {
                                          "name": "Margherita",
                                          "price": 324.5,
                                          "default": 1,
                                          "id": "135514750",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Schezwan Margherita",
                                          "price": 324.5,
                                          "id": "135514752",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Corn & Cheese",
                                          "price": 324.5,
                                          "id": "135514754",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Veggie Feast",
                                          "price": 324.5,
                                          "id": "135514756",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Spiced Paneer",
                                          "price": 324.5,
                                          "id": "135514759",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mexican Fiesta",
                                          "price": 374.5,
                                          "id": "135514761",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Bold BBQ Veggies",
                                          "price": 374.5,
                                          "id": "135514763",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 374.5,
                                          "id": "135514764",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Country Feast",
                                          "price": 374.5,
                                          "id": "135514765",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Ultimate Tandoori Veggie",
                                          "price": 374.5,
                                          "id": "135514766",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mazedar Makhni Paneer",
                                          "price": 374.5,
                                          "id": "135514767",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Awesome American Cheesy",
                                          "price": 374.5,
                                          "id": "135514768",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Veggie Supreme",
                                          "price": 374.5,
                                          "id": "135514769",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514699"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514702"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514707"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514712"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 64900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514716"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514721"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514727"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514732"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514736"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514740"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514743"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514745"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514750"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514752"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514754"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514756"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514759"
                                        }
                                      ],
                                      "price": 69900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514761"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514763"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514764"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514765"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514766"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514767"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514768"
                                        }
                                      ],
                                      "price": 74900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344566",
                                          "variationId": "135514747"
                                        },
                                        {
                                          "groupId": "42344575",
                                          "variationId": "135514769"
                                        }
                                      ],
                                      "price": 74900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 4"
                                },
                                "defaultPrice": 64900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Late Night Specials",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "133116142",
                                "name": "2 Medium Veg Pizzas @ 279 each",
                                "category": "Late Night Specials",
                                "description": "Serves 1 | Get 2 delicious veg medium pizzas of your choice & say goodbye to your midnight cravings. For Meals, refer to the nutritional data for individual products.",
                                "imageId": "2d34f1c2c669eab6821dd0ee068590e4",
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344618",
                                      "name": "Choose 1st Pizza",
                                      "variations": [
                                        {
                                          "name": "Margherita",
                                          "price": 279,
                                          "default": 1,
                                          "id": "135515094",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344621",
                                            "variationId": "135515120"
                                          }
                                        },
                                        {
                                          "name": "Schezwan Margherita",
                                          "price": 279,
                                          "id": "135515096",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344621",
                                            "variationId": "135515120"
                                          }
                                        },
                                        {
                                          "name": "Corn & Cheese",
                                          "price": 279,
                                          "id": "135515098",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344621",
                                            "variationId": "135515120"
                                          }
                                        },
                                        {
                                          "name": "Veggie Feast",
                                          "price": 279,
                                          "id": "135515099",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344621",
                                            "variationId": "135515120"
                                          }
                                        },
                                        {
                                          "name": "Spiced Paneer",
                                          "price": 279,
                                          "id": "135515101",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344621",
                                            "variationId": "135515120"
                                          }
                                        },
                                        {
                                          "name": "Mexican Fiesta",
                                          "price": 329,
                                          "id": "135515103",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344621",
                                            "variationId": "135515120"
                                          }
                                        },
                                        {
                                          "name": "Bold BBQ Veggies",
                                          "price": 329,
                                          "id": "135515105",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344621",
                                            "variationId": "135515120"
                                          }
                                        },
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 329,
                                          "id": "135515107",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344621",
                                            "variationId": "135515120"
                                          }
                                        },
                                        {
                                          "name": "Country Feast",
                                          "price": 329,
                                          "id": "135515109",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344621",
                                            "variationId": "135515120"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Tandoori Veggie",
                                          "price": 329,
                                          "id": "135515111",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344621",
                                            "variationId": "135515120"
                                          }
                                        },
                                        {
                                          "name": "Mazedar Makhni Paneer",
                                          "price": 329,
                                          "id": "135515112",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344621",
                                            "variationId": "135515120"
                                          }
                                        },
                                        {
                                          "name": "Awesome American Cheesy",
                                          "price": 329,
                                          "id": "135515115",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344621",
                                            "variationId": "135515120"
                                          }
                                        },
                                        {
                                          "name": "Veggie Supreme",
                                          "price": 329,
                                          "id": "135515116",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344621",
                                            "variationId": "135515120"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344621",
                                      "name": "Choose 2nd Pizza",
                                      "variations": [
                                        {
                                          "name": "Margherita",
                                          "price": 279,
                                          "default": 1,
                                          "id": "135515120",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Schezwan Margherita",
                                          "price": 279,
                                          "id": "135515123",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Corn & Cheese",
                                          "price": 279,
                                          "id": "135515128",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Veggie Feast",
                                          "price": 279,
                                          "id": "135515132",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Spiced Paneer",
                                          "price": 279,
                                          "id": "135515136",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mexican Fiesta",
                                          "price": 329,
                                          "id": "135515140",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Bold BBQ Veggies",
                                          "price": 329,
                                          "id": "135515142",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 329,
                                          "id": "135515143",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Country Feast",
                                          "price": 329,
                                          "id": "135515145",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Ultimate Tandoori Veggie",
                                          "price": 329,
                                          "id": "135515147",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mazedar Makhni Paneer",
                                          "price": 329,
                                          "id": "135515149",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Awesome American Cheesy",
                                          "price": 329,
                                          "id": "135515151",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Veggie Supreme",
                                          "price": 329,
                                          "id": "135515153",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515094"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515120"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515094"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515123"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515094"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515128"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515094"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515132"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515094"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515136"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515094"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515140"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515094"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515142"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515094"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515143"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515094"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515145"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515094"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515147"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515094"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515149"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515094"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515151"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515094"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515153"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515096"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515120"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515096"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515123"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515096"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515128"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515096"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515132"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515096"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515136"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515096"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515140"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515096"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515142"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515096"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515143"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515096"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515145"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515096"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515147"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515096"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515149"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515096"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515151"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515096"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515153"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515098"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515120"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515098"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515123"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515098"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515128"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515098"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515132"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515098"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515136"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515098"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515140"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515098"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515142"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515098"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515143"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515098"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515145"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515098"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515147"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515098"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515149"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515098"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515151"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515098"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515153"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515099"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515120"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515099"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515123"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515099"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515128"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515099"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515132"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515099"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515136"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515099"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515140"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515099"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515142"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515099"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515143"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515099"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515145"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515099"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515147"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515099"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515149"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515099"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515151"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515099"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515153"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515101"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515120"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515101"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515123"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515101"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515128"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515101"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515132"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515101"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515136"
                                        }
                                      ],
                                      "price": 55800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515101"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515140"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515101"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515142"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515101"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515143"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515101"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515145"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515101"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515147"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515101"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515149"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515101"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515151"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515101"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515153"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515103"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515120"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515103"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515123"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515103"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515128"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515103"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515132"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515103"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515136"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515103"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515140"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515103"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515142"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515103"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515143"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515103"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515145"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515103"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515147"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515103"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515149"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515103"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515151"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515103"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515153"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515105"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515120"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515105"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515123"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515105"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515128"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515105"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515132"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515105"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515136"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515105"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515140"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515105"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515142"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515105"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515143"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515105"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515145"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515105"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515147"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515105"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515149"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515105"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515151"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515105"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515153"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515107"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515120"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515107"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515123"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515107"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515128"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515107"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515132"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515107"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515136"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515107"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515140"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515107"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515142"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515107"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515143"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515107"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515145"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515107"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515147"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515107"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515149"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515107"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515151"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515107"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515153"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515109"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515120"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515109"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515123"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515109"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515128"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515109"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515132"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515109"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515136"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515109"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515140"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515109"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515142"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515109"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515143"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515109"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515145"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515109"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515147"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515109"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515149"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515109"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515151"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515109"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515153"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515111"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515120"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515111"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515123"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515111"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515128"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515111"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515132"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515111"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515136"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515111"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515140"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515111"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515142"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515111"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515143"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515111"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515145"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515111"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515147"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515111"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515149"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515111"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515151"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515111"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515153"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515112"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515120"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515112"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515123"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515112"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515128"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515112"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515132"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515112"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515136"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515112"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515140"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515112"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515142"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515112"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515143"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515112"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515145"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515112"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515147"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515112"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515149"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515112"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515151"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515112"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515153"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515115"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515120"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515115"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515123"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515115"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515128"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515115"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515132"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515115"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515136"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515115"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515140"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515115"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515142"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515115"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515143"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515115"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515145"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515115"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515147"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515115"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515149"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515115"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515151"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515115"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515153"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515116"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515120"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515116"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515123"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515116"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515128"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515116"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515132"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515116"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515136"
                                        }
                                      ],
                                      "price": 60800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515116"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515140"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515116"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515142"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515116"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515143"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515116"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515145"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515116"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515147"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515116"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515149"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515116"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515151"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344618",
                                          "variationId": "135515116"
                                        },
                                        {
                                          "groupId": "42344621",
                                          "variationId": "135515153"
                                        }
                                      ],
                                      "price": 65800
                                    }
                                  ]
                                },
                                "nextAvailableAtMessage": "Next available at 11 pm, today",
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 55800,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "133116141",
                                "name": "2 Personal Veg Pizzas @ 149 each",
                                "category": "Late Night Specials",
                                "description": "Serves 1 | Get 2 delicious personal Veg pizzas of your choice & satisfy those midnight cravings! For Meals, refer to the nutritional data for individual products.",
                                "imageId": "rw0irqot3gy3x66z2eyt",
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344602",
                                      "name": "Choose 1st Pizza",
                                      "variations": [
                                        {
                                          "name": "Margherita",
                                          "price": 149,
                                          "default": 1,
                                          "id": "135514963",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344605",
                                            "variationId": "135514996"
                                          }
                                        },
                                        {
                                          "name": "Schezwan Margherita",
                                          "price": 149,
                                          "id": "135514966",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344605",
                                            "variationId": "135514996"
                                          }
                                        },
                                        {
                                          "name": "Corn & Cheese",
                                          "price": 149,
                                          "id": "135514969",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344605",
                                            "variationId": "135514996"
                                          }
                                        },
                                        {
                                          "name": "Veggie Feast",
                                          "price": 149,
                                          "id": "135514974",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344605",
                                            "variationId": "135514996"
                                          }
                                        },
                                        {
                                          "name": "Spiced Paneer",
                                          "price": 149,
                                          "id": "135514978",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344605",
                                            "variationId": "135514996"
                                          }
                                        },
                                        {
                                          "name": "Mexican Fiesta",
                                          "price": 199,
                                          "id": "135514980",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344605",
                                            "variationId": "135514996"
                                          }
                                        },
                                        {
                                          "name": "Bold BBQ Veggies",
                                          "price": 199,
                                          "id": "135514982",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344605",
                                            "variationId": "135514996"
                                          }
                                        },
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 199,
                                          "id": "135514984",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344605",
                                            "variationId": "135514996"
                                          }
                                        },
                                        {
                                          "name": "Country Feast",
                                          "price": 199,
                                          "id": "135514986",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344605",
                                            "variationId": "135514996"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Tandoori Veggie",
                                          "price": 199,
                                          "id": "135514988",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344605",
                                            "variationId": "135514996"
                                          }
                                        },
                                        {
                                          "name": "Mazedar Makhni Paneer",
                                          "price": 199,
                                          "id": "135514989",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344605",
                                            "variationId": "135514996"
                                          }
                                        },
                                        {
                                          "name": "Awesome American Cheesy",
                                          "price": 199,
                                          "id": "135514991",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344605",
                                            "variationId": "135514996"
                                          }
                                        },
                                        {
                                          "name": "Veggie Supreme",
                                          "price": 199,
                                          "id": "135514993",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344605",
                                            "variationId": "135514996"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344605",
                                      "name": "Choose 2nd Pizza",
                                      "variations": [
                                        {
                                          "name": "Margherita",
                                          "price": 149,
                                          "default": 1,
                                          "id": "135514996",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Schezwan Margherita",
                                          "price": 149,
                                          "id": "135514997",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Corn & Cheese",
                                          "price": 149,
                                          "id": "135514999",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Veggie Feast",
                                          "price": 149,
                                          "id": "135515000",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Spiced Paneer",
                                          "price": 149,
                                          "id": "135515001",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mexican Fiesta",
                                          "price": 199,
                                          "id": "135515002",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Bold BBQ Veggies",
                                          "price": 199,
                                          "id": "135515003",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 199,
                                          "id": "135515004",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Country Feast",
                                          "price": 199,
                                          "id": "135515007",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Ultimate Tandoori Veggie",
                                          "price": 199,
                                          "id": "135515011",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mazedar Makhni Paneer",
                                          "price": 199,
                                          "id": "135515014",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Awesome American Cheesy",
                                          "price": 199,
                                          "id": "135515019",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Veggie Supreme",
                                          "price": 199,
                                          "id": "135515023",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514963"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514996"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514963"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514997"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514963"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514999"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514963"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515000"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514963"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515001"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514963"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515002"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514963"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515003"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514963"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515004"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514963"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515007"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514963"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515011"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514963"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515014"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514963"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515019"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514963"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515023"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514966"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514996"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514966"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514997"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514966"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514999"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514966"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515000"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514966"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515001"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514966"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515002"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514966"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515003"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514966"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515004"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514966"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515007"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514966"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515011"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514966"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515014"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514966"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515019"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514966"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515023"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514969"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514996"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514969"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514997"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514969"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514999"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514969"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515000"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514969"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515001"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514969"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515002"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514969"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515003"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514969"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515004"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514969"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515007"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514969"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515011"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514969"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515014"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514969"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515019"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514969"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515023"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514974"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514996"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514974"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514997"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514974"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514999"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514974"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515000"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514974"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515001"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514974"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515002"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514974"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515003"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514974"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515004"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514974"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515007"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514974"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515011"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514974"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515014"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514974"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515019"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514974"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515023"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514978"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514996"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514978"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514997"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514978"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514999"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514978"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515000"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514978"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515001"
                                        }
                                      ],
                                      "price": 29800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514978"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515002"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514978"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515003"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514978"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515004"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514978"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515007"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514978"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515011"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514978"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515014"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514978"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515019"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514978"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515023"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514980"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514996"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514980"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514997"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514980"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514999"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514980"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515000"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514980"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515001"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514980"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515002"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514980"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515003"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514980"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515004"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514980"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515007"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514980"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515011"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514980"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515014"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514980"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515019"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514980"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515023"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514982"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514996"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514982"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514997"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514982"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514999"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514982"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515000"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514982"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515001"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514982"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515002"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514982"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515003"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514982"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515004"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514982"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515007"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514982"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515011"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514982"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515014"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514982"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515019"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514982"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515023"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514984"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514996"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514984"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514997"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514984"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514999"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514984"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515000"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514984"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515001"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514984"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515002"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514984"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515003"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514984"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515004"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514984"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515007"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514984"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515011"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514984"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515014"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514984"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515019"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514984"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515023"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514986"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514996"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514986"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514997"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514986"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514999"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514986"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515000"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514986"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515001"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514986"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515002"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514986"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515003"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514986"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515004"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514986"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515007"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514986"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515011"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514986"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515014"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514986"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515019"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514986"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515023"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514988"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514996"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514988"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514997"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514988"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514999"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514988"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515000"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514988"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515001"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514988"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515002"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514988"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515003"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514988"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515004"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514988"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515007"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514988"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515011"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514988"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515014"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514988"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515019"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514988"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515023"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514989"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514996"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514989"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514997"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514989"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514999"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514989"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515000"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514989"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515001"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514989"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515002"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514989"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515003"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514989"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515004"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514989"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515007"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514989"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515011"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514989"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515014"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514989"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515019"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514989"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515023"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514991"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514996"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514991"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514997"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514991"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514999"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514991"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515000"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514991"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515001"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514991"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515002"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514991"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515003"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514991"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515004"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514991"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515007"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514991"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515011"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514991"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515014"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514991"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515019"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514991"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515023"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514993"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514996"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514993"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514997"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514993"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135514999"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514993"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515000"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514993"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515001"
                                        }
                                      ],
                                      "price": 34800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514993"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515002"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514993"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515003"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514993"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515004"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514993"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515007"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514993"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515011"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514993"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515014"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514993"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515019"
                                        }
                                      ],
                                      "price": 39800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344602",
                                          "variationId": "135514993"
                                        },
                                        {
                                          "groupId": "42344605",
                                          "variationId": "135515023"
                                        }
                                      ],
                                      "price": 39800
                                    }
                                  ]
                                },
                                "nextAvailableAtMessage": "Next available at 11 pm, today",
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 29800,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "133116145",
                                "name": "My Box @ Rs 199 - Non-Veg",
                                "category": "Late Night Specials",
                                "description": "Serves 1 | Any Non-Veg Pizza of your choice & 2 Pc of Exotica Veggie Garlic Bread. For Meals, refer to the nutritional data for individual products.",
                                "imageId": "615bbfc352c578cc5a7f348a4ce98a60",
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344671",
                                      "name": "Choose Your Pizza",
                                      "variations": [
                                        {
                                          "name": "Chicken Sausage",
                                          "price": 149,
                                          "default": 1,
                                          "id": "135515440",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344677",
                                            "variationId": "135515464"
                                          }
                                        },
                                        {
                                          "name": "Sausage & Sweet Corn",
                                          "price": 149,
                                          "id": "135515442",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344677",
                                            "variationId": "135515464"
                                          }
                                        },
                                        {
                                          "name": "Dhabe Da Keema",
                                          "price": 149,
                                          "id": "135515446",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344677",
                                            "variationId": "135515464"
                                          }
                                        },
                                        {
                                          "name": "Sizzling Schezwan Chicken",
                                          "price": 149,
                                          "id": "135515448",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344677",
                                            "variationId": "135515464"
                                          }
                                        },
                                        {
                                          "name": "Murg Malai Chicken",
                                          "price": 149,
                                          "id": "135515452",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344677",
                                            "variationId": "135515464"
                                          }
                                        },
                                        {
                                          "name": "Awesome American Cheesy Chicken",
                                          "price": 149,
                                          "id": "135515454",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344677",
                                            "variationId": "135515464"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka",
                                          "price": 149,
                                          "id": "135515455",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344677",
                                            "variationId": "135515464"
                                          }
                                        },
                                        {
                                          "name": "Chicken Pepperoni",
                                          "price": 149,
                                          "id": "135515457",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344677",
                                            "variationId": "135515464"
                                          }
                                        },
                                        {
                                          "name": "Nawabi Murg Makhni",
                                          "price": 149,
                                          "id": "135515459",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344677",
                                            "variationId": "135515464"
                                          }
                                        },
                                        {
                                          "name": "Chicken Supreme",
                                          "price": 149,
                                          "id": "135515460",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344677",
                                            "variationId": "135515464"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka Supreme",
                                          "price": 149,
                                          "id": "135515462",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344677",
                                            "variationId": "135515464"
                                          }
                                        },
                                        {
                                          "name": "Triple Chicken Feast",
                                          "price": 149,
                                          "id": "135515463",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344677",
                                            "variationId": "135515464"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344677",
                                      "name": "Choose your appetizer",
                                      "variations": [
                                        {
                                          "name": "2 Pc Exotica Veggie Garlic Bread",
                                          "price": 50,
                                          "default": 1,
                                          "id": "135515464",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344671",
                                          "variationId": "135515440"
                                        },
                                        {
                                          "groupId": "42344677",
                                          "variationId": "135515464"
                                        }
                                      ],
                                      "price": 19900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344671",
                                          "variationId": "135515442"
                                        },
                                        {
                                          "groupId": "42344677",
                                          "variationId": "135515464"
                                        }
                                      ],
                                      "price": 19900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344671",
                                          "variationId": "135515446"
                                        },
                                        {
                                          "groupId": "42344677",
                                          "variationId": "135515464"
                                        }
                                      ],
                                      "price": 19900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344671",
                                          "variationId": "135515448"
                                        },
                                        {
                                          "groupId": "42344677",
                                          "variationId": "135515464"
                                        }
                                      ],
                                      "price": 19900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344671",
                                          "variationId": "135515452"
                                        },
                                        {
                                          "groupId": "42344677",
                                          "variationId": "135515464"
                                        }
                                      ],
                                      "price": 19900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344671",
                                          "variationId": "135515454"
                                        },
                                        {
                                          "groupId": "42344677",
                                          "variationId": "135515464"
                                        }
                                      ],
                                      "price": 19900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344671",
                                          "variationId": "135515455"
                                        },
                                        {
                                          "groupId": "42344677",
                                          "variationId": "135515464"
                                        }
                                      ],
                                      "price": 19900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344671",
                                          "variationId": "135515457"
                                        },
                                        {
                                          "groupId": "42344677",
                                          "variationId": "135515464"
                                        }
                                      ],
                                      "price": 19900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344671",
                                          "variationId": "135515459"
                                        },
                                        {
                                          "groupId": "42344677",
                                          "variationId": "135515464"
                                        }
                                      ],
                                      "price": 19900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344671",
                                          "variationId": "135515460"
                                        },
                                        {
                                          "groupId": "42344677",
                                          "variationId": "135515464"
                                        }
                                      ],
                                      "price": 19900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344671",
                                          "variationId": "135515462"
                                        },
                                        {
                                          "groupId": "42344677",
                                          "variationId": "135515464"
                                        }
                                      ],
                                      "price": 19900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344671",
                                          "variationId": "135515463"
                                        },
                                        {
                                          "groupId": "42344677",
                                          "variationId": "135515464"
                                        }
                                      ],
                                      "price": 19900
                                    }
                                  ]
                                },
                                "nextAvailableAtMessage": "Next available at 11 pm, today",
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "133116144",
                                "name": "My Box @ Rs 179 - Veg",
                                "category": "Late Night Specials",
                                "description": "Serves 1 | Any Veg Pizza of your choice & 2 Pc of Exotica Veggie Garlic Bread. For Meals, refer to the nutritional data for individual products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/12/0ae0003e-b596-4885-8fc7-ade1a7a251f3_9b5eb5ac-e685-40f4-b19e-45e1c782804a.png_compressed",
                                "isVeg": 1,
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344655",
                                      "name": "Choose Your Pizza",
                                      "variations": [
                                        {
                                          "name": "Margherita",
                                          "price": 129,
                                          "default": 1,
                                          "id": "135515326",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344663",
                                            "variationId": "135515371"
                                          }
                                        },
                                        {
                                          "name": "Schezwan Margherita",
                                          "price": 129,
                                          "id": "135515329",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344663",
                                            "variationId": "135515371"
                                          }
                                        },
                                        {
                                          "name": "Corn & Cheese",
                                          "price": 129,
                                          "id": "135515331",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344663",
                                            "variationId": "135515371"
                                          }
                                        },
                                        {
                                          "name": "Veggie Feast",
                                          "price": 129,
                                          "id": "135515334",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344663",
                                            "variationId": "135515371"
                                          }
                                        },
                                        {
                                          "name": "Spiced Paneer",
                                          "price": 129,
                                          "id": "135515337",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344663",
                                            "variationId": "135515371"
                                          }
                                        },
                                        {
                                          "name": "Mexican Fiesta",
                                          "price": 129,
                                          "id": "135515340",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344663",
                                            "variationId": "135515371"
                                          }
                                        },
                                        {
                                          "name": "Bold BBQ Veggies",
                                          "price": 129,
                                          "id": "135515343",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344663",
                                            "variationId": "135515371"
                                          }
                                        },
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 129,
                                          "id": "135515345",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344663",
                                            "variationId": "135515371"
                                          }
                                        },
                                        {
                                          "name": "Country Feast",
                                          "price": 129,
                                          "id": "135515347",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344663",
                                            "variationId": "135515371"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Tandoori Veggie",
                                          "price": 129,
                                          "id": "135515351",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344663",
                                            "variationId": "135515371"
                                          }
                                        },
                                        {
                                          "name": "Mazedar Makhni Paneer",
                                          "price": 129,
                                          "id": "135515355",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344663",
                                            "variationId": "135515371"
                                          }
                                        },
                                        {
                                          "name": "Awesome American Cheesy",
                                          "price": 129,
                                          "id": "135515357",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344663",
                                            "variationId": "135515371"
                                          }
                                        },
                                        {
                                          "name": "Veggie Supreme",
                                          "price": 129,
                                          "id": "135515361",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344663",
                                            "variationId": "135515371"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344663",
                                      "name": "Choose your appetizer",
                                      "variations": [
                                        {
                                          "name": "2 Pc Exotica Veggie Garlic Bread",
                                          "price": 50,
                                          "default": 1,
                                          "id": "135515371",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344655",
                                          "variationId": "135515326"
                                        },
                                        {
                                          "groupId": "42344663",
                                          "variationId": "135515371"
                                        }
                                      ],
                                      "price": 17900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344655",
                                          "variationId": "135515329"
                                        },
                                        {
                                          "groupId": "42344663",
                                          "variationId": "135515371"
                                        }
                                      ],
                                      "price": 17900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344655",
                                          "variationId": "135515331"
                                        },
                                        {
                                          "groupId": "42344663",
                                          "variationId": "135515371"
                                        }
                                      ],
                                      "price": 17900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344655",
                                          "variationId": "135515334"
                                        },
                                        {
                                          "groupId": "42344663",
                                          "variationId": "135515371"
                                        }
                                      ],
                                      "price": 17900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344655",
                                          "variationId": "135515337"
                                        },
                                        {
                                          "groupId": "42344663",
                                          "variationId": "135515371"
                                        }
                                      ],
                                      "price": 17900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344655",
                                          "variationId": "135515340"
                                        },
                                        {
                                          "groupId": "42344663",
                                          "variationId": "135515371"
                                        }
                                      ],
                                      "price": 17900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344655",
                                          "variationId": "135515343"
                                        },
                                        {
                                          "groupId": "42344663",
                                          "variationId": "135515371"
                                        }
                                      ],
                                      "price": 17900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344655",
                                          "variationId": "135515345"
                                        },
                                        {
                                          "groupId": "42344663",
                                          "variationId": "135515371"
                                        }
                                      ],
                                      "price": 17900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344655",
                                          "variationId": "135515347"
                                        },
                                        {
                                          "groupId": "42344663",
                                          "variationId": "135515371"
                                        }
                                      ],
                                      "price": 17900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344655",
                                          "variationId": "135515351"
                                        },
                                        {
                                          "groupId": "42344663",
                                          "variationId": "135515371"
                                        }
                                      ],
                                      "price": 17900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344655",
                                          "variationId": "135515355"
                                        },
                                        {
                                          "groupId": "42344663",
                                          "variationId": "135515371"
                                        }
                                      ],
                                      "price": 17900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344655",
                                          "variationId": "135515357"
                                        },
                                        {
                                          "groupId": "42344663",
                                          "variationId": "135515371"
                                        }
                                      ],
                                      "price": 17900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344655",
                                          "variationId": "135515361"
                                        },
                                        {
                                          "groupId": "42344663",
                                          "variationId": "135515371"
                                        }
                                      ],
                                      "price": 17900
                                    }
                                  ]
                                },
                                "nextAvailableAtMessage": "Next available at 11 pm, today",
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "133116140",
                                "name": "2 Personal Non-Veg Pizzas @ Rs 179 each",
                                "category": "Late Night Specials",
                                "description": "Serves 1 | Get 2 delicious personal Non-Veg pizzas of your choice & satisfy those midnight cravings! For Meals, refer to the nutritional data for individual products.",
                                "imageId": "b55utd4ludogin1ftnhh",
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344584",
                                      "name": "Choose 1st Pizza",
                                      "variations": [
                                        {
                                          "name": "Chicken Sausage",
                                          "price": 179,
                                          "id": "135514836",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344586",
                                            "variationId": "135514860"
                                          }
                                        },
                                        {
                                          "name": "Sausage & Sweet Corn",
                                          "price": 174.5,
                                          "default": 1,
                                          "id": "135514839",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344586",
                                            "variationId": "135514860"
                                          }
                                        },
                                        {
                                          "name": "Dhabe Da Keema",
                                          "price": 174.5,
                                          "id": "135514842",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344586",
                                            "variationId": "135514860"
                                          }
                                        },
                                        {
                                          "name": "Sizzling Schezwan Chicken",
                                          "price": 174.5,
                                          "id": "135514844",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344586",
                                            "variationId": "135514860"
                                          }
                                        },
                                        {
                                          "name": "Murg Malai Chicken",
                                          "price": 224.5,
                                          "id": "135514845",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344586",
                                            "variationId": "135514860"
                                          }
                                        },
                                        {
                                          "name": "Awesome American Cheesy Chicken",
                                          "price": 224.5,
                                          "id": "135514847",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344586",
                                            "variationId": "135514860"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka",
                                          "price": 224.5,
                                          "id": "135514849",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344586",
                                            "variationId": "135514860"
                                          }
                                        },
                                        {
                                          "name": "Chicken Pepperoni",
                                          "price": 224.5,
                                          "id": "135514851",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344586",
                                            "variationId": "135514860"
                                          }
                                        },
                                        {
                                          "name": "Nawabi Murg Makhni",
                                          "price": 224.5,
                                          "id": "135514853",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344586",
                                            "variationId": "135514860"
                                          }
                                        },
                                        {
                                          "name": "Chicken Supreme",
                                          "price": 224.5,
                                          "id": "135514855",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344586",
                                            "variationId": "135514860"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka Supreme",
                                          "price": 224.5,
                                          "id": "135514856",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344586",
                                            "variationId": "135514860"
                                          }
                                        },
                                        {
                                          "name": "Triple Chicken Feast",
                                          "price": 224.5,
                                          "id": "135514858",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344586",
                                            "variationId": "135514860"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344586",
                                      "name": "Choose 2nd Pizza",
                                      "variations": [
                                        {
                                          "name": "Chicken Sausage",
                                          "price": 174.5,
                                          "default": 1,
                                          "id": "135514860",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Sausage & Sweet Corn",
                                          "price": 174.5,
                                          "id": "135514861",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Dhabe Da Keema",
                                          "price": 174.5,
                                          "id": "135514862",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Sizzling Schezwan Chicken",
                                          "price": 174.5,
                                          "id": "135514863",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Murg Malai Chicken",
                                          "price": 224.5,
                                          "id": "135514864",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Awesome American Cheesy Chicken",
                                          "price": 224.5,
                                          "id": "135514865",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Tikka",
                                          "price": 224.5,
                                          "id": "135514866",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Pepperoni",
                                          "price": 224.5,
                                          "id": "135514867",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Nawabi Murg Makhni",
                                          "price": 224.5,
                                          "id": "135514868",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Supreme",
                                          "price": 224.5,
                                          "id": "135514869",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Tikka Supreme",
                                          "price": 224.5,
                                          "id": "135514870",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Triple Chicken Feast",
                                          "price": 224.5,
                                          "id": "135514871",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514836"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514860"
                                        }
                                      ],
                                      "price": 35350
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514836"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514861"
                                        }
                                      ],
                                      "price": 35350
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514836"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514862"
                                        }
                                      ],
                                      "price": 35350
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514836"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514863"
                                        }
                                      ],
                                      "price": 35350
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514836"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514864"
                                        }
                                      ],
                                      "price": 40350
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514836"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514865"
                                        }
                                      ],
                                      "price": 40350
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514836"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514866"
                                        }
                                      ],
                                      "price": 40350
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514836"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514867"
                                        }
                                      ],
                                      "price": 40350
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514836"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514868"
                                        }
                                      ],
                                      "price": 40350
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514836"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514869"
                                        }
                                      ],
                                      "price": 40350
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514836"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514870"
                                        }
                                      ],
                                      "price": 40350
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514836"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514871"
                                        }
                                      ],
                                      "price": 40350
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514839"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514860"
                                        }
                                      ],
                                      "price": 34900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514839"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514861"
                                        }
                                      ],
                                      "price": 34900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514839"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514862"
                                        }
                                      ],
                                      "price": 34900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514839"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514863"
                                        }
                                      ],
                                      "price": 34900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514839"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514864"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514839"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514865"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514839"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514866"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514839"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514867"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514839"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514868"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514839"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514869"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514839"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514870"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514839"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514871"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514842"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514860"
                                        }
                                      ],
                                      "price": 34900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514842"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514861"
                                        }
                                      ],
                                      "price": 34900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514842"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514862"
                                        }
                                      ],
                                      "price": 34900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514842"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514863"
                                        }
                                      ],
                                      "price": 34900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514842"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514864"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514842"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514865"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514842"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514866"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514842"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514867"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514842"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514868"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514842"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514869"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514842"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514870"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514842"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514871"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514844"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514860"
                                        }
                                      ],
                                      "price": 34900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514844"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514861"
                                        }
                                      ],
                                      "price": 34900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514844"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514862"
                                        }
                                      ],
                                      "price": 34900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514844"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514863"
                                        }
                                      ],
                                      "price": 34900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514844"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514864"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514844"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514865"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514844"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514866"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514844"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514867"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514844"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514868"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514844"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514869"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514844"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514870"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514844"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514871"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514845"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514860"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514845"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514861"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514845"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514862"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514845"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514863"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514845"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514864"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514845"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514865"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514845"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514866"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514845"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514867"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514845"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514868"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514845"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514869"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514845"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514870"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514845"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514871"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514847"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514860"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514847"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514861"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514847"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514862"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514847"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514863"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514847"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514864"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514847"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514865"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514847"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514866"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514847"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514867"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514847"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514868"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514847"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514869"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514847"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514870"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514847"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514871"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514849"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514860"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514849"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514861"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514849"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514862"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514849"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514863"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514849"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514864"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514849"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514865"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514849"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514866"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514849"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514867"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514849"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514868"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514849"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514869"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514849"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514870"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514849"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514871"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514851"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514860"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514851"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514861"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514851"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514862"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514851"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514863"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514851"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514864"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514851"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514865"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514851"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514866"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514851"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514867"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514851"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514868"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514851"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514869"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514851"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514870"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514851"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514871"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514853"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514860"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514853"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514861"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514853"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514862"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514853"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514863"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514853"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514864"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514853"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514865"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514853"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514866"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514853"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514867"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514853"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514868"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514853"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514869"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514853"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514870"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514853"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514871"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514855"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514860"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514855"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514861"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514855"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514862"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514855"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514863"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514855"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514864"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514855"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514865"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514855"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514866"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514855"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514867"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514855"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514868"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514855"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514869"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514855"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514870"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514855"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514871"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514856"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514860"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514856"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514861"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514856"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514862"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514856"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514863"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514856"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514864"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514856"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514865"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514856"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514866"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514856"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514867"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514856"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514868"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514856"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514869"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514856"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514870"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514856"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514871"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514858"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514860"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514858"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514861"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514858"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514862"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514858"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514863"
                                        }
                                      ],
                                      "price": 39900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514858"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514864"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514858"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514865"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514858"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514866"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514858"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514867"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514858"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514868"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514858"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514869"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514858"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514870"
                                        }
                                      ],
                                      "price": 44900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344584",
                                          "variationId": "135514858"
                                        },
                                        {
                                          "groupId": "42344586",
                                          "variationId": "135514871"
                                        }
                                      ],
                                      "price": 44900
                                    }
                                  ]
                                },
                                "nextAvailableAtMessage": "Next available at 11 pm, today",
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 34900,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "133116143",
                                "name": "2 Medium Non-Veg Pizzas @ 329 each",
                                "category": "Late Night Specials",
                                "description": "Serves 1 | Get 2 delicious non-veg medium pizzas of your choice & say goodbye to your midnight cravings. For Meals, refer to the nutritional data for individual products.",
                                "imageId": "6110f28b77f670194674bbf318970656",
                                "variants": {
                                  
                                },
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42344635",
                                      "name": "Choose 1st Pizza",
                                      "variations": [
                                        {
                                          "name": "Chicken Sausage",
                                          "price": 329,
                                          "default": 1,
                                          "id": "135515200",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344640",
                                            "variationId": "135515238"
                                          }
                                        },
                                        {
                                          "name": "Sausage & Sweet Corn",
                                          "price": 329,
                                          "id": "135515201",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344640",
                                            "variationId": "135515238"
                                          }
                                        },
                                        {
                                          "name": "Dhabe Da Keema",
                                          "price": 329,
                                          "id": "135515202",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344640",
                                            "variationId": "135515238"
                                          }
                                        },
                                        {
                                          "name": "Sizzling Schezwan Chicken",
                                          "price": 329,
                                          "id": "135515204",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344640",
                                            "variationId": "135515238"
                                          }
                                        },
                                        {
                                          "name": "Murg Malai Chicken",
                                          "price": 379,
                                          "id": "135515206",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344640",
                                            "variationId": "135515238"
                                          }
                                        },
                                        {
                                          "name": "Awesome American Cheesy Chicken",
                                          "price": 379,
                                          "id": "135515207",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344640",
                                            "variationId": "135515238"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka",
                                          "price": 379,
                                          "id": "135515210",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344640",
                                            "variationId": "135515238"
                                          }
                                        },
                                        {
                                          "name": "Chicken Pepperoni",
                                          "price": 379,
                                          "id": "135515213",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344640",
                                            "variationId": "135515238"
                                          }
                                        },
                                        {
                                          "name": "Nawabi Murg Makhni",
                                          "price": 379,
                                          "id": "135515216",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344640",
                                            "variationId": "135515238"
                                          }
                                        },
                                        {
                                          "name": "Chicken Supreme",
                                          "price": 379,
                                          "id": "135515219",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344640",
                                            "variationId": "135515238"
                                          }
                                        },
                                        {
                                          "name": "Chicken Tikka Supreme",
                                          "price": 379,
                                          "id": "135515224",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344640",
                                            "variationId": "135515238"
                                          }
                                        },
                                        {
                                          "name": "Triple Chicken Feast",
                                          "price": 379,
                                          "id": "135515229",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42344640",
                                            "variationId": "135515238"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42344640",
                                      "name": "Choose 2nd Pizza",
                                      "variations": [
                                        {
                                          "name": "Chicken Sausage",
                                          "price": 329,
                                          "default": 1,
                                          "id": "135515238",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Sausage & Sweet Corn",
                                          "price": 329,
                                          "id": "135515243",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Dhabe Da Keema",
                                          "price": 329,
                                          "id": "135515248",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Sizzling Schezwan Chicken",
                                          "price": 329,
                                          "id": "135515251",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Murg Malai Chicken",
                                          "price": 379,
                                          "id": "135515254",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Awesome American Cheesy Chicken",
                                          "price": 379,
                                          "id": "135515257",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Tikka",
                                          "price": 379,
                                          "id": "135515260",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Pepperoni",
                                          "price": 379,
                                          "id": "135515261",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Nawabi Murg Makhni",
                                          "price": 379,
                                          "id": "135515264",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Supreme",
                                          "price": 379,
                                          "id": "135515266",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Chicken Tikka Supreme",
                                          "price": 379,
                                          "id": "135515268",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Triple Chicken Feast",
                                          "price": 379,
                                          "id": "135515270",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515200"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515238"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515200"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515243"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515200"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515248"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515200"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515251"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515200"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515254"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515200"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515257"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515200"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515260"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515200"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515261"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515200"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515264"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515200"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515266"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515200"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515268"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515200"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515270"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515201"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515238"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515201"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515243"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515201"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515248"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515201"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515251"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515201"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515254"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515201"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515257"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515201"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515260"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515201"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515261"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515201"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515264"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515201"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515266"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515201"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515268"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515201"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515270"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515202"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515238"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515202"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515243"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515202"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515248"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515202"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515251"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515202"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515254"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515202"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515257"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515202"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515260"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515202"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515261"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515202"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515264"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515202"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515266"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515202"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515268"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515202"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515270"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515204"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515238"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515204"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515243"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515204"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515248"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515204"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515251"
                                        }
                                      ],
                                      "price": 65800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515204"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515254"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515204"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515257"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515204"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515260"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515204"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515261"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515204"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515264"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515204"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515266"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515204"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515268"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515204"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515270"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515206"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515238"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515206"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515243"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515206"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515248"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515206"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515251"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515206"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515254"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515206"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515257"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515206"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515260"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515206"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515261"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515206"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515264"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515206"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515266"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515206"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515268"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515206"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515270"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515207"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515238"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515207"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515243"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515207"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515248"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515207"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515251"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515207"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515254"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515207"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515257"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515207"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515260"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515207"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515261"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515207"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515264"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515207"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515266"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515207"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515268"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515207"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515270"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515210"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515238"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515210"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515243"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515210"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515248"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515210"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515251"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515210"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515254"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515210"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515257"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515210"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515260"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515210"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515261"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515210"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515264"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515210"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515266"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515210"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515268"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515210"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515270"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515213"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515238"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515213"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515243"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515213"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515248"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515213"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515251"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515213"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515254"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515213"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515257"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515213"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515260"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515213"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515261"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515213"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515264"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515213"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515266"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515213"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515268"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515213"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515270"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515216"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515238"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515216"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515243"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515216"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515248"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515216"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515251"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515216"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515254"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515216"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515257"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515216"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515260"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515216"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515261"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515216"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515264"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515216"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515266"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515216"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515268"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515216"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515270"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515219"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515238"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515219"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515243"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515219"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515248"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515219"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515251"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515219"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515254"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515219"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515257"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515219"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515260"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515219"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515261"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515219"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515264"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515219"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515266"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515219"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515268"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515219"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515270"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515224"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515238"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515224"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515243"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515224"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515248"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515224"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515251"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515224"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515254"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515224"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515257"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515224"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515260"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515224"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515261"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515224"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515264"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515224"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515266"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515224"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515268"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515224"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515270"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515229"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515238"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515229"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515243"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515229"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515248"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515229"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515251"
                                        }
                                      ],
                                      "price": 70800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515229"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515254"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515229"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515257"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515229"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515260"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515229"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515261"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515229"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515264"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515229"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515266"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515229"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515268"
                                        }
                                      ],
                                      "price": 75800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42344635",
                                          "variationId": "135515229"
                                        },
                                        {
                                          "groupId": "42344640",
                                          "variationId": "135515270"
                                        }
                                      ],
                                      "price": 75800
                                    }
                                  ]
                                },
                                "nextAvailableAtMessage": "Next available at 11 pm, today",
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 65800,
                                "ribbon": {
                                  
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "30% OFF",
                                    "subTitle": "USE TRYNEW",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3"
                                  }
                                ],
                                "itemBadge": {
                                  
                                },
                                "badgesV2": {
                                  
                                },
                                "ratings": {
                                  "aggregatedRating": {
                                    
                                  }
                                }
                              },
                              "analytics": {
                                
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                        "type": "FSSAI",
                        "imageId": "fssai_final_edss9i",
                        "text": [
                          "License No. 10020022011450"
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                        "name": "Pizza Hut",
                        "area": "Triplicane",
                        "completeAddress": "Old No - 57-62, New No -111, First Floor, Wallajah Road, Anna Salai, Chennai, Tamilnadu - 600002"
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      ],
      "firstOffsetRequest": true,
      "isQCLink": false
    },
    "tid": "14bcccd1-cdcf-4a08-91c8-977f61adfbfe",
    "sid": "dv6e2f9e-7d3f-4cf4-8859-6b66bca4e526",
    "deviceId": "e4466909-d139-ec90-fb1a-adde4ac70f80",
    "csrfToken": null
  }